import type { Dict } from '../types';

export const ru: Dict = {
  'chat.amrCard.switchTitle': 'Не удалось вызвать модель — это выполнение приостановлено',
  'chat.amrCard.switchBody': 'Переключитесь на официальный сервис моделей AMR от Open Design — без настройки API-ключа. После входа, авторизации и пополнения это выполнение будет автоматически повторено.',
  'chat.amrCard.chipOfficial': 'Официальный хостинг',
  'chat.amrCard.chipNoKey': 'Без API-ключа',
  'chat.amrCard.chipAutoRetry': 'Авто-повтор после входа',
  'chat.amrCard.switchCta': 'Переключиться на AMR и повторить',
  'chat.amrError.authMessage': 'Ваш аккаунт AMR ещё не авторизован. Авторизуйте его, и это выполнение будет автоматически повторено.',
  'chat.amrError.balanceMessage': 'Баланс AMR исчерпан. Пополните, чтобы продолжить это выполнение.',
  'chat.amrError.authorizeCta': 'Авторизовать и повторить',
  'chat.amrError.rechargeCta': 'Пополнить AMR',
  'chat.antigravityError.launchTerminalCta': 'Войти через терминал',
  'chat.antigravityError.launchSwitchModelCta': 'Сменить модель в терминале',
  'chat.connectionDropped': 'Соединение с сервисом модели прервалось до завершения ответа — обычно из-за нестабильной сети или прокси. Повторите попытку.',
  'common.cancel': 'Отмена',
  'common.save': 'Сохранить',
  'common.close': 'Закрыть',
  'common.clear': 'Очистить',
  'common.delete': 'Удалить',
  'common.rename': 'Переименовать',
  'common.edit': 'Редактировать',
  'common.preview': 'Предпросмотр',
  'common.share': 'Поделиться',
  'common.search': 'Поиск',
  'common.searchEllipsis': 'Поиск…',
  'common.loading': 'Загрузка…',
  'common.all': 'Все',
  'common.none': 'Нет',
  'common.default': 'По умолчанию',
  'common.installed': 'установлено',
  'common.notInstalled': 'не установлено',
  'common.active': 'активно',
  'common.offline': 'офлайн',
  'common.selected': 'выбрано',
  'common.create': 'Создать',
  'common.openPreview': 'Открыть предпросмотр',
  'common.exitFullscreen': 'Выйти из полноэкранного режима',
  'common.fullscreen': 'Полноэкранный режим',
  'common.openInNewTab': 'Открыть в новой вкладке',
  'common.exportPdf': 'Экспорт в PDF',
  'common.exportZip': 'Скачать как .zip',
  'common.exportHtml': 'Экспорт как HTML',
  'common.exportImage': 'Экспорт как изображение',
  'common.exportImageFailed': 'Не удалось захватить изображение. Попробуйте еще раз или воспользуйтесь инструментом создания снимков экрана в браузере.',
  'common.justNow': 'только что',
  'common.minutesAgo': '{n} мин. назад',
  'common.hoursAgo': '{n} ч. назад',
  'common.daysAgo': '{n} д. назад',
  'common.weeksAgo': '{n} нед. назад',
  'common.now': 'сейчас',
  'common.minutesShort': '{n}м',
  'common.hoursShort': '{n}ч',
  'common.daysShort': '{n}д',
  'common.untitled': 'Без названия',
  'plugins.availableDetails.provenance': 'Происхождение',
  'plugins.availableDetails.provenanceLine': 'из {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'из {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Установить',
  'plugins.availableDetails.version': 'Версия',
  'plugins.availableDetails.pluginVersion': 'Версия плагина',
  'plugins.availableDetails.copyInstallCommand': 'Скопировать команду установки',
  'plugins.availableDetails.copied': 'Скопировано',
  'plugins.availableDetails.deprecatedPrefix': 'Устарело: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Эта версия помечена как устаревшая.',
  'plugins.availableDetails.yanked': 'Отозвано.',
  'plugins.availableDetails.yankedWithReason': 'Отозвано: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (устарело)',
  'plugins.availableDetails.versionYankedSuffix': ' (отозвано)',
  'plugins.availableDetails.ref': 'Ссылка',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Разрешения',
  'plugins.availableDetails.capabilitySummary': 'Сводка возможностей',
  'plugins.actions.copyInstallCommand': 'Скопировать команду установки',
  'plugins.actions.copyPluginId': 'Скопировать ID плагина',
  'plugins.actions.copyReadmeBadge': 'Скопировать бейдж README',
  'plugins.actions.openSourceGithub': 'Открыть исходники на GitHub',
  'plugins.actions.openSource': 'Открыть исходники',
  'plugins.actions.openHomepage': 'Открыть домашнюю страницу',
  'plugins.actions.openMarketplace': 'Открыть в маркетплейсе',
  'app.brand': 'Open Design',
  'app.brandPill': 'Предварительная исследовательская версия',
  'app.brandSubtitle': 'от Nexu Labs',
  'app.welcomeLoading': 'Загрузка рабочего пространства…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Добро пожаловать',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Начать с краткого описания',
  'settings.onboardingCreateBody': 'Опишите сайт, приложение, презентацию, изображение или видео, которое вам нужно. Open Design создаст проект и сохранит возможность редактирования работы.',
  'settings.onboardingMemoryTitle': 'Сохранить рабочий контекст',
  'settings.onboardingMemoryBody': 'Добавьте предпочтения, факты о проекте и повторяющиеся правила, чтобы будущие чаты учитывали нужный контекст.',
  'settings.onboardingSystemsTitle': 'Подключите свою дизайн-систему',
  'settings.onboardingSystemsBody': 'Выберите или создайте бренд-систему, чтобы сгенерированные работы соответствовали реальным цветам, типографике и языку продукта.',
  'settings.onboardingExecutionTitle': 'Выберите способ генерации',
  'settings.onboardingExecutionBody': 'Официальный CLI с настройкой в один клик и готовыми параметрами по умолчанию. Используйте один ключ для выбора из множества моделей по более выгодным ценам.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Официально рекомендовано',
  'settings.onboardingAmrCloudBenefitReady': 'Без развертывания',
  'settings.onboardingAmrCloudBenefitModels': 'Поддерживает Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'Скоро',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Изображения и видео',
  'settings.onboardingAmrCloudUpcomingSkills': 'Много Skills',
  'settings.onboardingAmrCloudUpcomingRouting': 'Умная маршрутизация',
  'settings.onboardingAmrModelSourceLabel': 'AMR CLI',
  'settings.onboardingAmrCloudAuthorizeAction': 'Авторизовать AMR',
  'settings.onboardingAmrCloudAuthorizedAction': 'Авторизовано',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Design system',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Будьте в курсе',
  'settings.onboardingNewsletterTitle': 'Оставайтесь в курсе',
  'settings.onboardingNewsletterBody': 'Получайте новости продукта, новые шаблоны, дизайн-системы и работу амбассадоров на почту. Необязательно — можно пропустить.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'Официальный',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'About you',
  'settings.onboardingProfileBody': 'Optional details for better defaults.',
  'settings.onboardingRoleLabel': 'Your role',
  'settings.onboardingOrgSizeLabel': 'Organization size',
  'settings.onboardingUseCaseLabel': 'Use case',
  'settings.onboardingSourceLabel': 'Where did you hear about us?',
  'settings.onboardingSelectPlaceholder': 'Select one',
  'settings.onboardingSelectMultiplePlaceholder': 'Select one or more',
  'settings.onboardingOrgSolo': 'Solo / personal (1)',
  'settings.onboardingOrgTeam': 'Small team (2-10)',
  'settings.onboardingOrgStartup': 'Startup / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'Growth company (51-200)',
  'settings.onboardingOrgMidMarket': 'Mid-market (201-1000)',
  'settings.onboardingOrgEnterprise': 'Enterprise (1000+)',
  'settings.onboardingRolePm': '📋 Product manager',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Engineer',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleGrowth': '📈 Growth',
  'settings.onboardingRoleOps': '⚙️ Operations',
  'settings.onboardingRoleFounder': '🚀 Founder / executive',
  'settings.onboardingRoleStudent': '🎓 Student / educator',
  'settings.onboardingRoleOther': '✨ Other',
  'settings.onboardingUseProduct': '🎨 Product design',
  'settings.onboardingUseDesignSystem': '🧩 Design system',
  'settings.onboardingUsePrototype': '📱 Prototype / app UI',
  'settings.onboardingUseLanding': '🌐 Landing pages',
  'settings.onboardingUseAds': '📣 Ads / social content',
  'settings.onboardingUseDashboard': '📊 Dashboards / internal tools',
  'settings.onboardingUseDeck': '🖥️ Presentation / deck',
  'settings.onboardingUseMarketing': '📈 Marketing / growth',
  'settings.onboardingUseEngineering': '🤝 Engineering handoff',
  'settings.onboardingUseAgency': '💼 Agency / client work',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceFriend': '👥 Friend or coworker',
  'settings.onboardingSourceSocial': '📱 Social media',
  'settings.onboardingSourceProductHunt': '🅿️ Product Hunt',
  'settings.onboardingSourceCommunity': '💬 Design / AI community',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceBlog': '📰 Blog or newsletter',
  'settings.onboardingSourceAiTool': '✨ AI tool recommendation',
  'settings.onboardingSourceSearch': '🔍 Search',
  'settings.onboardingSourceEvent': '🎤 Event or community',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.onboardingSkip': 'Skip for now',
  'settings.kicker': 'Настройки',
  'settings.title': 'Режим выполнения',
  'settings.subtitle': 'Выберите локальный CLI или BYOK.',
  'settings.modeAria': 'Режим выполнения',
  'settings.protocolAria': 'Протокол API',
  'settings.modeDaemon': 'Локальный CLI',
  'settings.modeDaemonHelp': 'Запуск через CLI код-агента на вашем компьютере',
  'settings.modeDaemonOffline': 'Демон не запущен',
  'settings.modeDaemonOfflineMeta': 'демон офлайн',
  'settings.modeDaemonInstalledMeta': '{count} установлено',
  'settings.modeApi': 'API-провайдер',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'BYOK не может читать, записывать или редактировать файлы проекта. Используйте Local CLI, когда нужны изменения в коде.',
  'settings.codeAgent': 'Код-агент',
  'settings.codeAgentHint': 'Определяется сканированием вашего PATH. Выберите CLI, через который будут проходить генерации.',
  'settings.rescan': '↻ Пересканировать',
  'settings.rescanTitle': 'Пересканировать PATH',
  'settings.rescanRunning': 'Сканирование...',
  'settings.rescanSuccess': 'Сканирование завершено. Доступно: {count}.',
  'settings.designSystemRenameFailed': 'Не удалось переименовать. Проверьте демон и повторите попытку.',
  'settings.rescanFailed': 'Сканирование не удалось. Проверьте демон и повторите попытку.',
  'settings.test': 'Тест',
  'settings.testTitle': 'Отправить крошечный тестовый запрос для проверки соединения',
  'settings.testRunning': 'Проверка соединения…',
  'settings.byokReadyToTest': 'Готово к проверке',
  'settings.testCancel': 'Отмена',
  'settings.testRetry': 'Повторить проверку',
  'settings.required': 'обязательно',
  'settings.testMissingFields': 'Заполните {fields}, чтобы проверить подключение.',
  'settings.testSuccessApi': 'Подключено. Ответ за {ms} мс — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} ответил за {ms} мс — \'{sample}\'',
  'settings.testAuthFailed': 'Сбой аутентификации. Проверьте ключ API.',
  'settings.testForbidden': 'Доступ запрещен. Проверьте учетную запись, регион или организацию.',
  'settings.testNotFoundModel': 'Модель \'{model}\' не найдена на этом эндпойнте.',
  'settings.testInvalidModelId': 'ID модели \'{model}\' недействителен. Пользовательский ID должен начинаться с буквы или цифры и не содержать пробелов.',
  'settings.testInvalidBaseUrl': 'Base URL недействителен или недоступен.',
  'settings.testRateLimited': 'Поставщик ограничил тест. Конфигурация выглядит верной.',
  'settings.testUpstream': 'Поставщик вернул {status}. Повторите попытку чуть позже.',
  'settings.testTimeout': 'Тест прерван по таймауту через {ms} мс.',
  'settings.testAgentMissing': '{agentName} не установлен или отсутствует в PATH.',
  'settings.testAgentSpawn': 'Не удалось запустить {agentName}: {detail}.',
  'settings.testUnknown': 'Тест не пройден: {detail}',
  'settings.agentInstall.install': 'Установить',
  'settings.agentInstall.docs': 'Документация',
  'settings.agentInstall.pathHint': 'Если вы установили CLI через npm или Homebrew, но она всё ещё отмечена как не установленная, убедитесь, что bin-каталог инструмента есть в PATH, который наследует daemon Open Design (в macOS PATH у Terminal и GUI-приложений может отличаться). См. QUICKSTART.md (раздел "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Откройте Установить или Документация для нужного агента.',
  'settings.agentInstall.stepAuth': 'Пройдите аутентификацию в CLI поставщика (вход или добавление API-ключей), затем вернитесь в Open Design.',
  'settings.agentInstall.stepRescan': 'Нажмите «Пересканировать» в этом разделе.',
  'settings.agentInstall.stepSelect': 'Выберите карточку агента, когда он появится как установленный.',
  'settings.noAgentsDetected': 'Агенты ещё не обнаружены. Установите один из следующих инструментов: Claude Code, Codex, Devin for Terminal, Gemini CLI, OpenCode, Cursor Agent, Qwen или GitHub Copilot CLI, затем нажмите «Пересканировать».',
  'settings.agentInstalledGroup': 'Ваши CLI ({count})',
  'settings.agentInstallGroup': 'Доступно для установки ({count})',
  'settings.agentAuthRequired': 'Требуется аутентификация',
  'settings.agentAuthUnknown': 'Статус аутентификации неизвестен',
  'settings.amrCloud': 'Open Design AMR',
  'settings.amrAuthorize': 'Авторизовать',
  'settings.amrBenefitOfficial': 'Официальный',
  'settings.amrBenefitLowerPrice': 'Ниже стоимость',
  'settings.amrBenefitManyModels': 'Множество моделей',
  'settings.amrPromoBonus': 'Ограниченный бонус: +100%',
  'settings.amrSignInToContinue': 'Войдите, чтобы продолжить',
  'settings.amrSignIn': 'Войти',
  'settings.amrSignedIn': 'Вы вошли',
  'settings.amrNotSignedIn': 'Вы не вошли',
  'settings.amrSigningIn': 'Вход…',
  'settings.amrCancelSignIn': 'Отменить вход',
  'settings.amrAccountStatus': 'Статус аккаунта AMR',
  'settings.amrConsole': 'Консоль AMR',
  'settings.amrLoginErrorCompact': 'Не удалось войти в AMR.',
  'settings.advanced': 'Дополнительно',
  'settings.amrLogin': 'Войти',
  'settings.amrLogout': 'Выйти',
  'settings.amrLoggingIn': 'Вход…',
  'settings.amrLoggingOut': 'Выход…',
  'settings.amrLoggedInAs': 'Вы вошли как {email}',
  'settings.amrLoggedInWithPlan': 'Вход выполнен как {email} · {plan}',
  'settings.amrLoggedInPill': 'Вы вошли',
  'settings.amrNotLoggedIn': 'Вы не вошли',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Быстро заполнить провайдера',
  'settings.providerPreset': 'Пресет шлюза',
  'settings.protocolGroupProtocols': 'Протоколы',
  'settings.protocolGroupGateways': 'Шлюзы',
  'settings.customProvider': 'Пользовательский провайдер',
  'settings.apiKey': 'API-ключ',
  'settings.apiKeyGetLink': 'Получить ключ ↗',
  'settings.showKey': 'Показать ключ',
  'settings.hideKey': 'Скрыть ключ',
  'settings.show': 'Показать',
  'settings.hide': 'Скрыть',
  'settings.model': 'Модель',
  'settings.apiKeyInvalid': 'Недействительный API key.',
  'settings.apiKeyCleaned': 'Из API key удалены лишние пробелы.',
  'settings.modelsLoadedFromAccount': '✓ Загружено моделей из вашего аккаунта: {count}.',
  'settings.modelsLoadedCount': '✓ Загружено моделей: {count}.',
  'settings.modelSourceAccount': 'Из вашего аккаунта',
  'settings.modelSourceSuggested': 'Рекомендуемое',
  'settings.fetchModels': 'Загрузить модели',
  'settings.fetchModelsTitle': 'Загрузить доступные модели от этого провайдера',
  'settings.fetchModelsRunning': 'Загрузка моделей…',
  'settings.fetchModelsMissingFields': 'Заполните {fields}, чтобы загрузить модели.',
  'settings.fetchModelsInvalidBaseUrl': 'Введите корректный Base URL, чтобы загрузить модели.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI использует имена развёртываний, поэтому обнаружение моделей здесь недоступно.',
  'settings.fetchModelsUnsupportedOllama': 'Обнаружение моделей Ollama Cloud пока недоступно. Выберите или введите модель.',
  'settings.fetchModelsSuccess': 'Загружено моделей: {count}.',
  'settings.fetchModelsEmpty': 'Совместимые текстовые модели не найдены.',
  'settings.fetchModelsUnsupported': 'Обнаружение моделей недоступно для этого протокола.',
  'settings.fetchModelsFailed': 'Не удалось загрузить модели: {detail}',
  'settings.suggestedModelsHint': 'Это рекомендуемые модели для этого протокола. Ваш провайдер может поддерживать другие модели.',
  'settings.baseUrl': 'Базовый URL',
  'settings.baseUrlInvalid': 'Используйте публичный URL с http:// или https://.',
  'settings.baseUrlCustomize': 'Настроить',
  'settings.baseUrlDefaultHint': 'Эндпоинт по умолчанию. Обычно его не нужно менять.',
  'settings.azureBaseUrlPlaceholder': 'Вставьте URL эндпоинта Azure',
  'settings.azureBaseUrlHint': 'Найдите это в портале Azure → ваш ресурс → Endpoint.',
  'settings.azureDeploymentModel': 'Имя развертывания',
  'settings.azureCustomDeploymentName': 'Пользовательское имя развёртывания',
  'settings.azureDeploymentModelHint': 'Для Azure OpenAI это поле используется как имя развертывания в /openai/deployments/<model>. Укажите имя развертывания, созданного в Azure.',
  'settings.azureModelFetchHint': 'Введите имя развёртывания из вашего ресурса Azure. Развёртывания Azure нельзя получить автоматически.',
  'settings.apiVersion': 'Версия API',
  'settings.byokImageModel': 'Модель генерации изображений',
  'settings.byokVideoModel': 'Модель генерации видео',
  'settings.byokVideoI2vHint': 'Модель «изображение в видео»: нужно референсное изображение (иначе используется последнее изображение проекта)',
  'settings.byokSpeechModel': 'Модель синтеза речи',
  'settings.byokSpeechVoice': 'Голос',
  'settings.byokModelDefaultOption': 'По умолчанию',
  'settings.maxTokens': 'Макс. токенов (опционально)',
  'settings.maxTokensHint': 'Ограничение длины ответа. У каждой модели свой настроенный дефолт (виден в плейсхолдере); оставьте поле пустым, чтобы использовать его, или введите число, чтобы переопределить.',
  'settings.apiHint': 'Запросы отправляются через локальный прокси daemon на указанную Base URL. Ключ хранится только в этом браузере и отправляется в запросах к провайдеру.',
  'settings.skipForNow': 'Пропустить сейчас',
  'settings.getStarted': 'Начать',
  'settings.envConfigure': 'Режим выполнения',
  'settings.localCli': 'Локальный CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'агент не выбран',
  'settings.language': 'Язык',
  'settings.languageHint': 'Переключить язык интерфейса. Сохраняется в этом браузере.',
  'settings.appearance': 'Внешний вид',
  'settings.appearanceHint': 'Выберите светлую, тёмную или системную тему.',
  'settings.themeSystem': 'Системная',
  'settings.themeLight': 'Светлая',
  'settings.themeDark': 'Тёмная',
  'settings.agentModelHead': 'Модель для:',
  'settings.modelPicker': 'Модель',
  'settings.modelSourceLive': 'Из CLI в реальном времени',
  'settings.modelSourceFallback': 'Встроенный список',
  'settings.reasoningPicker': 'Сложность рассуждений',
  'settings.modelPickerHint': 'Получается из CLI, если он поддерживает команду `models`. «По умолчанию» оставляет выбор конфигурации CLI, а «Пользовательская…» позволяет ввести любой ID модели, который CLI принимает.',
  'settings.modelPickerLiveHint': 'Модели обновлены из установленного CLI. Вариант по умолчанию по-прежнему использует конфигурацию CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Модели обновлены из установленного CLI.',
  'settings.modelPickerFallbackHint': 'Показаны встроенные значения по умолчанию. Нажмите «Пересканировать», чтобы получить актуальные модели из CLI.',
  'settings.cliEnvTitle': 'Дополнительно: прокси и пользовательские пути',
  'settings.cliEnvHint': 'Используйте это, только если вы направляете трафик CLI через собственный прокси или установили бинарный файл в нестандартном расположении. Секреты остаются в локальной конфигурации приложения, и доступ к ним имеет только выбранный CLI.',
  'settings.cliEnvClaudeConfigDir': 'Каталог конфигурации Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL прокси Claude',
  'settings.cliEnvClaudeApiKey': 'API key прокси Claude',
  'settings.cliEnvCodexHome': 'Домашний каталог Codex',
  'settings.cliEnvCodexBin': 'Путь к исполняемому файлу Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL прокси Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key прокси Codex/OpenAI',
  'settings.modelCustom': 'Пользовательская (введите ниже)…',
  'settings.modelCustomLabel': 'Пользовательский ID модели',
  'settings.modelCustomPlaceholder': 'например, anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Медиа-провайдеры',
  'settings.mediaProvidersHint': 'API-ключи для генерации изображений, видео и аудио. Хранятся локально и синхронизируются с локальным демоном.',
  'settings.mcpServerTitle': 'MCP-сервер',
  'settings.mcpServerHint': 'Откройте Open Design как MCP-сервер для вашего кодинг-агента.',
  'settings.externalMcpTitle': 'Внешний MCP',
  'settings.externalMcpHint': 'Добавьте MCP-инструменты из внешних сервисов (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'API-ключ',
  'settings.mediaProviderBaseUrl': 'Базовый URL',
  'settings.mediaProviderConfigured': 'Настроено',
  'settings.mediaProviderUnset': 'Не настроено',
  'settings.mediaProviderClear': 'Очистить',
  'settings.mediaProviderClearConfirm': 'Удалить сохранённые настройки {name}? Вам придётся ввести их заново, чтобы использовать {name}.',
  'settings.mediaProviderPlaceholder': 'Вставьте API-ключ',
  'settings.mediaProviderBaseUrlPlaceholder': 'Переопределить базовый URL',
  'settings.mediaProviderReload': 'Перезагрузить из локального демона',
  'settings.mediaProviderReloadError': 'Не удалось заново загрузить настройки медиапровайдеров из локального демона.',
  'settings.mediaProviderReloadSuccess': 'Настройки медиапровайдеров заново загружены из локального демона.',
  'settings.mediaProviderLoadError': 'Не удалось загрузить настройки медиапровайдеров из локального демона. Пока используются настройки, сохранённые в браузере.',
  'settings.mediaProviderComingSoonHint': 'Мы отслеживаем их в дорожной карте; демон пока не поставляет клиент, поэтому настраивать нечего.',
  'settings.privacy': 'Конфиденциальность',
  'settings.privacyHint': 'Какие данные передаются команде Open Design',
  'settings.privacyConsentKicker': 'Помогите нам улучшить Open Design',
  'settings.privacyConsentLead': 'Open Design может передавать данные об использовании нашей команде, чтобы помочь нам стать лучше. Сюда входят:',
  'settings.privacyConsentFooter': 'Эти параметры можно изменить в любой момент в разделе «Настройки → Конфиденциальность».',
  'settings.privacyConsentShare': 'Передавать данные об использовании',
  'settings.privacyConsentDecline': 'Не передавать',
  'settings.privacyConsentAccept': 'Понятно',
  'settings.privacyConsentBannerFooter': 'Передача данных включена по умолчанию. Вы можете отключить её в любой момент в разделе «Настройки → Конфиденциальность».',
  'settings.privacyConsentPolicyLink': 'Прочитать политику конфиденциальности',
  'settings.privacyMetrics': 'Анонимные метрики',
  'settings.privacyMetricsHint': 'Количество запусков, использование Token, частота ошибок, длительность. Без промптов и данных проекта.',
  'settings.privacyContent': 'Содержимое диалога и инструментов',
  'settings.privacyContentHint': 'Запросы, ответы ассистента, входные/выходные данные инструментов и файлы полного контекста, необходимые для проверки качества. Секреты удаляются перед отправкой.',
  'settings.privacyInstallationId': 'Анонимный идентификатор',
  'settings.privacyOptedOut': 'отключено',
  'settings.privacyDataDeletion': 'Удалить мои данные',
  'settings.privacyDataDeletionHint': 'Меняет ваш анонимный идентификатор и прекращает отправку данных. Существующие трассировки удаляются согласно нашей политике хранения.',
  'settings.about': 'О приложении',
  'settings.aboutHint': 'Версия и сведения о запуске',
  'settings.appVersion': 'Версия',
  'settings.appChannel': 'Канал',
  'settings.appRuntime': 'Среда запуска',
  'settings.appPlatform': 'Платформа',
  'settings.appArchitecture': 'Архитектура',
  'settings.runtimePackaged': 'Упакованное приложение',
  'settings.runtimeDevelopment': 'Разработка',
  'settings.versionUnavailable': 'Сведения о версии недоступны, пока daemon не запущен.',
  'settings.installLatest': 'Установить последнюю версию',
  'settings.alreadyLatest': 'У вас установлена последняя версия',
  'settings.mcpTitle': 'Сервер MCP',
  'settings.mcpHint': 'Позвольте агентам для кода (Cursor, Claude Code, VS Code…) напрямую читать ваши проекты Open Design.',
  'settings.mcpDaemonError': 'Не удалось подключиться к локальному демону для определения путей установки ({error}). Убедитесь, что Open Design запущен, затем снова откройте эту панель.',
  'settings.mcpBuildDaemon': 'Сначала соберите демон.',
  'settings.mcpNodeMissing': 'Отсутствует исполняемый файл Node.',
  'settings.mcpBuildHint': 'Файл apps/daemon/dist/cli.js отсутствует. Выполните `pnpm --filter @open-design/daemon build` и обновите.',
  'settings.mcpMethodCli': 'Команда CLI',
  'settings.mcpInstructionCli': 'Выполните это в терминале.',
  'settings.mcpMethodToml': 'Конфигурация TOML',
  'settings.mcpInstructionCodex': 'Добавьте эту таблицу в {path}. Одна и та же конфигурация используется совместно Codex CLI и расширением Codex для IDE.',
  'settings.mcpMethodOneClick': 'Установка в один клик',
  'settings.mcpInstructionCursor': 'Нажмите «Install in Cursor», чтобы установить с диалогом подтверждения, или объедините этот JSON с {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Установить в Cursor',
  'settings.mcpMethodJson': 'Конфигурация JSON',
  'settings.mcpInstructionCopilot': 'Откройте палитру команд ({shortcut}), выполните «MCP: Open User Configuration» и объедините этот JSON. Чтобы инструменты отображались, Copilot Chat должен находиться в режиме Agent.',
  'settings.mcpInstructionAntigravity': 'В Antigravity: меню «...» панели Agent → MCP Servers → Manage MCP Servers → View raw config. Объедините этот JSON.',
  'settings.mcpInstructionZed': 'Откройте настройки Zed ({shortcut}) и объедините это с объектом верхнего уровня. Zed использует «context_servers», а не «mcpServers».',
  'settings.mcpInstructionWindsurf': 'Откройте {path} (или используйте значок MCP в Cascade → Configure) и объедините:',
  'settings.mcpCopyAria': 'Скопировать фрагмент конфигурации MCP',
  'settings.mcpResolvingFailed': '# не удалось определить пути, см. ошибку выше',
  'settings.mcpLoadingPaths': '# загрузка путей установки из локального демона…',
  'settings.mcpCopied': 'Скопировано',
  'settings.mcpCopy': 'Копировать',
  'settings.mcpCursorApproval': 'Cursor открывает диалог подтверждения перед записью конфигурации.',
  'settings.mcpCodexOneClickInstall': 'Установить в Codex',
  'settings.mcpCodexOneClickUninstall': 'Удалить из Codex',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI не найден в PATH — установите Codex или вставьте фрагмент вручную.',
  'settings.mcpCodexInstallSuccess': 'Установлено. Перезапустите Codex, чтобы загрузить новый сервер.',
  'settings.mcpCodexUninstallSuccess': 'Удалено из Codex.',
  'settings.mcpCodexBusy': 'Выполняется…',
  'settings.mcpCodexInstallError': 'Операция не выполнена: {error}',
  'settings.mcpRestartNote': 'Перезапустите клиент, чтобы подключить новый сервер.',
  'settings.mcpRestartDetail': 'Большинство редакторов загружают серверы MCP только при запуске. В Cursor / VS Code / Antigravity / Windsurf вместо полного перезапуска можно выполнить `Developer: Reload Window` из палитры команд. Zed и Claude Code требуют выхода и повторного открытия.',
  'settings.mcpCapabilitiesTitle': 'Что может ваш Agent',
  'settings.mcpCapabilityRead': 'Читать или искать любой файл в проекте (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Получать набор данных дизайна одним вызовом: входной файл плюс каждую переменную CSS, компонент и шрифт, на которые он ссылается.',
  'settings.mcpCapabilityDefault': 'По умолчанию использовать проект и файл, открытые в Open Design, чтобы можно было сказать «собери это в моём приложении», не уточняя, о каком дизайне идёт речь.',
  'settings.mcpRunningNote': 'Для успешного выполнения вызовов инструментов MCP необходимо, чтобы Open Design был запущен. Если вы запустили своего агента для кодинга до открытия Open Design, перезапустите агент, чтобы он мог подключиться к работающему демону.',
  'entry.tabDesigns': 'Дизайны',
  'entry.tabTemplates': 'Шаблоны',
  'entry.tabDesignSystems': 'Дизайн-системы',
  'entry.tabConnectors': 'Коннекторы',
  'entry.openSettingsTitle': 'Настройки',
  'entry.openSettingsAria': 'Открыть настройки',
  'entry.discordLabel': 'Присоединиться к Discord',
  'entry.discordAria': 'Присоединиться к Discord-сообществу Open Design',
  'entry.discordAriaWithOnline': 'Присоединиться к Discord-сообществу Open Design — {online}',
  'entry.discordOnlineLabel': '{count} онлайн',
  'entry.followXLabel': 'Подписаться на @nexudotio в X',
  'entry.resizeAria': 'Изменить размер боковой панели',
  'entry.loadingWorkspace': 'Загрузка рабочего пространства…',
  'entry.useEverywhereTitle': 'Использовать везде',
  'entry.useEverywhereAria': 'Открыть руководство «Использовать везде» (CLI, MCP, HTTP, Skills)',
  'entry.navExpand': 'Развернуть боковую панель',
  'entry.navCollapse': 'Свернуть боковую панель',
  'entry.navNewProject': 'Новый проект',
  'entry.navHome': 'Главная',
  'entry.navProjects': 'Проекты',
  'entry.navTasks': 'Автоматизации',
  'entry.navPlugins': 'Плагины',
  'entry.navDesignSystems': 'Дизайн-системы',
  'entry.navIntegrations': 'Интеграции',
  'workspaceTabs.project': 'Проект',
  'workspaceTabs.pluginDetails': 'Сведения о плагине',
  'workspaceTabs.marketplace': 'Маркетплейс',
  'homeHero.title': 'Что вы хотите спроектировать?',
  'homeHero.templatesScrollHint': 'Прокрутите вверх, чтобы увидеть больше шаблонов',
  'homeHero.templatesCollapse': 'Свернуть шаблоны',
  'homeHero.subtitlePrefix': 'Открытая альтернатива Claude Design.',
  'homeHero.placeholder': 'Опишите, что вы хотите сгенерировать…',
  'homeHero.placeholderActive': 'Измените пример запроса или напишите свой…',
  'homeHero.skills': 'Навыки',
  'homeHero.addMenu': 'Добавить контекст',
  'homeHero.addPlugin': 'Добавить плагин',
  'homeHero.addConnectors': 'Добавить коннекторы',
  'homeHero.addMcp': 'Добавить сервер MCP',
  'homeHero.noPlugins': 'Нет установленных плагинов',
  'homeHero.noMcp': 'Нет серверов MCP',
  'homeHero.noConnectors': 'Нет подключённых коннекторов',
  'homeHero.applying': 'Применение…',
  'homeHero.pluginTitle': 'Плагин: {title}',
  'homeHero.pluginPrefix': 'Плагин: {title}',
  'homeHero.skillPrefix': 'Навык: {title}',
  'homeHero.removePlugin': 'Удалить плагин',
  'homeHero.removePluginAria': 'Удалить плагин {title}',
  'homeHero.clearActivePlugin': 'Сбросить активный плагин',
  'homeHero.clearActiveSkill': 'Сбросить активный навык',
  'homeHero.contextItemsResolved': 'Разрешено элементов контекста: {n}',
  'homeHero.removeFile': 'Удалить файл',
  'homeHero.contextSearchResults': 'Результаты поиска по контексту',
  'homeHero.contextSurfaces': 'Источники контекста',
  'homeHero.loadingContext': 'Загрузка контекста…',
  'homeHero.noResults': 'Нет результатов по запросу «{query}».',
  'homeHero.searchPrompt': 'Поиск файлов, плагинов, навыков, серверов MCP и коннекторов.',
  'homeHero.parameters': 'Параметров: {n}',
  'homeHero.details': 'Подробнее',
  'homeHero.toRun': 'для запуска',
  'homeHero.forNewLine': 'для новой строки',
  'homeHero.run': 'Запустить',
  'homeHero.typeSomethingToRun': 'Введите что-нибудь для запуска',
  'homeHero.promptExamples': 'Примеры',
  'homeHero.footer.designSystem': 'Стиль',
  'homeHero.footer.autoDesignSystem': 'Авто',
  'homeHero.footer.autoDesignSystemSummary': 'Автоматически подбирает дизайн-систему и визуальный стиль для текущего промпта.',
  'homeHero.footer.ratio': 'Формат',
  'homeHero.footer.duration': 'Длительность',
  'homeHero.footer.resolution': 'Разрешение',
  'homeHero.footer.speakerNotes': 'Заметки',
  'homeHero.footer.noSpeakerNotes': 'Без заметок',
  'homeHero.footer.availableCount': 'Доступно: {n}',
  'homeHero.footer.noMatches': 'Нет совпадений',
  'homeHero.moreShortcuts': 'Еще',
  'homeHero.railAria': 'Выберите категорию проекта или быстрый старт',
  'homeHero.subTypeAria': 'Выберите подтип',
  'homeHero.confirmReplaceTitle': 'Заменить текущий запрос?',
  'homeHero.confirmReplaceBody': 'Использование {title} заменит текст, который сейчас введён в поле.',
  'homeHero.confirmReplace': 'Заменить',
  'homeHero.chip.prototype': 'Прототип',
  'homeHero.chip.liveArtifact': 'Живой артефакт',
  'homeHero.chip.deck': 'Презентация',
  'homeHero.chip.image': 'Изображение',
  'homeHero.chip.video': 'Видео',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.audio': 'Аудио',
  'homeHero.chip.createPlugin': 'Создать плагин',
  'homeHero.chip.figma': 'Из Figma',
  'homeHero.chip.folder': 'Из папки',
  'homeHero.chip.template': 'Из шаблона',
  'homeHero.chip.liveArtifactHint': 'Создайте интерактивный артефакт HTML/CSS/JS с живым предпросмотром.',
  'homeHero.chip.hyperframesHint': 'Создавайте анимацию на основе HTML: субтитры, реагирующая на звук графика, переходы между сценами.',
  'homeHero.chip.createPluginHint': 'Создайте многоразовый плагин Open Design и добавьте его в раздел «Мои плагины».',
  'homeHero.chip.figmaHint': 'Перенесите фрейм Figma в активную дизайн-систему.',
  'homeHero.chip.folderHint': 'Импортируйте существующую локальную папку и продолжите редактирование.',
  'homeHero.chip.templateHint': 'Начните со встроенного шаблона.',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'Папка',
  'workingDirPicker.homeTitle': 'Сохраняется в локальном хранилище — нажмите, чтобы выбрать папку',
  'workingDirPicker.processing': 'Обработка…',
  'workingDirPicker.select': 'Локальное хранилище',
  'workingDirPicker.clearAria': 'Очистить рабочий каталог',
  'workingDirPicker.replaceFailed': 'Не удалось заменить рабочий каталог',
  'workingDirPicker.unavailable': 'Выбор папки недоступен в этой сборке. Запустите десктопное приложение, чтобы выбрать папку.',
  'workingDirPicker.openUnavailable': 'Откройте этот проект в десктопном приложении, чтобы показать папку.',
  'workingDirPicker.openFailed': 'Не удалось показать эту папку',
  'workingDirPicker.showInFileManager': 'Показать в файловом менеджере',
  'workingDirPicker.replace': 'Выбрать папку…',
  'workingDirPicker.recent': 'Недавние каталоги',
  'workingDirPicker.defaultLabel': 'Локальное хранилище',
  'handoff.toTarget': 'Передать в {target}',
  'handoff.openInTarget': 'Открыть в {target}',
  'handoff.openAction': 'Открыть',
  'handoff.menuTitle': 'В каком редакторе открыть?',
  'handoff.action': 'Передать',
  'handoff.fallbackTitle': 'Редакторы в $PATH не найдены — откроется в {target}',
  'handoff.chooseTargetAria': 'Выберите цель передачи',
  'handoff.optionsAria': 'Параметры передачи',
  'handoff.editorSection': 'Открыть в редакторе',
  'handoff.cliSection': 'Скопировать для CLI',
  'handoff.clickOpen': 'Нажмите, чтобы открыть',
  'handoff.framework': 'Фреймворк кода',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'чистый JavaScript, HTML и CSS',
  'handoff.amrWebsite': 'Открыть сайт AMR',
  'handoff.copyPrompt': 'Скопировать запрос',
  'handoff.copyPromptForTarget': 'Скопировать запрос для {target}',
  'handoff.copied': 'Скопировано',
  'handoff.projectPathUnavailable': 'Путь к проекту ещё загружается. Повторите попытку через мгновение.',
  'handoff.copyFailed': 'Запись в буфер обмена заблокирована. Повторите попытку через мгновение.',
  'handoff.promptIntro': 'Продолжить из этой локальной папки проекта Open Design:',
  'handoff.promptTarget': 'Цель',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Вы перенимаете работу в {cli}. Пожалуйста:',
  'handoff.promptReadFiles': 'Сначала перейдите в этот каталог или прочитайте его. Отдавайте приоритет DESIGN.md, README, существующим HTML/CSS/JS, ресурсам и package.json, если он есть.',
  'handoff.promptKeepDesign': 'Сохраняйте текущий визуальный дизайн, макет, взаимодействия и ресурсы. Не останавливайтесь на плане.',
  'handoff.promptProduceCode': 'Создавайте или изменяйте реальный работоспособный код {framework}. Если в проекте уже есть более понятный стек, укажите на конфликт и сохраните работоспособность результата.',
  'handoff.promptVerify': 'В завершение сообщите мне команды для запуска, предпросмотра и проверки.',
  'handoff.promptCommandHint': 'Чтобы начать из каталога проекта, используйте:',
  'handoff.promptProject': 'Проект',
  'handoff.promptProjectId': 'ID проекта',
  'handoff.notInstalled': 'Не установлено',
  'handoff.notDetectedTitle': '{target} — не обнаружено в $PATH',
  'designSystemPicker.select': 'Выберите дизайн-систему',
  'designSystemPicker.loading': 'Загрузка дизайн-систем…',
  'designSystemPicker.searchPlaceholder': 'Поиск дизайн-систем (название / категория / описание)',
  'designSystemPicker.searchCompactPlaceholder': 'Поиск дизайн-систем',
  'designSystemPicker.noneTitle': 'Без дизайн-системы',
  'designSystemPicker.noneSummary': 'Позволить модели выбирать свободно',
  'designSystemPicker.empty': 'Подходящих дизайн-систем нет',
  'designSystemPicker.openPreview': 'Открыть предпросмотр',
  'designSystemPicker.loadingPreview': 'Загрузка предпросмотра…',
  'designSystemPicker.noPreview': 'Нет страницы предпросмотра. Откройте «Дизайн-системы», чтобы посмотреть полный предпросмотр.',
  'designSystemPicker.previewHint': 'Наведите курсор на дизайн-систему для предпросмотра',
  'designSystemPicker.fullscreenAria': 'Полноэкранный предпросмотр: {title}',
  'designSystemPicker.closeFullscreen': 'Закрыть полноэкранный предпросмотр',
  'designSystemPicker.closeEsc': 'Закрыть (Esc)',
  'designSystemPicker.previewFrameTitle': 'Предпросмотр: {title}',
  'designSystemPicker.fullscreenFrameTitle': 'Полноэкранный предпросмотр: {title}',
  'recentProjects.title': 'Недавние проекты',
  'recentProjects.viewAll': 'Показать все',
  'recentProjects.empty': 'Пока нет проектов — введите запрос, чтобы начать.',
  'pluginsHome.title': 'Сообщество',
  'pluginsHome.subtitle': 'Готовые рабочие процессы Open Design, входящие в состав этой среды выполнения. Выберите один, чтобы загрузить стартовый запрос, или просмотрите реестр для дополнительных вариантов.',
  'pluginsHome.browseRegistry': 'Просмотр реестра',
  'pluginsHome.count': '{filtered} из {total}',
  'pluginsHome.loadingCatalog': 'Загрузка каталога…',
  'pluginsHome.emptyCatalog': 'Каталог пуст. Встроенные плагины поставляются вместе с Open Design и должны появляться здесь автоматически — если проблема не исчезает, попробуйте перезапустить демон.',
  'pluginsHome.emptyFiltered': 'Нет плагинов, соответствующих текущим фильтрам.',
  'pluginsHome.clearFilters': 'Сбросить фильтры',
  'pluginsHome.modeAria': 'Режим плагина',
  'pluginsHome.featured': 'Сохранено',
  'pluginsHome.totalInCatalog': '{n} в каталоге',
  'pluginsHome.categoryFilterAria': 'Фильтр по категории',
  'pluginsHome.subcategoryFilterAria': 'Фильтр по подкатегории {label}',
  'pluginsHome.allCategory': 'Все: {label}',
  'pluginsHome.searchPlaceholder': 'Поиск плагинов…',
  'pluginsHome.searchAria': 'Поиск плагинов',
  'pluginsHome.clearSearch': 'Очистить поиск',
  'pluginsHome.facet.import': 'Импорт',
  'pluginsHome.facet.create': 'Создать',
  'pluginsHome.facet.export': 'Экспорт',
  'pluginsHome.facet.share': 'Поделиться',
  'pluginsHome.facet.deploy': 'Развернуть',
  'pluginsHome.facet.refine': 'Доработать',
  'pluginsHome.facet.extend': 'Расширить',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Код / папка',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Скриншот',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Слайды',
  'pluginsHome.facet.publicLink': 'Публичная ссылка',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Дашборды',
  'pluginsHome.subfacet.app-prototypes': 'Приложения',
  'pluginsHome.subfacet.landing-marketing': 'Лендинги / маркетинг',
  'pluginsHome.subfacet.developer-tools': 'Инструменты разработчика',
  'pluginsHome.subfacet.docs-reports': 'Документы / отчёты',
  'pluginsHome.subfacet.brand-design': 'Бренд / дизайн',
  'pluginsHome.subfacet.pitch-business': 'Питч / бизнес',
  'pluginsHome.subfacet.course-training': 'Курсы / обучение',
  'pluginsHome.subfacet.reports-briefings': 'Отчёты / брифинги',
  'pluginsHome.subfacet.product-sales': 'Продукт / продажи',
  'pluginsHome.subfacet.engineering-talks': 'Технические доклады',
  'pluginsHome.subfacet.creative-decks': 'Креативные презентации',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / мокапы',
  'pluginsHome.subfacet.brand-visuals': 'Бренд / логотип',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Раскадровки',
  'pluginsHome.subfacet.social-content': 'Соцсети / контент',
  'pluginsHome.subfacet.avatar-portrait': 'Аватар / портрет',
  'pluginsHome.subfacet.illustration-style': 'Иллюстрация / стиль',
  'pluginsHome.subfacet.motion-effects': 'Моушн / эффекты',
  'pluginsHome.subfacet.social-short-form': 'Соцсети / короткие видео',
  'pluginsHome.subfacet.marketing-product': 'Маркетинг / продукт',
  'pluginsHome.subfacet.data-explainers': 'Данные / объяснения',
  'pluginsHome.subfacet.cinematic-story': 'Кино / истории',
  'pluginsView.lede': 'Просматривайте установленные рабочие процессы, изучайте записи реестра, управляйте источниками и подготавливайте плагины для распространения в команде.',
  'pluginsView.importPlugin': 'Импортировать плагин',
  'pluginsView.agentContext': 'Контекст Agent',
  'pluginsView.summaryAria': 'Сводка по плагину',
  'pluginsView.areasAria': 'Области плагина',
  'pluginsView.loading': 'Загрузка плагинов…',
  'pluginsView.tab.installed': 'Установлено',
  'pluginsView.tab.available': 'Доступно',
  'pluginsView.tab.sources': 'Источники',
  'pluginsView.tab.team': 'Команда',
  'pluginsView.tabHint.installed': 'Ваши плагины',
  'pluginsView.tabHint.available': 'Из источников',
  'pluginsView.tabHint.sources': 'Каталоги',
  'pluginsView.tabHint.team': 'Корпоративные',
  'pluginsView.installedTitle': 'Установленные плагины',
  'pluginsView.installedSubtitle': 'Плагины, которые вы импортировали или установили из источников маркетплейса.',
  'pluginsView.installedEmpty': 'Пока нет установленных пользовательских плагинов. Воспользуйтесь действием «Создать / Импорт» или установите запись из раздела «Доступно».',
  'pluginsView.availableTitle': 'Доступно из источников',
  'pluginsView.availableSubtitle': 'Записи каталога, найденные в настроенных маркетплейсах.',
  'pluginsView.availableFiltersAria': 'Фильтры доступных плагинов',
  'pluginsView.searchAvailableAria': 'Поиск доступных плагинов',
  'pluginsView.searchAvailablePlaceholder': 'Поиск доступных плагинов',
  'pluginsView.clearAvailableSearch': 'Очистить поиск доступных плагинов',
  'pluginsView.source': 'Источник',
  'pluginsView.availableEmptyInstalled': 'Пока нет доступных записей. Установленные записи каталога удаляются из раздела «Доступно»; удалите одну из них, чтобы она снова стала доступной.',
  'pluginsView.availableEmptyFiltered': 'Нет доступных записей, соответствующих вашим фильтрам.',
  'pluginsView.availableEmptyNoSources': 'Пока нет доступных записей. Добавьте источник на вкладке «Источники».',
  'pluginsView.installing': 'Установка…',
  'pluginsView.install': 'Установить',
  'pluginsView.sourcesTitle': 'Источники реестра',
  'pluginsView.sourcesSubtitle': 'Каталоги маркетплейса, из которых формируются доступные плагины.',
  'pluginsView.sourceUrl': 'URL источника',
  'pluginsView.defaultTrust': 'Уровень доверия по умолчанию',
  'pluginsView.trust.restricted': 'Ограниченный',
  'pluginsView.trust.trusted': 'Доверенный',
  'pluginsView.trust.official': 'Официальный',
  'pluginsView.adding': 'Добавление…',
  'pluginsView.addSource': 'Добавить источник',
  'pluginsView.sourcesEmpty': 'Источники реестра ещё не настроены.',
  'pluginsView.pluginsCount': 'Плагинов: {n}',
  'pluginsView.catalogVersion': 'каталог v{version}',
  'pluginsView.trustFor': 'Доверие для {name}',
  'pluginsView.refreshing': 'Обновление…',
  'pluginsView.removing': 'Удаление…',
  'pluginsView.teamTitle': 'Частные командные маркетплейсы',
  'pluginsView.teamBody': 'Этот раздел зарезервирован для корпоративных и командных каталогов, частных политик доверия и общих средств управления жизненным циклом плагинов.',
  'pluginCard.details': 'Подробности',
  'pluginCard.use': 'Использовать',
  'pluginCard.useWithQuery': 'Использовать с запросом',
  'pluginCard.applying': 'Применение…',
  'pluginCard.publish': 'Опубликовать',
  'pluginCard.contribute': 'Внести вклад',
  'pluginCard.starting': 'Запуск…',
  'pluginCard.detailsAria': 'Посмотреть подробности для {title}',
  'pluginCard.chooseUseAria': 'Выберите способ использования {title}',
  'pluginCard.useOptionsAria': 'Параметры использования для {title}',
  'pluginCard.shareAria': 'Поделиться {title}',
  'pluginCard.publishAria': 'Опубликовать {title} как репозиторий GitHub',
  'pluginCard.publishTitle': 'Опубликовать плагин как репозиторий GitHub',
  'pluginCard.contributeAria': 'Внести {title} в Open Design',
  'pluginCard.contributeTitle': 'Внести плагин в Open Design через pull request',
  'skillPluginCandidate.createForMe': 'Создать плагин/шаблон',
  'skillPluginCandidate.contributeToMain': 'Внести вклад в open-design',
  'skillPluginCandidate.repoDescription': 'Похоже, этот репозиторий может работать как плагин.',
  'integrations.kicker': 'Интеграция',
  'integrations.lede': 'Подключайте внешние системы, добавляйте инструменты MCP в цикл работы вашего агента и используйте Open Design из других IDE, скриптов и средств автоматизации.',
  'integrations.agentReady': 'Готово для агента',
  'integrations.areasAria': 'Области интеграции',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Навыки',
  'integrations.tabHint.mcp': 'Внешние инструменты',
  'integrations.tabHint.connectors': 'Учётные записи и API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Интеграции навыков',
  'integrations.skillsBody': 'Управление интеграцией на уровне навыков переносится из другой ветки. Эта вкладка зарезервирована, чтобы настройка MCP, коннекторов и будущих навыков находилась в одном маршруте Интеграции.',
  'mcpClient.title': 'Внешние серверы MCP',
  'mcpClient.subtitle': 'Сторонние инструменты для вашего агента-программиста.',
  'mcpClient.addServer': 'Добавить сервер',
  'mcpClient.emptyTitle': 'Серверы MCP не настроены.',
  'mcpClient.emptyBody': 'Нажмите «Add server», чтобы начать — выберите шаблон (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) или настройте собственный stdio / HTTP-сервер.',
  'mcpClient.saveChanges': 'Сохранить изменения',
  'mcpClient.storedAt': 'Хранится в',
  'mcpClient.daemonError': 'Не удалось подключиться к локальному демону. Убедитесь, что Open Design запущен, затем снова откройте эту панель.',
  'mcpClient.saveFailed': 'Не удалось сохранить. Убедитесь, что демон запущен, и повторите попытку.',
  'useEverywhere.modalAria': 'Используйте Open Design везде',
  'useEverywhere.modalTitle': 'Используйте Open Design везде',
  'useEverywhere.modalSubtitle': 'Подключайте Open Design к любой IDE, агенту или скрипту — CLI, HTTP, MCP и Skills. Используйте «Copy guide for an agent» и вставьте в Claude Code, Codex, Cursor, openclaw или hermes, чтобы настроить всё.',
  'useEverywhere.closeAria': 'Закрыть «использовать везде»',
  'useEverywhere.closeTitle': 'Закрыть (Esc)',
  'useEverywhere.tabsAria': 'Точки интеграции',
  'useEverywhere.footStrong': 'Передача в один клик.',
  'useEverywhere.footBody': 'Копирует структурированное руководство в формате markdown, с которым ваш агент может сразу работать — установить, проверить и использовать.',
  'useEverywhere.configureMcp': 'Настроить сервер MCP',
  'useEverywhere.copyGuide': 'Скопировать руководство для агента',
  'useEverywhere.copy': 'Копировать',
  'useEverywhere.copied': 'Скопировано',
  'useEverywhere.copyFailed': 'Не удалось скопировать',
  'useEverywhere.copySnippetAria': 'Скопировать фрагмент: {label}',
  'useEverywhere.section.overview.tab': 'Обзор',
  'useEverywhere.section.overview.heading': 'Open Design работает везде, где работает ваш Agent',
  'useEverywhere.section.overview.intro': 'Open Design — это больше, чем окно: это локальный привилегированный демон (`od`) плюс реестр Skills + Design-Systems + Atoms. Как только он запущен на вашей машине, любой код-агент (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, ваш собственный скрипт) может управлять генерациями, инспектировать проекты и создавать дизайн-артефакты через четыре взаимозаменяемые поверхности.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` для headless-скриптов, CI и автоматизации в shell.',
  'useEverywhere.section.overview.bullet2': 'MCP-сервер — подключает Open Design как сервер Model Context Protocol, чтобы любой агент с поддержкой MCP мог получать список навыков, запускать сценарии и читать артефакты.',
  'useEverywhere.section.overview.bullet3': 'HTTP API — REST- и SSE-эндпоинты `http://127.0.0.1:7456/api/*`; та же поверхность, что использует веб-интерфейс.',
  'useEverywhere.section.overview.bullet4': 'Skills — готовые к использованию пакеты `SKILL.md` (совместимые с Claude), которые любой агент, уже находящийся в вашем PATH, может вызвать вообще без Open Design.',
  'useEverywhere.section.overview.bullet5': 'Стандартные артефакты — создавайте реальные HTML-проекты из Skills, встроенных плагинов по умолчанию и примеров плагинов сообщества ещё до запуска демона.',
  'useEverywhere.section.overview.snippet1': 'Запустите демон (и веб-интерфейс) локально',
  'useEverywhere.section.overview.snippet2': 'Убедитесь, что он доступен',
  'useEverywhere.section.overview.snippet3': 'Загрузите стандартные артефакты перед запуском',
  'useEverywhere.section.overview.footer': 'По умолчанию демон пишет в `./.od/` (локально для проекта). Установите `OD_DATA_DIR=~/.open-design`, чтобы использовать общие данные между проектами.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Управляйте Open Design из любой оболочки',
  'useEverywhere.section.cli.intro': 'Исполняемый файл `od` поставляется вместе с демоном и является тем же бинарником, который используют Claude Code / Codex при запуске генерации. Большинство подкоманд — это лёгкие клиенты, отправляющие POST-запросы локальному демону, поэтому они работают одинаково независимо от того, запустили ли вы его через `pnpm tools-dev` или как упакованное приложение.',
  'useEverywhere.section.cli.bullet1': '`od` (без аргументов) — запускает демон и открывает веб-интерфейс.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — создаёт байты изображения / видео / аудио через единый медиа-протокол.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — запускает выполнение проекта на основе промпта + навыка.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — устанавливает и применяет плагины сообщества.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — показывает, что доступно локально.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — проверяет состояние демона и обнаруживает CLI агентов в вашем PATH.',
  'useEverywhere.section.cli.snippet1': 'Сгенерировать изображение (делегируется настроенному медиа-провайдеру)',
  'useEverywhere.section.cli.snippet2': 'Запустить сценарный плагин в фоновом режиме и передавать события в виде строк JSON',
  'useEverywhere.section.cli.snippet3': 'Инвентаризация доступных локально навыков и дизайн-систем',
  'useEverywhere.section.cli.snippet4': 'Проверить начальные артефакты через CLI',
  'useEverywhere.section.cli.snippet5': 'Проверить окружение + обнаруженные агенты (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Все подкоманды принимают `--daemon-url http://127.0.0.1:<port>` для обращения к конкретному запущенному демону — полезно при запуске второго экземпляра в песочнице для тестов.',
  'useEverywhere.section.mcp.tab': 'Сервер MCP',
  'useEverywhere.section.mcp.heading': 'Предоставьте Open Design как сервер MCP любому кодовому Agent',
  'useEverywhere.section.mcp.intro': 'Open Design поставляется с сервером Model Context Protocol (`od mcp`), который позволяет любому клиенту с поддержкой MCP — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — обнаруживать инструменты Open Design (получать список навыков, отображать предпросмотры, генерировать медиа, запускать плагины) без ручного вызова через shell. Демон публикует готовый к вставке фрагмент установки через `GET /api/mcp/install-info` для каждого основного клиента.',
  'useEverywhere.section.mcp.bullet1': 'Транспорт stdio — без дополнительного порта, клиент запускает `od mcp` напрямую.',
  'useEverywhere.section.mcp.bullet2': 'Автоматически определяет URL активного демона через локальный сокет статуса IPC при запуске в качестве sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Возвращается к `--daemon-url http://127.0.0.1:<port>` для обычных установок, чтобы процесс MCP всегда находил запущенный демон.',
  'useEverywhere.section.mcp.bullet4': 'Закрепляет `OD_DATA_DIR`, чтобы порождённый процесс MCP писал туда же, куда уже пишет демон (позволяет избежать EPERM в упакованных бандлах приложений macOS).',
  'useEverywhere.section.mcp.snippet1': 'Общая конфигурация MCP-клиента (работает в Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'Или: запросите у демона фрагмент, адаптированный под вашу установку',
  'useEverywhere.section.mcp.snippet3': 'Вариант MCP с активными артефактами (чтение и обновление панелей)',
  'useEverywhere.section.mcp.footer': 'В приложении Open Design откройте Settings → Integrations, чтобы скопировать команду установки для конкретного клиента (Cursor, Claude Code, Antigravity, VS Code) вместо ручного редактирования JSON.',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'Тот же интерфейс REST + SSE, который использует веб-интерфейс',
  'useEverywhere.section.http.intro': 'Локальный демон предоставляет HTTP API по адресу `http://127.0.0.1:7456` (порт настраивается). Любая конечная точка, которую вызывает веб-интерфейс, доступна и для ваших скриптов. Потоковые конечные точки (ходы чата, запуски проектов) отправляют события Server-Sent Events с типами контракта из `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — проверка работоспособности демона.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` и `GET /api/design-systems` — доступные реестры.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` и `POST /api/projects` — список и создание проектов (POST возвращает проект + первый диалог).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — SSE-поток событий агента для диалога.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — привязывает установленный плагин и возвращает его готовый пример запроса + входные данные.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — обнаруженные CLI код-агентов в вашем PATH.',
  'useEverywhere.section.http.snippet1': 'Список установленных навыков (Agent будет использовать их как шаблоны)',
  'useEverywhere.section.http.snippet2': 'Создать проект из промпта (полный серверный процесс)',
  'useEverywhere.section.http.snippet3': 'Стриминг хода чата (SSE — каждая строка совместима с JSON-Lines)',
  'useEverywhere.section.http.footer': 'Чистые типы TypeScript для каждого запроса/ответа находятся в `@open-design/contracts` — импортируйте их в свой скрипт для полного автодополнения без настройки генератора.',
  'useEverywhere.section.skills.tab': 'Навыки и фоновый режим',
  'useEverywhere.section.skills.heading': 'Готовые к использованию Skills для любого агента — даже без запущенного Open Design',
  'useEverywhere.section.skills.intro': 'Skill — это директория с совместимым с Claude файлом `SKILL.md` (YAML-фронтматтер + тело). Open Design расширяет формат пространством имён `od:` (`mode`, `preview`, `design_system`, `inputs`, …), чтобы один и тот же артефакт можно было использовать как внутри Open Design, так и обычным агентом, например Claude Code, Codex, openclaw или hermes. Обнаружение следует цепочке приоритетов, поэтому проекты могут переопределять свои собственные навыки.',
  'useEverywhere.section.skills.bullet1': 'Обнаружение: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (приоритет у проекта).',
  'useEverywhere.section.skills.bullet2': 'Создайте символическую ссылку на один навык в нескольких проектах, чтобы делиться им без копирования.',
  'useEverywhere.section.skills.bullet3': 'Каждый навык может объявлять коннекторы, атомы, требования к дизайн-системе и пример вывода `preview` для галереи.',
  'useEverywhere.section.skills.bullet4': 'Фоновый режим: Agent с `od` в своём PATH может вызвать `od skills list`, а затем запустить любой навык; для операций только на чтение демон необязателен.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` отрабатывает ту же структуру артефактов на примерах плагинов по умолчанию и примерах плагинов сообщества, а затем сохраняет полученные проекты `index.html` как переиспользуемые тестовые данные.',
  'useEverywhere.section.skills.snippet1': 'Минимальный SKILL.md (совместимый с Claude front matter + дополнения Open Design)',
  'useEverywhere.section.skills.snippet2': 'Создать символическую ссылку на общий навык в проекте (в стиле cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Фоновый режим: список навыков, которые демон видит прямо сейчас',
  'useEverywhere.section.skills.snippet4': 'Набор фикстур артефактов для фонового режима',
  'useEverywhere.section.skills.footer': 'Спецификация: `docs/skills-protocol.md` и `docs/agent-adapters.md` охватывают весь интерфейс адаптеров (Claude Code, Codex, Cursor, Agent с поддержкой MCP, резервный вариант BYOK API) и стратегии внедрения навыков для каждого адаптера.',
  'tasks.kicker': 'Рабочее пространство автоматизации',
  'tasks.comingSoon': 'Скоро',
  'tasks.lede': 'Автоматизации превращают промпты в устойчивую работу: Orbit запускает их, рутины сохраняют их, расписания решают, когда они срабатывают, а активные артефакты показывают, что изменилось.',
  'tasks.newAutomation': 'Новая автоматизация',
  'tasks.previewNote': 'Только предпросмотр интерфейса. Настройки Orbit доступны уже сегодня; рутины, расписания и связка с активными артефактами появятся по мере слияния серверных веток.',
  'tasks.primitivesAria': 'Примитивы автоматизации',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Постоянная среда выполнения для долгосрочной или повторяющейся работы Agent.',
  'tasks.primitive.orbit.enabled': 'Ежедневная сводка включена',
  'tasks.primitive.orbit.manualOnly': 'Только вручную',
  'tasks.primitive.routines.title': 'Рутины',
  'tasks.primitive.routines.body': 'Устойчивые определения задач, которые сохраняются после завершения отдельного чата.',
  'tasks.primitive.routines.meta': 'Оболочка продукта готова',
  'tasks.primitive.schedules.title': 'Расписания',
  'tasks.primitive.schedules.body': 'Триггеры по времени или событиям, которые решают, когда должна запуститься рутина.',
  'tasks.primitive.schedules.meta': 'Ветка в ожидании',
  'tasks.primitive.liveArtifacts.title': 'Активные артефакты',
  'tasks.primitive.liveArtifacts.body': 'Отчёты и заметки, которые продолжают обновляться, пока работает Agent.',
  'tasks.primitive.liveArtifacts.meta': 'Модель предпросмотра',
  'tasks.listAria': 'Список автоматизаций',
  'tasks.routinesAndRuns': '{n} рутин и запусков',
  'tasks.filtersAria': 'Фильтры автоматизаций',
  'tasks.filter.scheduled': 'По расписанию',
  'tasks.filter.running': 'Выполняется',
  'tasks.filter.done': 'Готово',
  'tasks.configurationAria': 'Настройка автоматизации',
  'tasks.slot.trigger': 'Триггер',
  'tasks.slot.pattern': 'Шаблон',
  'tasks.slot.runtime': 'Среда выполнения',
  'tasks.slot.output': 'Результат',
  'tasks.liveArtifact': 'Живой артефакт',
  'tasks.viewProgress': 'Посмотреть прогресс',
  'tasks.pause': 'Пауза',
  'tasks.runNow': 'Запустить сейчас',
  'tasks.openArtifact': 'Открыть артефакт',
  'tasks.status.dailyAt': 'Ежедневно · {time}',
  'tasks.status.pausedManual': 'Приостановлено · только вручную',
  'tasks.sample.orbit.title': 'Сводка коннектора Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'Дайджест коннектора запланирован',
  'tasks.sample.orbit.metaDisabled': 'Откройте настройки Orbit, чтобы включить',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · живой артефакт',
  'tasks.sample.orbit.previewDisabled': 'Нет запланированных запусков',
  'tasks.sample.orbit.triggerEnabled': 'Расписание · ежедневно в {time}',
  'tasks.sample.orbit.triggerDisabled': 'Вручную · запуск по требованию',
  'tasks.sample.orbit.pattern': 'Рутина · дайджест коннекторов',
  'tasks.sample.orbit.runtime': 'Orbit · по расписанию демона',
  'tasks.sample.orbit.output': 'Живой артефакт · обновляемый отчёт',
  'tasks.sample.orbit.artifactMetaEnabled': 'Обновляется после каждого запуска',
  'tasks.sample.orbit.artifactMetaDisabled': 'Ожидание расписания',
  'tasks.sample.orbit.body1': '# Сводка активности Orbit Daily',
  'tasks.sample.orbit.body2': 'Коннекторы проверены · успехи, пропуски и сбои',
  'tasks.sample.orbit.body3': 'Ключевые моменты становятся обновляемым живым артефактом.',
  'tasks.sample.mcp.title': 'Исследование альтернатив MCP',
  'tasks.sample.mcp.status': 'Выполняется в orbit · 2 ч 14 мин',
  'tasks.sample.mcp.meta': 'Обработано источников: 14 / 30',
  'tasks.sample.mcp.preview': 'research_notes.md · живой',
  'tasks.sample.mcp.trigger': 'Вручную · однократно',
  'tasks.sample.mcp.pattern': 'Запрос для глубокого исследования',
  'tasks.sample.mcp.runtime': 'Удалённо · постоянно',
  'tasks.sample.mcp.output': 'Живой отчёт · автообновление',
  'tasks.sample.mcp.artifactMeta': 'Обновлено 12 с назад',
  'tasks.sample.mcp.body1': '# Альтернативы MCP — промежуточные результаты',
  'tasks.sample.mcp.body2': 'Изучено 14 источников · отобрано 3 претендента',
  'tasks.sample.mcp.body3': '## Краткий список',
  'tasks.sample.mcp.body4': '- Схемы вызова инструментов через JSON-RPC...',
  'tasks.sample.mcp.body5': '- Протоколы агентов на основе gRPC...',
  'tasks.sample.weekly.title': 'Еженедельный дайджест команды',
  'tasks.sample.weekly.status': 'Далее: пн, 9:00',
  'tasks.sample.weekly.meta': 'Обновляет еженедельный документ команды',
  'tasks.sample.weekly.preview': 'team_weekly.md · следующий артефакт',
  'tasks.sample.weekly.trigger': 'Расписание · еженедельно',
  'tasks.sample.weekly.pattern': 'Рутина · командный дайджест',
  'tasks.sample.weekly.runtime': 'Удалённо · повторяющееся',
  'tasks.sample.weekly.output': 'Активный артефакт · markdown',
  'tasks.sample.weekly.artifactMeta': 'Обновлено 4 дн назад',
  'tasks.sample.weekly.body1': '# Итоги недели команды',
  'tasks.sample.weekly.body2': '## В работе',
  'tasks.sample.weekly.body3': '- Этап интеграции дизайн-системы',
  'tasks.sample.weekly.body4': '- Проверка качества коннекторов',
  'tasks.sample.weekly.body5': '## Риски',
  'tasks.sample.pr.title': 'Напоминание о ревью PR',
  'tasks.sample.pr.status': 'При новом PR · запущено 23 мин назад',
  'tasks.sample.pr.meta': 'Отправляет личное сообщение в Slack',
  'tasks.sample.pr.preview': 'Последняя доставка выполнена успешно',
  'tasks.sample.pr.trigger': 'Событие · новый PR',
  'tasks.sample.pr.pattern': 'Рутина · уведомление',
  'tasks.sample.pr.runtime': 'Локально · быстрый запуск',
  'tasks.sample.pr.output': 'Сообщение · личка в Slack',
  'tasks.sample.pr.artifactMeta': 'Последний запуск 23 мин назад',
  'tasks.sample.pr.body1': 'Открыт PR #184 для ревью',
  'tasks.sample.pr.body2': 'Подобранные ревьюеры: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Доставка: личное сообщение в Slack отправлено',
  'tasks.sample.meeting.title': 'Подготовка к встрече',
  'tasks.sample.meeting.status': 'Завтра · 10:00',
  'tasks.sample.meeting.meta': 'Разовый запуск · отправляет сводку',
  'tasks.sample.meeting.preview': 'meeting_brief.md · в очереди',
  'tasks.sample.meeting.trigger': 'Расписание · разовый запуск',
  'tasks.sample.meeting.pattern': 'Запрос для брифинга',
  'tasks.sample.meeting.runtime': 'Удалённо · ограниченный',
  'tasks.sample.meeting.output': 'Артефакт + сообщение',
  'tasks.sample.meeting.artifactMeta': 'В очереди на генерацию',
  'tasks.sample.meeting.body1': '# Бриф встречи',
  'tasks.sample.meeting.body2': 'Источник повестки: событие календаря + связанные документы',
  'tasks.sample.meeting.body3': 'Результат будет включать решения, блокеры и вопросы.',
  'tasks.sample.candidate.title': 'Отслеживание кандидатов',
  'tasks.sample.candidate.status': 'Сбой · требует внимания',
  'tasks.sample.candidate.meta': 'Срок авторизации истёк',
  'tasks.sample.candidate.preview': 'Переподключите Greenhouse, чтобы продолжить',
  'tasks.sample.candidate.trigger': 'Расписание · ежедневно',
  'tasks.sample.candidate.pattern': 'Рутина · синхронизация кандидатов',
  'tasks.sample.candidate.runtime': 'Удалённо · повторяющийся',
  'tasks.sample.candidate.output': 'Активный артефакт · таблица',
  'tasks.sample.candidate.artifactMeta': 'Приостановлено до восстановления авторизации',
  'tasks.sample.candidate.body1': '# Пайплайн кандидатов',
  'tasks.sample.candidate.body2': 'Последняя успешная синхронизация: 2 дн назад',
  'tasks.sample.candidate.body3': 'Требуется действие: переподключите учётную запись источника.',
  'routines.title': 'Автоматизации',
  'routines.subtitle': 'Запланированные автоматизации, работающие без участия пользователя.',
  'routines.newAutomation': 'Новая автоматизация',
  'routines.loading': 'Загрузка…',
  'routines.empty': 'Автоматизаций пока нет.',
  'routines.emptyHint': 'Нажмите «Новая автоматизация», чтобы запланировать автономный запуск Agent.',
  'routines.runHistoryLoading': 'Загрузка запусков…',
  'routines.runHistoryEmpty': 'Запусков пока нет.',
  'routines.fieldName': 'Название',
  'routines.fieldNamePlaceholder': 'Утренняя сводка',
  'routines.fieldPrompt': 'Запрос',
  'routines.fieldPromptPlaceholder': 'Собрать вчерашнюю активность в GitHub и Linear и обобщить изменения.',
  'routines.fieldSchedule': 'Расписание',
  'routines.fieldMinute': 'Минута каждого часа',
  'routines.fieldTime': 'Время',
  'routines.fieldTimezone': 'Часовой пояс',
  'routines.fieldsetProject': 'Проект',
  'routines.kind.hourly': 'Ежечасно',
  'routines.kind.daily': 'Ежедневно',
  'routines.kind.weekdays': 'По будням',
  'routines.kind.weekly': 'Еженедельно',
  'routines.weekday.short.0': 'Вс',
  'routines.weekday.short.1': 'Пн',
  'routines.weekday.short.2': 'Вт',
  'routines.weekday.short.3': 'Ср',
  'routines.weekday.short.4': 'Чт',
  'routines.weekday.short.5': 'Пт',
  'routines.weekday.short.6': 'Сб',
  'routines.weekday.long.0': 'Воскресенье',
  'routines.weekday.long.1': 'Понедельник',
  'routines.weekday.long.2': 'Вторник',
  'routines.weekday.long.3': 'Среда',
  'routines.weekday.long.4': 'Четверг',
  'routines.weekday.long.5': 'Пятница',
  'routines.weekday.long.6': 'Суббота',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Запускается каждый час в :{minute}',
  'routines.describe.daily': 'Запускается ежедневно в {time} {tz}',
  'routines.describe.weekdays': 'Запускается с пн по пт в {time} {tz}',
  'routines.describe.weekly': 'Запускается каждый {day} в {time} {tz}',
  'routines.modeCreate': 'Создавать новый проект при каждом запуске',
  'routines.modeCreateHint': 'Новое изолированное рабочее пространство при каждом срабатывании.',
  'routines.modeReuse': 'Использовать существующий проект',
  'routines.modeReuseHint': 'Каждый запуск создаётся как новый разговор внутри проекта.',
  'routines.pickProject': '— Выберите проект —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ новый проект при каждом запуске',
  'routines.tagPaused': 'приостановлено',
  'routines.metaNext': 'далее: {when}',
  'routines.metaLast': 'последний:',
  'routines.triggerManual': 'вручную',
  'routines.triggerScheduled': 'по расписанию',
  'routines.openProject': 'Открыть проект',
  'routines.openProjectTitle': 'Открыть проект, в который записал этот запуск',
  'routines.runNow': 'Запустить сейчас',
  'routines.edit': 'Изменить',
  'routines.pause': 'Приостановить',
  'routines.resume': 'Возобновить',
  'routines.history': 'История',
  'routines.hideHistory': 'Скрыть историю',
  'routines.delete': 'Удалить',
  'routines.deleteTitle': 'Удалить эту автоматизацию',
  'routines.cancel': 'Отмена',
  'routines.save': 'Сохранить',
  'routines.saving': 'Сохранение…',
  'routines.create': 'Создать',
  'routines.creating': 'Создание…',
  'routines.status.queued': 'в очереди',
  'routines.status.running': 'выполняется',
  'routines.status.succeeded': 'успешно',
  'routines.status.failed': 'ошибка',
  'routines.status.canceled': 'отменено',
  'routines.confirmDelete': 'Удалить эту автоматизацию? Прошлые запуски и их проекты будут сохранены.',
  'routines.errorPickProject': 'Выберите проект для повторного использования или переключитесь на «Создавать новый при каждом запуске»',
  'routines.errorAgentEmptyOutput': 'Agent завершил работу, не создав никакого результата. Возможно, модель или провайдер вернули пустой ответ — проверьте журналы агента на наличие ошибок на стороне сервиса.',
  'entry.helpAria': 'Помощь',
  'entry.helpMenuAria': 'Меню помощи',
  'entry.helpGetHelp': 'Получить помощь на GitHub',
  'entry.helpSubmitFeature': 'Предложить функцию',
  'entry.helpWhatsNew': 'Что нового',
  'entry.helpDownloadDesktop': 'Скачать настольное приложение',
  'entry.githubStarLabel': 'Звезда',
  'entry.githubStarTitle': 'Поставьте нам звезду на GitHub',
  'entry.githubStarAria': 'Поставить Open Design звезду на GitHub',
  'entry.tabImageTemplates': 'Шаблоны изображений',
  'entry.tabVideoTemplates': 'Шаблоны видео',
  'promptTemplates.searchPlaceholder': 'Поиск шаблонов…',
  'promptTemplates.countLabel': '{n} результатов',
  'promptTemplates.emptyImage': 'Шаблоны промптов изображений не установлены.',
  'promptTemplates.emptyVideo': 'Шаблоны промптов видео не установлены.',
  'promptTemplates.emptyNoMatch': 'Нет шаблонов, соответствующих поиску.',
  'promptTemplates.attributionFooter': 'Адаптировано из публичных библиотек промптов. Каждая карточка ссылается на исходного автора.',
  'promptTemplates.openPreviewTitle': 'Открыть промпт и предпросмотр',
  'promptTemplates.sourcePrefix': 'Источник:',
  'promptTemplates.fetchError': 'Не удалось загрузить текст шаблона.',
  'promptTemplates.promptLabel': 'Текст промпта',
  'promptTemplates.copyPrompt': 'Копировать промпт',
  'promptTemplates.copyDone': 'Скопировано!',
  'promptTemplates.modelHint': 'Рекомендуемая модель: {model}',
  'promptTemplates.openSource': 'Открыть оригинал',
  'promptTemplates.openFullscreen': 'Открыть полноэкранный предпросмотр',
  'promptTemplates.closeFullscreen': 'Закрыть полноэкранный предпросмотр',
  'promptTemplates.allSources': 'Все источники',
  'promptTemplates.sourceFilterAria': 'Фильтр по источнику',
  'promptTemplates.retry': 'Повторить',
  'connectors.title': 'Коннекторы',
  'connectors.subtitle': 'Локальные и будущие источники данных для live-артефактов.',
  'connectors.account': 'Аккаунт',
  'connectors.noAccount': 'Не подключено',
  'connectors.tools': 'Инструменты',
  'connectors.connect': 'Подключить',
  'connectors.disconnect': 'Отключить',
  'connectors.authorizationPending': 'Ожидание авторизации...',
  'connectors.authorizationPendingHint': 'Завершите авторизацию в открытом окне.',
  'connectors.cancelAuthorization': 'Отмена',
  'connectors.configure': 'Настроить',
  'connectors.unavailable': 'Недоступно',
  'connectors.phaseStubTitle': 'API коннекторов появятся на этапе 3; это предварительный интерфейс.',
  'connectors.statusAvailable': 'Доступно',
  'connectors.statusConnected': 'Подключено',
  'connectors.statusError': 'Ошибка',
  'connectors.statusDisabled': 'Отключено',
  'connectors.gateTitle': 'Добавьте ключ Composio API, чтобы продолжить',
  'connectors.gateBody': 'Вставьте ключ выше и нажмите «Сохранить ключ», чтобы загрузить доступные интеграции.',
  'connectors.aboutLabel': 'О коннекторе',
  'connectors.detailsLabel': 'Детали',
  'connectors.statusLabel': 'Статус',
  'connectors.category.aiAgents': 'AI-агенты',
  'connectors.category.aiInfrastructure': 'AI-инфраструктура',
  'connectors.category.accounting': 'Бухгалтерия',
  'connectors.category.admin': 'Администрирование',
  'connectors.category.advertising': 'Реклама',
  'connectors.category.analytics': 'Аналитика',
  'connectors.category.automation': 'Автоматизация',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Календарь',
  'connectors.category.commerce': 'Коммерция',
  'connectors.category.communication': 'Коммуникации',
  'connectors.category.contacts': 'Контакты',
  'connectors.category.dataPlatform': 'Платформа данных',
  'connectors.category.database': 'База данных',
  'connectors.category.design': 'Дизайн',
  'connectors.category.developer': 'Инструменты разработчика',
  'connectors.category.documentation': 'Документация',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Образование',
  'connectors.category.email': 'Почта',
  'connectors.category.events': 'События',
  'connectors.category.fieldService': 'Выездное обслуживание',
  'connectors.category.finance': 'Финансы',
  'connectors.category.fitness': 'Фитнес',
  'connectors.category.forms': 'Формы',
  'connectors.category.gaming': 'Игры',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Гостеприимство',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Интеграция',
  'connectors.category.localization': 'Локализация',
  'connectors.category.logistics': 'Логистика',
  'connectors.category.maps': 'Карты',
  'connectors.category.marketing': 'Маркетинг',
  'connectors.category.media': 'Медиа',
  'connectors.category.meetings': 'Встречи',
  'connectors.category.nonprofit': 'НКО',
  'connectors.category.observability': 'Наблюдаемость',
  'connectors.category.payments': 'Платежи',
  'connectors.category.personal': 'Личное',
  'connectors.category.presentations': 'Презентации',
  'connectors.category.procurement': 'Закупки',
  'connectors.category.product': 'Продукт',
  'connectors.category.productivity': 'Продуктивность',
  'connectors.category.projectManagement': 'Управление проектами',
  'connectors.category.recruiting': 'Рекрутинг',
  'connectors.category.research': 'Исследования',
  'connectors.category.salesIntelligence': 'Аналитика продаж',
  'connectors.category.scheduling': 'Планирование',
  'connectors.category.search': 'Поиск',
  'connectors.category.security': 'Безопасность',
  'connectors.category.signing': 'Подписание',
  'connectors.category.social': 'Социальные сети',
  'connectors.category.spreadsheets': 'Таблицы',
  'connectors.category.storage': 'Хранилище',
  'connectors.category.support': 'Поддержка',
  'connectors.category.surveys': 'Опросы',
  'connectors.category.tasks': 'Задачи',
  'connectors.category.timeTracking': 'Учёт времени',
  'connectors.category.video': 'Видео',
  'connectors.category.whiteboard': 'Доска',
  'connectors.categoryLabel': 'Категория',
  'connectors.providerLabel': 'Провайдер',
  'connectors.toolsSection': 'Инструменты',
  'connectors.toolsLoading': 'Загрузка инструментов…',
  'connectors.noToolsAvailable': 'Инструменты ещё не загружены. Подключитесь, чтобы увидеть возможности интеграции.',
  'connectors.toolDetailsUnavailable': 'Сведения об инструментах недоступны, но этот коннектор сообщает о {n} инструментах.',
  'connectors.loadMoreTools': 'Загрузить ещё инструменты',
  'connectors.openDetailsAria': 'Открыть детали «{name}»',
  'connectors.toolsBadgeNone': 'Нет инструментов',
  'connectors.toolsBadgeOne': '{n} инструмент',
  'connectors.toolsBadgeMany': '{n} инструментов',
  'connectors.searchPlaceholder': 'Поиск коннекторов…',
  'connectors.searchAriaLabel': 'Поиск коннекторов по названию, провайдеру или инструменту',
  'connectors.searchClear': 'Очистить поиск',
  'connectors.emptyNoMatchTitle': 'Нет коннекторов по запросу «{query}»',
  'connectors.emptyNoMatchBody': 'Попробуйте другое ключевое слово или очистите поиск, чтобы вернуться к полному каталогу.',
  'connectors.emptyNoMatchAction': 'Очистить поиск',
  'newproj.tabPrototype': 'Прототип',
  'newproj.tabLiveArtifact': 'Новый live-артефакт',
  'newproj.tabDeck': 'Презентация',
  'newproj.tabTemplate': 'Шаблон',
  'newproj.tabMedia': 'Медиа',
  'newproj.tabOther': 'Другое',
  'newproj.titlePrototype': 'Новый прототип',
  'newproj.titleLiveArtifact': 'Новый live-артефакт',
  'newproj.titleDeck': 'Новая презентация',
  'newproj.titleTemplate': 'Начать с шаблона',
  'newproj.titleImage': 'Новое изображение',
  'newproj.titleVideo': 'Новое видео',
  'newproj.titleAudio': 'Новое аудио',
  'newproj.titleMedia': 'Новый медиафайл',
  'newproj.titleOther': 'Новый проект',
  'newproj.namePlaceholder': 'Название проекта',
  'newproj.fidelityLabel': 'Детализация',
  'newproj.fidelityWireframe': 'Вайрфрейм',
  'newproj.fidelityHigh': 'Высокая детализация',
  'newproj.toggleSpeakerNotes': 'Использовать заметки докладчика',
  'newproj.toggleSpeakerNotesHint': 'Меньше текста на слайдах — основные тезисы в заметках.',
  'newproj.toggleAnimations': 'Включить анимации',
  'newproj.toggleAnimationsHint': 'Добавить анимации (появление, наведение, переходы) поверх шаблона.',
  'newproj.targetPlatformsLabel': 'Целевые платформы',
  'newproj.targetPlatformsHint': 'Выберите одну или несколько. Адаптивный веб охватывает только контрольные точки браузера; добавьте iOS, Android, приложение для планшета или настольное приложение для нативных кросс-платформенных вариантов.',
  'newproj.platform.responsive.label': 'Адаптивный веб',
  'newproj.platform.responsive.hint': 'Единый веб-интерфейс, адаптированный для настольных, планшетных и мобильных браузеров',
  'newproj.platform.webDesktop.label': 'Настольный веб',
  'newproj.platform.webDesktop.hint': 'Продукт или целевая страница с ориентацией на браузер',
  'newproj.platform.mobileIos.label': 'Приложение iOS',
  'newproj.platform.mobileIos.hint': 'Фреймы iPhone и правила взаимодействия iOS',
  'newproj.platform.mobileAndroid.label': 'Приложение Android',
  'newproj.platform.mobileAndroid.hint': 'Фреймы Pixel и правила взаимодействия Material',
  'newproj.platform.tablet.label': 'Приложение для планшета',
  'newproj.platform.tablet.hint': 'Нативный интерфейс планшета с разделёнными представлениями',
  'newproj.platform.desktopApp.label': 'Настольное приложение',
  'newproj.platform.desktopApp.hint': 'Оформление приложения macOS/Windows',
  'newproj.surfaceOptionsLabel': 'Сопутствующие поверхности',
  'newproj.includeLandingPage': 'Включить целевую страницу',
  'newproj.includeLandingPageHint': 'Добавьте адаптивную маркетинговую страницу для рекламы, списков ожидания, кампаний запуска, загрузок приложения или описания продукта.',
  'newproj.includeOsWidgets': 'Включить виджеты ОС',
  'newproj.includeOsWidgetsHint': 'Добавьте нативные для платформы виджеты главного экрана, экрана блокировки или быстрого доступа для мобильных и планшетных приложений.',
  'newproj.includeOsWidgetsDisabledHint': 'Доступно, когда в качестве целевой платформы выбрано приложение iOS, Android или планшета.',
  'newproj.templateLabel': 'Шаблон',
  'newproj.noTemplatesTitle': 'Шаблонов пока нет',
  'newproj.noTemplatesBody': 'Откройте любой проект, затем используйте меню «Поделиться» в просмотре файлов, чтобы преобразовать его в шаблон. Шаблоны появятся здесь.',
  'newproj.savedTemplate': 'Сохраненный шаблон',
  'newproj.fileSingular': 'файл',
  'newproj.filePlural': 'файлов',
  'newproj.create': 'Создать',
  'newproj.locationLabel': 'Сохранить в',
  'newproj.locationDefault': 'Проекты Open Design',
  'newproj.locationExternalBase': 'Внешняя база',
  'newproj.createLiveArtifact': 'Создать live-артефакт',
  'newproj.createFromTemplate': 'Создать из шаблона',
  'newproj.createDisabledTitle': 'Сначала сохраните проект как шаблон (меню «Поделиться» в любом проекте).',
  'newproj.importClaudeZip': 'Импортировать ZIP-файл из Claude Design',
  'newproj.importClaudeZipTitle': 'Импортировать экспорт `.zip` из Claude Design',
  'newproj.importingClaudeZip': 'Импорт…',
  'newproj.privacyFooter': 'По умолчанию только вы можете видеть свой проект.',
  'newproj.designSystem': 'Дизайн-система',
  'newproj.dsNoneFreeform': 'Нет — произвольная форма',
  'newproj.dsNoneSubtitleEmpty': 'Без системных токенов, выбирайте свою палитру',
  'newproj.dsNoneSubtitleSelected': 'Пропустить системные токены. Агент выбирает свою палитру.',
  'newproj.dsCategoryFallback': 'Дизайн-система',
  'newproj.dsSearch': 'Поиск дизайн-систем…',
  'newproj.dsModeAria': 'Режим выбора',
  'newproj.dsModeSingle': 'Один',
  'newproj.dsModeMulti': 'Несколько',
  'newproj.dsNoneTitle': 'Нет — произвольная форма',
  'newproj.dsNoneSub': 'Пропустить системные токены. Агент выбирает свою палитру.',
  'newproj.dsEmpty': 'Нет дизайн-систем, соответствующих «{query}».',
  'newproj.dsFootSingular': 'только для вдохновения.',
  'newproj.dsFootPlural': 'только для вдохновения.',
  'newproj.dsFootClear': 'Очистить',
  'newproj.dsBadgeDefault': 'ПО УМОЛЧАНИЮ',
  'newproj.dsPrimaryFallback': 'Основной',
  'newproj.surfaceImage': 'Изображение',
  'newproj.surfaceVideo': 'Видео',
  'newproj.surfaceAudio': 'Аудио',
  'newproj.modelLabel': 'Модель',
  'newproj.modelSearch': 'Поиск моделей…',
  'newproj.modelEmpty': 'Нет подходящих моделей.',
  'newproj.modelRecommended': 'Рекомендовано',
  'newproj.modelMissingTitle': 'Выберите модель',
  'newproj.modelMissingSub': 'Выберите модель для этой среды.',
  'newproj.aspectLabel': 'Формат',
  'newproj.videoLengthLabel': 'Длина',
  'newproj.videoLengthSeconds': '{n}с',
  'newproj.audioKindLabel': 'Тип аудио',
  'newproj.audioKindMusic': 'Музыка',
  'newproj.audioKindSpeech': 'Речь / TTS',
  'newproj.audioKindSfx': 'Звуковые эффекты',
  'newproj.audioDurationLabel': 'Длительность',
  'newproj.audioDurationSeconds': '{n}с',
  'newproj.voiceLabel': 'Голос',
  'newproj.voicePlaceholder': 'Voice id провайдера, опционально',
  'newproj.connectorsLabel': 'Коннекторы',
  'newproj.connectorsHint': 'Источники данных, из которых артефакт может получать данные.',
  'newproj.connectorsEmptyTitle': 'Коннекторы не настроены',
  'newproj.connectorsEmptyBody': 'Подключите источник данных, чтобы live-артефакт использовал реальные данные вместо заглушек.',
  'newproj.connectorsEmptyCta': 'Настроить коннекторы →',
  'newproj.connectorsLoading': 'Загрузка коннекторов…',
  'newproj.connectorsCountOne': 'Подключено: {n}',
  'newproj.connectorsCountMany': 'Подключено: {n}',
  'newproj.connectorsManage': 'Управлять',
  'newproj.promptTemplateLabel': 'Эталонный шаблон',
  'newproj.promptTemplateNoneTitle': 'Без шаблона — свой бриф',
  'newproj.promptTemplateNoneSub': 'Пропустить галерею и описать самостоятельно',
  'newproj.promptTemplateRefSub': 'Эталонный шаблон',
  'newproj.promptTemplateSearch': 'Поиск шаблонов…',
  'newproj.promptTemplateEmpty': 'Шаблоны для этого формата ещё не добавлены.',
  'newproj.promptTemplateBodyLabel': 'Промпт (можно править)',
  'newproj.promptTemplateOptimizeHint': 'Меняйте всё что нужно — правки попадут в бриф агента.',
  'newproj.promptTemplateBodyEmpty': 'Пустое тело — агент не получит шаблонную референцию.',
  'newproj.deleteTemplateTitle': 'Удалить шаблон',
  'newproj.deleteTemplateConfirm': 'Удалить «{name}»? Это действие невозможно отменить.',
  'newproj.deleteTemplateConfirmCta': 'Удалить шаблон',
  'newproj.deleteTemplateError': 'Не удалось удалить шаблон. Попробуйте ещё раз.',
  'designs.subRecent': 'Недавние',
  'designs.subYours': 'Ваши дизайны',
  'designs.filterAria': 'Фильтр проектов',
  'designs.searchPlaceholder': 'Поиск…',
  'designs.emptyNoProjects': 'Проектов пока нет.',
  'designs.emptyNoMatch': 'Нет проектов, соответствующих вашему поиску.',
  'designs.deleteTitle': 'Удалить проект',
  'designs.deleteConfirm': 'Удалить «{name}»?',
  'designs.cardFreeform': 'произвольная форма',
  'designs.badgeLive': 'В эфире',
  'designs.liveArtifactBadgesAria': 'Бейджи live-артефактов',
  'designs.liveCount': '{n} в эфире',
  'designs.statusLive': 'Live-артефакт',
  'designs.statusArchived': 'Архивирован',
  'designs.statusError': 'Ошибка',
  'designs.statusRefreshing': 'Обновление…',
  'designs.statusRefreshFailed': 'Не удалось обновить',
  'designs.statusRefreshed': 'Обновлено',
  'designs.status.notStarted': 'Не начато',
  'designs.status.queued': 'В очереди',
  'designs.status.running': 'Выполняется',
  'designs.status.awaitingInput': 'Нужен ввод',
  'designs.status.succeeded': 'Завершено',
  'designs.status.published': 'Опубликовано',
  'designs.status.failed': 'Ошибка',
  'designs.status.canceled': 'Отменено',
  'designs.viewToggleAria': 'Режим просмотра',
  'designs.viewGrid': 'Вид сеткой',
  'designs.viewKanban': 'Вид доской',
  'designs.kanbanEmptyColumn': 'Нет дизайнов',
  'designs.deleteAria': 'Удалить проект {name}',
  'designs.menuMore': 'Другие действия',
  'designs.menuRename': 'Переименовать',
  'designs.menuDelete': 'Удалить',
  'designs.renamePrompt': 'Новое имя для «{name}»',
  'designs.selectMode': 'Выбрать',
  'designs.cancelSelect': 'Отмена',
  'designs.deleteSelected': 'Удалить выбранное',
  'designs.selectedCount': 'Выбрано: {n}',
  'designs.deleteSelectedConfirm': 'Удалить проектов: {n}?',
  'designs.deleteSelectedSuccess': 'Проектов удалено: {n}.',
  'designs.deleteSelectedPartial': 'Удалено проектов: {deleted}; не удалось: {failed}.',
  'designs.tagPrototype': 'Прототип',
  'designs.tagLiveArtifact': 'Живой артефакт',
  'designs.tagSlide': 'Слайд',
  'designs.tagMedia': 'Медиа',
  'designs.renameTitle': 'Переименовать проект',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Отмена',
  'examples.typeLabel': 'Тип',
  'examples.surfaceLabel': 'Поверхность',
  'examples.surfaceWeb': 'Веб',
  'examples.surfaceImage': 'Изображение',
  'examples.surfaceVideo': 'Видео',
  'examples.surfaceAudio': 'Аудио',
  'examples.scenarioLabel': 'Сценарий',
  'examples.modeAll': 'Все',
  'examples.modePrototypeDesktop': 'Прототипы · Десктоп',
  'examples.modePrototypeMobile': 'Прототипы · Мобильные',
  'examples.modeDeck': 'Презентации',
  'examples.modeDocument': 'Документы и шаблоны',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'В эфире',
  'examples.scenarioGeneral': 'Общее',
  'examples.scenarioEngineering': 'Инженерия',
  'examples.scenarioProduct': 'Продукт',
  'examples.scenarioDesign': 'Дизайн',
  'examples.scenarioMarketing': 'Маркетинг',
  'examples.scenarioSales': 'Продажи',
  'examples.scenarioFinance': 'Финансы',
  'examples.scenarioHr': 'HR',
  'examples.scenarioOperations': 'Операции',
  'examples.scenarioSupport': 'Поддержка',
  'examples.scenarioLegal': 'Юридический',
  'examples.scenarioEducation': 'Образование',
  'examples.scenarioPersonal': 'Личное',
  'examples.searchPlaceholder': 'Поиск примеров…',
  'examples.searchAria': 'Поиск примеров по имени',
  'examples.emptyNoSkills': 'Нет доступных навыков. Демон запущен?',
  'examples.emptyNoMatch': 'Нет примеров, соответствующих этим фильтрам.',
  'examples.openPreview': '⤢ Открыть предпросмотр',
  'examples.loadingPreview': 'Загрузка предпросмотра…',
  'examples.hoverPreview': 'Наведите для предпросмотра',
  'examples.usePrompt': 'Использовать этот запрос',
  'examples.previewModalTitle': 'Открыть полный предпросмотр (модально)',
  'examples.shareTitle': 'Поделиться этим примером',
  'examples.shareLoadFirst': 'Сначала наведите для загрузки предпросмотра',
  'examples.unavailablePlaceholder': 'Нет встроенного предпросмотра {kind} — откройте, чтобы узнать больше',
  'examples.shareUnavailable': 'Нет встроенного предпросмотра {kind} для отправки',
  'examples.shareMenu': 'Поделиться ▾',
  'examples.exportPdfAllSlides': 'Экспорт в PDF (все слайды)',
  'examples.exportPptxLocked': 'Экспорт в PPTX… (сначала откройте шаблон)',
  'examples.tagSlideDeck': 'Презентация',
  'examples.tagTemplate': 'Шаблон',
  'examples.tagDesignSystem': 'Дизайн-система',
  'examples.tagMobilePrototype': 'Мобильный прототип',
  'examples.tagDesktopPrototype': 'Десктопный прототип',
  'examples.tagImage': 'Изображение',
  'examples.tagVideo': 'Видео',
  'examples.tagAudio': 'Аудио',
  'examples.previewLabel': 'Предпросмотр',
  'ds.surfaceLabel': 'Поверхность',
  'ds.surfaceWeb': 'Веб',
  'ds.surfaceImage': 'Изображение',
  'ds.surfaceVideo': 'Видео',
  'ds.surfaceAudio': 'Аудио',
  'ds.searchPlaceholder': 'Поиск дизайн-систем…',
  'ds.emptyNoMatch': 'Нет дизайн-систем, соответствующих вашему поиску.',
  'ds.badgeDefault': 'ПО УМОЛЧАНИЮ',
  'ds.preview': 'Предпросмотр',
  'ds.previewTitle': 'Предпросмотр дизайн-системы',
  'ds.categoryAll': 'Все',
  'ds.categoryUncategorized': 'Без категории',
  'ds.showcase': 'Витрина',
  'ds.tokens': 'Токены',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Загрузка DESIGN.md…',
  'avatar.title': 'Аккаунт и настройки',
  'avatar.localCli': 'Локальный CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Использовать локальный CLI',
  'avatar.useApi': 'Использовать API · BYOK',
  'avatar.codeAgent': 'Код-агент',
  'avatar.rescan': 'Пересканировать PATH',
  'avatar.amrConsole': 'Аккаунт AMR',
  'avatar.amrConsoleMeta': 'Баланс и пополнение',
  'avatar.settings': 'Настройки',
  'avatar.backToProjects': 'Назад к проектам',
  'avatar.metaActive': 'активно',
  'avatar.metaOffline': 'офлайн',
  'avatar.metaSelected': 'выбрано',
  'avatar.noAgentSelected': 'агент не выбран',
  'avatar.modelSection': 'Модель',
  'avatar.modelLabel': 'Модель',
  'avatar.reasoningLabel': 'Рассуждения',
  'avatar.customSuffix': '(пользовательская)',
  'socialShare.openDesignSection': 'Поделиться Open Design',
  'socialShare.openDesignTitle': 'Open Design на GitHub',
  'socialShare.openDesignText': 'Open Design — это рабочее пространство с открытым исходным кодом для создания, редактирования, развёртывания и передачи дизайн-артефактов.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'ПОДЕЛИТЬСЯ В СОЦСЕТЯХ',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': 'Создано с помощью Open Design: {title}. Посмотрите развёрнутый артефакт и поставьте звезду репозиторию: {repo}',
  'socialShare.projectCopyText': 'Создано с помощью Open Design: {title}\n{url}\nРепозиторий Open Design: {repo}',
  'socialShare.deployFirst': 'Развернуть, затем поделиться…',
  'socialShare.copied': 'Скопировано',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Переключить CLI / модель',
  'inlineSwitcher.chipCli': 'Локальный CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'по умолчанию',
  'inlineSwitcher.noAgent': 'агент не выбран',
  'inlineSwitcher.modeLabel': 'Режим',
  'inlineSwitcher.agentLabel': 'Агент',
  'inlineSwitcher.providerLabel': 'Провайдер',
  'inlineSwitcher.modelLabel': 'Модель',
  'inlineSwitcher.useCli': 'Использовать локальный CLI',
  'inlineSwitcher.useByok': 'Использовать собственный API-ключ',
  'inlineSwitcher.daemonOffline': 'Демон офлайн — откройте настройки',
  'inlineSwitcher.noAgentsDetected': 'CLI не найден в PATH',
  'inlineSwitcher.openSettingsForModel': 'Настройте провайдера в Настройках',
  'inlineSwitcher.missingApiKey': 'API-ключ не задан — откройте Настройки.',
  'inlineSwitcher.openFullSettings': 'Открыть настройки выполнения',
  'inlineSwitcher.customSuffix': '(пользовательская)',
  'project.backToProjects': 'Назад к проектам',
  'project.metaFreeform': 'произвольная форма',
  'project.customInstructions': 'Инструкции проекта',
  'project.customInstructionsPlaceholder': 'Инструкции для этого проекта (добавляются к каждому сообщению)…',
  'project.resizeChatPanel': 'Изменить размер панели чата',
  'project.instructionsActive': 'Активно — добавляется в каждое сообщение',
  'chat.tabChat': 'Чат',
  'chat.tabComments': 'Комментарии',
  'chat.commentsSoon': 'Комментарии — скоро',
  'chat.comments.attached': 'Прикреплены к чату',
  'chat.comments.emptyAttached': 'Нет прикреплённых комментариев.',
  'chat.comments.saved': 'Сохранённые комментарии',
  'chat.comments.emptySaved': 'Сохранённых комментариев нет.',
  'chat.comments.add': 'Добавить',
  'chat.comments.addAll': 'Добавить все',
  'chat.comments.remove': 'Удалить',
  'chat.comments.placeholder': 'Оставьте комментарий к этому элементу…',
  'chat.comments.addSend': 'Добавить и отправить',
  'chat.comments.updateSend': 'Обновить и отправить',
  'chat.comments.removeAttachment': 'Открепить комментарий',
  'chat.comments.removeAttachmentAria': 'Открепить комментарий для {name}',
  'chat.comments.comment': 'Комментарий',
  'chat.comments.sendToChat': 'Отправить в чат',
  'chat.comments.sending': 'Отправка…',
  'chat.comments.edit': 'Редактировать',
  'chat.comments.select': 'Выбрать',
  'chat.comments.selectAll': 'Выбрать всё',
  'chat.comments.deselect': 'Отменить выбор',
  'chat.comments.nSelected': 'Выбрано: {n}',
  'chat.comments.pin': 'Закрепить',
  'chat.comments.addNote': 'Добавить заметку',
  'chat.comments.savedToast': 'Комментарий сохранён',
  'chat.comments.pinSavedToast': 'Закрепление сохранено',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': 'Захвачено элементов: {n}',
  'chat.comments.clear': 'Очистить',
  'chat.comments.targetImage': 'Изображение',
  'chat.comments.targetControl': 'Элемент управления',
  'chat.comments.targetLink': 'Ссылка',
  'chat.comments.targetText': 'Текст',
  'chat.comments.targetSection': 'Раздел',
  'chat.comments.targetPage': 'Страница',
  'chat.comments.targetArea': 'Область',
  'chat.annotationNotePlaceholder': 'Добавьте заметку к этой пометке',
  'chat.annotationAttachImage': 'Прикрепить изображение',
  'chat.annotationAttachedImages': 'Прикреплённые изображения',
  'chat.annotationAttachedRemove': 'Удалить последнее изображение',
  'chat.annotationAddToInput': 'Добавить в ввод',
  'chat.annotationAddingToInput': 'Добавление...',
  'chat.annotationQueue': 'Очередь',
  'chat.annotationQueueing': 'Добавление в очередь...',
  'chat.annotationSending': 'Отправка...',
  'chat.annotationSendDisabledReason': 'Сейчас выполняется задача',
  'chat.annotationPreviewMissing': 'Не удалось сделать предпросмотр. Попробуйте ещё раз.',
  'chat.annotationPreviewMissingInk': 'Не удалось сделать предпросмотр. Попробуйте ещё раз, чтобы не отправить только рукописные пометки.',
  'chat.annotationTimeout': 'Истекло время отправки аннотации. Попробуйте ещё раз.',
  'chat.annotationFailed': 'Не удалось отправить аннотацию. Попробуйте ещё раз.',
  'chat.annotationProjectCreateFailed': 'Не удалось создать проект, поэтому аннотация не была отправлена.',
  'chat.annotationUploadFailed': 'Не удалось загрузить вложение. Попробуйте ещё раз.',
  'chat.conversationsTitle': 'Разговоры',
  'chat.conversationsAria': 'История разговоров',
  'chat.newConversation': 'Новый разговор',
  'chat.newConversationsTitle': 'Новый разговор',
  'chat.conversationsHeading': 'Разговоры',
  'chat.new': 'Новый',
  'chat.emptyConversations': 'Разговоров пока нет.',
  'chat.deleteConversation': 'Удалить разговор',
  'chat.renameConversationLabel': 'Переименовать «{title}»',
  'chat.deleteConversationConfirm': 'Удалить «{title}»? Это удалит его сообщения.',
  'chat.untitledConversation': 'Разговор без названия',
  'chat.forkedConversationTitle': 'Форк {title}',
  'chat.forkConversationFailed': 'Не удалось создать форк этого разговора.',
  'chat.startTitle': 'Начать разговор',
  'chat.startHint': 'Опишите, что хотите сгенерировать, или начните с одного из этих примеров:',
  'chat.fillInputTitle': 'Нажмите, чтобы заполнить ввод',
  'chat.jumpToLatest': 'Перейти к последнему',
  'chat.scrollToLatest': 'Прокрутить к последнему',
  'chat.you': 'Вы',
  'chat.openFile': 'Открыть {name}',
  'chat.copyPrompt': 'Скопировать запрос',
  'chat.copyErrorDiagnostic': 'Скопировать диагностику ошибки',
  'chat.copyDone': 'Скопировано!',
  'chat.inspect.noEditableTargets': 'Редактируемый текст или объекты стиля не найдены.',
  'chat.inspect.noCommentTargets': 'Текст или визуальные объекты для комментирования не найдены.',
  'chat.inspect.editHint': 'Выберите текст или объект стиля в предпросмотре, чтобы отредактировать его.',
  'chat.inspect.commentHint': 'Выберите текст или область в предпросмотре, чтобы оставить комментарий.',
  'chat.composerPlaceholder': 'Опишите, что хотите сгенерировать…',
  'chat.activeFileEditingLabel': 'Редактирование',
  'chat.activeFilePlaceholder': 'Попросите Open Design изменить {file}...',
  'chat.designArtifactsShowMore': 'Показать еще {count} файлов дизайна',
  'chat.mode.chat.label': 'Спросить',
  'chat.mode.chat.title': 'Режим вопросов',
  'chat.mode.chat.summary': 'Для быстрых ответов, правок, планирования и обсуждения без обязательного создания дизайн-артефакта.',
  'chat.mode.chat.solves': 'Используйте его, чтобы уточнять идеи, улучшать промпты, сравнивать варианты или задавать вопросы о текущей работе.',
  'chat.mode.chat.query1': 'Суммируй этот черновик и покажи пробелы.',
  'chat.mode.chat.query2': 'Помоги выбрать лучшую структуру для этой лендинговой страницы.',
  'chat.mode.chat.query3': 'Проверь этот дизайн и предложи конкретные улучшения.',
  'chat.mode.design.label': 'Дизайн',
  'chat.mode.design.title': 'Режим дизайна',
  'chat.mode.design.summary': 'Для создания или изменения конкретных результатов: страниц, прототипов, live-артефактов, слайдов, изображений, видео, HyperFrames, аудио, дашбордов и файлов проекта.',
  'chat.mode.design.solves': 'Используйте его, когда Open Design должен сгенерировать файлы, обновить workspace или превратить бриф в мультимодальные deliverables.',
  'chat.mode.design.query1': 'Создай лендинг запуска продукта и прототип HyperFrames по этому брифу.',
  'chat.mode.design.query2': 'Сделай инвестиционный deck на 10 слайдов с заметками спикера.',
  'chat.mode.design.query3': 'Сгенерируй идеи изображений, видео и аудио для этой кампании.',
  'chat.mode.cardBestFor': 'Подходит для',
  'chat.mode.cardTry': 'Примеры запросов',
  'chat.composerHint': '⌘/Ctrl + Enter для отправки · укажите цель, содержание, стиль и формат',
  'chat.cliSettingsTitle': 'Настройки CLI и модели',
  'chat.cliSettingsAria': 'Открыть настройки CLI и модели',
  'chat.attachTitle': 'Прикрепить файлы (или вставить / перетащить)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Прикрепить файлы',
  'chat.importTitle': 'Импортировать источники (скоро)',
  'chat.importLabel': 'Импорт',
  'chat.importComingSoon': 'Скоро',
  'chat.importSoon': 'Скоро',
  'chat.importFig': 'Загрузить .fig файл',
  'chat.importGitHub': 'Подключить GitHub',
  'chat.importWeb': 'Захватить веб-элемент',
  'chat.importFolder': 'Ссылка на папку с кодом',
  'chat.importSkills': 'Навыки и дизайн-системы',
  'chat.importProject': 'Сослаться на другой проект',
  'chat.importDesignSystemHeader': 'Выберите дизайн-систему',
  'chat.importDesignSystemBack': 'Назад',
  'chat.importDesignSystemSearch': 'Поиск дизайн-систем…',
  'chat.importDesignSystemEmpty': 'Нет дизайн-систем, соответствующих "{query}"',
  'chat.importDesignSystemNone': 'Нет — свободно',
  'chat.importDesignSystemNoneSub': 'Не привязываться к системе в этот раз',
  'chat.importDesignSystemActive': 'Активна',
  'chat.importDesignSystemSwitched': 'Дизайн-система переключена на {title}',
  'chat.importDesignSystemFailed': 'Не удалось сменить дизайн-систему. Попробуйте снова.',
  'chat.importDesignSystemLoadFailed': 'Не удалось загрузить дизайн-системы.',
  'browserUse.title': 'Вдохновение',
  'browserUse.summary': 'Веб-действий: {count}, с приоритетом на извлечение ресурсов, дизайн-язык, анимацию, визуальные проверки и структуру компонентов.',
  'browserUse.searchAria': 'Поиск вдохновения',
  'browserUse.searchPlaceholder': 'Поиск по скриншотам, шрифтам, цветам, a11y...',
  'browserUse.empty': 'Нет подходящего вдохновения',
  'browserUse.unavailable': 'Вдохновение здесь недоступно',
  'browserUse.added': 'Добавлено в редактор',
  'browserUse.category.assets': 'Извлечение ресурсов',
  'browserUse.category.tokens': 'Дизайн-язык',
  'browserUse.category.motion': 'Анимация',
  'browserUse.category.visual': 'Визуальные проверки',
  'browserUse.category.structure': 'Компоненты',
  'browserUse.category.project': 'Запуск проекта',
  'browserUse.category.general': 'Общие',
  'browserUse.input.none': 'Нет ввода',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Необязательный селектор',
  'browserUse.input.requirementSelector': 'Требование, необязательный селектор',
  'browserUse.input.selectorOptional': 'Необязательный селектор',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Селектор, scale=2',
  'browserUse.input.gridOverlay': '12 колонок, макс. 1200, отступ 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, домен или поисковые запросы',
  'browserUse.input.selector': 'Селектор',
  'browserUse.input.selectorText': 'Селектор и текст',
  'browserUse.input.scroll': 'Пиксели, верх, низ или страница',
  'browserUse.input.terminalRun': 'Команда, таймаут 120 с',
  'browserUse.input.command': 'Команда',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Лучшие кандидаты логотипа из шапки, навигации, имён классов, позиции, OG-изображения и запасного варианта favicon.',
  'browserUse.action.list_images.output': 'Все изображения img, srcset, source и фоновые изображения CSS с размерами и alt-текстом.',
  'browserUse.action.download_assets.output': 'Папка со скачанными ресурсами плюс _manifest.json с поддержкой referer и cookie.',
  'browserUse.action.extract_svgs.output': 'Встроенные SVG и связанные файлы .svg, сохранённые как отдельные SVG-файлы.',
  'browserUse.action.optimize_svgs.output': 'Оптимизированные SVG-файлы плюс коэффициент сжатия.',
  'browserUse.action.extract_colors.output': 'Взвешенная палитра плюс CSS-переменные цвета :root в виде palette.json и palette.html.',
  'browserUse.action.extract_fonts.output': 'Основные семейства шрифтов, размеры, начертания и правила @font-face в виде typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Радиус, тень, отступы и CSS-переменные в виде tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Типографическая шкала заголовков, основного текста и кнопок с размером, начертанием, высотой строки и соотношениями.',
  'browserUse.action.extract_buttons.output': 'Библиотека стилей кнопок без дубликатов в виде buttons.html и buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Контейнеры grid и flex, направление, отступы, колонки и максимальная ширина в виде layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Адаптивные точки останова медиазапросов в виде breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'CSS-градиенты в виде gradients.css, gradients.json и HTML-предпросмотра.',
  'browserUse.action.extract_shadows.output': 'Тени блоков, тени текста и отбрасываемые тени в виде shadows.json плюс предпросмотр.',
  'browserUse.action.extract_easings.output': 'Функции плавности переходов и анимаций в виде easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js и style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, правила transition и transform, обнаруженные библиотеки движения, motion.css и motion.json.',
  'browserUse.action.validate_view.output': 'Пути к снимкам экрана плюс структурированные визуальные проблемы и проблемы вёрстки.',
  'browserUse.action.audit_layout.output': 'Дефекты вёрстки, включая переполнение, границы, наложение и обрезанный текст, в виде audit.json.',
  'browserUse.action.audit_accessibility.output': 'Проблемы доступности с селекторами, метками, ролями, фокусом, контрастом и снимками экрана, где это полезно.',
  'browserUse.action.responsive_screenshots.output': 'Снимки экрана для мобильных 390, планшетов 834 и десктопа 1440.',
  'browserUse.action.screenshot_full.output': 'Снимок всей страницы за пределами области просмотра.',
  'browserUse.action.screenshot_element.output': 'Снимок одного элемента по умолчанию в масштабе 2x.',
  'browserUse.action.screenshot_with_grid.output': 'Снимок экрана с наложением сетки вёрстки.',
  'browserUse.action.screenshot_dark_mode.output': 'Снимок экрана с prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Одностраничное руководство по стилю с цветами, типографической шкалой, радиусом и тенями.',
  'browserUse.action.extract_html.output': 'Чистый автономный HTML без script, noscript или встроенных атрибутов событий.',
  'browserUse.action.extract_component_inventory.output': 'Повторяющиеся шаблоны компонентов, селекторы, количество и снимки экрана.',
  'browserUse.action.extract_copy.output': 'Заголовки, призывы к действию, основной текст и описания в виде copy.md и copy.json.',
  'browserUse.action.extract_nav.output': 'Основная навигация и ссылки в подвале в виде sitemap.md и nav.json.',
  'browserUse.action.extract_forms.output': 'Поля форм, метки, подсказки валидации и действия отправки в виде forms.json.',
  'browserUse.action.run_project.output': 'Обнаруженный URL сервера разработки, открытый на вкладке Browser.',
  'browserUse.action.detect_project.output': 'Фреймворк, менеджер пакетов, команда установки, команда запуска и порт.',
  'browserUse.action.page_info.output': 'URL, заголовок, описание, OG-изображение, цвет темы, favicon и viewport.',
  'browserUse.action.snapshot.output': 'До 120 видимых интерактивных и текстовых элементов с тегом, меткой, href и координатами.',
  'browserUse.action.navigate.output': 'Открыть страницу и вернуть page_info.',
  'browserUse.action.click.output': 'Нажать на первый подходящий элемент после прокрутки к нему.',
  'browserUse.action.type_text.output': 'Заполнить поле ввода и отправить события input и change.',
  'browserUse.action.scroll.output': 'Текущая и максимальная позиция прокрутки.',
  'browserUse.action.extract_og_metadata.output': 'Meta-заголовок, описание, канонический URL, карточки OG/Twitter, изображение для соцсетей и цвет темы.',
  'browserUse.action.terminal_run.output': 'stdout, stderr и код выхода.',
  'browserUse.action.terminal_run_background.output': 'Идентификатор фоновой задачи и недавний вывод.',
  'browserUse.action.terminal_read.output': 'Недавний вывод общего терминала.',
  'chat.designToolbox.title': 'Дизайн-инструменты',
  'chat.designToolbox.tooltip': 'Дизайн-инструменты',
  'chat.designToolbox.aria': 'Открыть дизайн-инструменты',
  'chat.designToolbox.searchPlaceholder': 'Поиск навыков / MCP / плагинов / коннекторов / файлов дизайна...',
  'chat.designToolbox.searchAria': 'Поиск ресурсов в дизайн-инструментах',
  'chat.designToolbox.followupSection': 'Уточнение',
  'chat.designToolbox.resourcesSection': 'Глобальные ресурсы',
  'chat.designToolbox.selected': 'Выбрано',
  'chat.designToolbox.noResources': 'Ресурсы по запросу «{query}» не найдены.',
  'chat.designToolbox.badge.video': 'Видео',
  'chat.designToolbox.badge.image': 'Изображение',
  'chat.designToolbox.badge.motion': 'Анимация',
  'chat.designToolbox.badge.polish': 'Доработка',
  'chat.designToolbox.action.auto-match.title': 'Подобрать следующий шаг',
  'chat.designToolbox.action.auto-match.badge': 'Подобрать',
  'chat.designToolbox.action.auto-match.description': 'Сначала задайте планку вкуса, затем подберите навыки, MCP, плагины, коннекторы и файлы.',
  'chat.designToolbox.action.motion.title': 'Добавить анимацию / движение',
  'chat.designToolbox.action.motion.badge': 'Анимация',
  'chat.designToolbox.action.motion.description': 'Добавьте анимацию появления, прокрутки, перехода состояний и микровзаимодействий к текущему HTML или элементу страницы.',
  'chat.designToolbox.action.motion-polish.title': 'Доработать анимацию',
  'chat.designToolbox.action.motion-polish.badge': 'Тайминг',
  'chat.designToolbox.action.motion-polish.description': 'Проверьте тайминг, плавность, производительность и резервные варианты для reduced-motion в существующей анимации.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Убрать ИИ-ощущение',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Вкус',
  'chat.designToolbox.action.anti-ai-polish.description': 'Уберите шаблонность, ИИ-градиенты, дешёвые стопки карточек и расплывчатые формулировки.',
  'chat.designToolbox.action.visual-polish.title': 'Доработка дизайна / готово к выпуску',
  'chat.designToolbox.action.visual-polish.badge': 'Доработка',
  'chat.designToolbox.action.visual-polish.description': 'Проверьте визуальную иерархию, типографику, отступы, адаптивность, доступность и качество поставки.',
  'chat.designToolbox.action.image-gen.title': 'Сгенерировать изображения / визуальные референсы',
  'chat.designToolbox.action.image-gen.badge': 'Изображение',
  'chat.designToolbox.action.image-gen.description': 'Сгенерируйте референсы секций, ассеты, иконки, изображения для соцсетей или мудборд для текущей страницы.',
  'chat.designToolbox.action.video-gen.title': 'Сгенерировать видео / сценарий движения',
  'chat.designToolbox.action.video-gen.badge': 'Видео',
  'chat.designToolbox.action.video-gen.description': 'Превратите дизайн в короткое видео, раскадровку Remotion / Hyperframes или готовый к генерации промпт.',
  'chat.designToolbox.kind.skill': 'Навык',
  'chat.designToolbox.kind.plugin': 'Плагин',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Шаблон MCP',
  'chat.designToolbox.kind.connector': 'Коннектор',
  'chat.designToolbox.kind.designFile': 'Файл дизайна',
  'chat.designToolbox.context.browser': 'Браузер',
  'chat.designToolbox.context.designFiles': 'Файлы дизайна',
  'chat.designToolbox.context.designSystem': 'Дизайн-система',
  'chat.designToolbox.context.folder': 'Папка',
  'chat.designToolbox.context.terminal': 'Терминал',
  'chat.designToolbox.context.sideChat': 'Боковой чат',
  'chat.designToolbox.context.liveArtifact': 'Живой артефакт',
  'chat.designToolbox.context.file': 'Файл',
  'chat.designToolbox.prompt.contextGeneric': 'Текущая цель: открытый в данный момент HTML / файл дизайна / веб-элемент.',
  'chat.designToolbox.prompt.contextSpecific': 'Текущая цель: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Сохраните намерение, уже заданное в редакторе: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Выбранный навык: {skill}. Используйте его как основной рабочий процесс для этого хода.',
  'chat.designToolbox.prompt.noSkill': 'Если конкретный навык не подошёл, сначала выберите оптимальную комбинацию из доступных навыков, MCP, плагинов, коннекторов и файлов дизайна.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Выступите в роли оркестратора креативного директора и завершите рабочий процесс дизайна:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Сначала определите, что значит «хороший дизайн»: аудитория, бизнес-цель, ощущение бренда, референсы стиля, плотность информации, стандарты цвета/типографики/анимации/ассетов, а также шаблоны AI/заготовок, которых следует избегать.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Выполните поиск и подбор по всему индексу ресурсов выше. Не используйте только рекомендации дизайн-инструментов; при необходимости сочетайте навыки, MCP, плагины, коннекторы и файлы дизайна.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. Если цель или планка эстетики всё ещё неясна, направьте меня с помощью ограниченного набора вариантов или интерфейса в виде формы и укажите рекомендуемое значение по умолчанию. Если всё достаточно ясно, выполните следующий шаг напрямую.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Завершите процесс в таком порядке: диагностика -> направление стиля -> выбор ресурсов -> конкретное редактирование/генерация -> проверка. На каждом шаге объясняйте, почему выбраны эти ресурсы и что нужно подтвердить далее.',
  'chat.designToolbox.prompt.motion': 'Добавьте к текущему HTML / элементу страницы качественную анимацию: выберите 1-2 наиболее полезных момента появления, прокрутки, перехода состояний или микровзаимодействия. Сохраняйте сдержанность, предпочитайте transform / opacity и включайте резервные варианты prefers-reduced-motion.',
  'chat.designToolbox.prompt.motionPolish': 'Проверьте и доработайте существующие тайминги анимации, плавность, производительность и доступность. Уберите резкую, дешёвую или ухудшающую читаемость анимацию; при необходимости используйте более выверенную временную шкалу.',
  'chat.designToolbox.prompt.antiAiPolish': 'Сделайте один проход доработки против «AI-ощущения»: уберите шаблонные макеты, дешёвые градиенты/свечения, бессмысленные стопки карточек и расплывчатые формулировки. Сохраните информацию и сделайте так, чтобы это выглядело работой настоящего дизайнера.',
  'chat.designToolbox.prompt.visualPolish': 'Доработайте этот дизайн до состояния готовности к выпуску: проверьте иерархию, типографику, отступы, адаптивное поведение, состояния кнопок, пустые состояния, состояния загрузки и ошибок, а также доступность; сразу исправьте самые важные проблемы.',
  'chat.designToolbox.prompt.imageGen': 'Создайте следующий план визуальных ресурсов для этого дизайна: референсы секций, hero-ресурсы, иллюстрации, иконки, изображения для соцсетей или мудборд. Сначала определите, какого изображения не хватает, затем предоставьте исполнимые промпты для генерации / план файлов.',
  'chat.designToolbox.prompt.videoGen': 'Разверните этот дизайн в сторону видео: создайте раскадровку короткого видео, структуру кадров Hyperframes / Remotion или готовый промпт для Sora/fal. Предпочтительно, чтобы существующий HTML / содержимое страницы естественно превращалось в кадры.',
  'chat.designToolbox.prompt.useSkill': 'Используйте {skill} в текущем дизайне.',
  'chat.designToolbox.prompt.skillInstruction': 'Сначала определите лучшую следующую цель, затем выполните один конкретный проход. Если это зависит от внешних ресурсов или API, предоставьте работоспособный запасной вариант или укажите, что мне нужно предоставить.',
  'chat.designToolbox.prompt.selectedResource': 'Выбранный ресурс: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Описание ресурса: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Используйте этот плагин как основной контекст для текущего процесса проектирования. Если он предоставляет вводные данные или GenUI, при необходимости подскажите мне, что выбрать; если он не подходит к цели, выберите более подходящий глобальный ресурс и объясните почему.',
  'chat.designToolbox.prompt.mcpResource': 'Отдавайте предпочтение этой возможности MCP для следующего шага проектирования. Когда нужны внешние ресурсы, веб-захват, генерация изображений/видео или данные, сначала определите, способна ли она справиться с задачей, затем предоставьте исполнимый план.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Этот MCP — настраиваемый шаблон. Если это самый полезный инструмент для данного шага проектирования, сначала помогите с настройкой; если уже есть настроенная альтернатива, продолжайте с ней.',
  'chat.designToolbox.prompt.connectorResource': 'Используйте этот коннектор, когда нужны реальные данные, ресурсы, содержимое аккаунта или доступ к внешнему рабочему процессу. Перед использованием объясните, что будет прочитано или записано, и при необходимости запросите подтверждение.',
  'chat.designToolbox.prompt.fileResource': 'Используйте этот файл дизайна как текущую цель проектирования или референсный ресурс и выполните из него следующий шаг. Если нужно сравнить другие файлы, продолжайте поиск по всем файлам дизайна.',
  'chat.designToolbox.prompt.resourceIndex': 'Индекс глобальных ресурсов: навыки ({skills}), плагины ({plugins}), MCP (включено: {mcpEnabled} / шаблонов: {mcpTemplates}), коннекторы (подключено: {connectors}), файлы дизайна ({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Доступные для поиска навыки',
  'chat.designToolbox.prompt.searchablePlugins': 'Доступные для поиска плагины',
  'chat.designToolbox.prompt.availableMcp': 'Доступные MCP',
  'chat.designToolbox.prompt.connectedConnectors': 'Подключённые коннекторы',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Референсные файлы дизайна',
  'chat.designToolbox.prompt.mcpTemplateName': 'Шаблон {name}',
  'chat.designToolbox.prompt.processRule': 'Правило рабочего процесса: сначала определите эстетическую цель и ограничения, затем ищите и подбирайте ресурсы; когда требуется выбор пользователя, сгенерируйте интерфейс с ограниченным набором вариантов и продолжайте после подтверждения.',
  'chat.designToolbox.prompt.moreSuffix': ', ещё +{count}',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Области упоминаний',
  'chat.mentionTabAll': 'Все',
  'chat.mentionTabTabs': 'Вкладки',
  'chat.mentionTabPlugins': 'Плагины',
  'chat.mentionTabSkills': 'Навыки',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Коннекторы',
  'chat.mentionTabFiles': 'Файлы дизайна',
  'chat.mentionNoResults': 'Нет результатов по запросу «{query}».',
  'chat.mentionSearchPrompt': 'Поиск по файлам дизайна, вкладкам, плагинам, навыкам, серверам MCP и коннекторам.',
  'chat.mentionSectionTabs': 'Вкладки',
  'chat.mentionSectionPlugins': 'Плагины',
  'chat.mentionSectionSkills': 'Навыки',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Коннекторы',
  'chat.mentionSectionFiles': 'Файлы дизайна',
  'chat.mentionActiveSkill': 'Активно',
  'chat.mentionUseMcpTitle': 'Использовать {name}',
  'chat.mentionUseConnectorTitle': 'Использовать {name}',
  'chat.mentionPluginOfficial': 'Официальный',
  'chat.mentionPluginMine': 'Мой плагин',
  'chat.linkedFolderRemoveAria': 'Удалить связанную папку {path}',
  'chat.linkedFolderNotFound': 'Папка не существует',
  'chat.linkedFolderAlready': 'Эта папка уже связана',
  'chat.linkedFolderPickError': 'Не удалось открыть выбор папки',
  'chat.queuedHeader': 'В очереди',
  'chat.queuedToSend': 'для отправки',
  'chat.queuedEditQueuedTaskAria': 'Изменить задачу в очереди',
  'chat.queuedSave': 'Сохранить',
  'chat.queuedCancel': 'Отмена',
  'chat.queuedReorder': 'Перетащите для изменения порядка',
  'chat.queuedEdit': 'Изменить',
  'chat.queuedMore': 'ещё в очереди',
  'chat.queuedFollowUpFallback': 'Продолжение в очереди',
  'chat.send': 'Отправить',
  'chat.stop': 'Остановить',
  'chat.removeAria': 'Удалить {name}',
  'chat.example1Title': 'Редакционная презентация',
  'chat.example1Tag': 'Журнал',
  'chat.example1Prompt': '10-слайдовая редакционная презентация для дизайн-студии, привлекающей посевной раунд — швейцарская сетка, крупные заголовки с засечками и жирными буквицами, моноширинные номера секций, много негативного пространства и полноформатные фотослайды, чередующиеся с текстовыми. Обложка, видение, рынок, продукт, тракция, команда, запрос, контакт.',
  'chat.example2Title': 'SaaS аналитическая панель',
  'chat.example2Tag': 'Данные',
  'chat.example2Prompt': 'Насыщенная аналитическая панель для SaaS-инструментов разработчика — полоса KPI с динамикой неделя к неделе, две составные линейные диаграммы (MRR и активные рабочие пространства), мировая тепловая карта использования, когортная матрица удержания, таблица лидеров по ключевым клиентам и лента событий в реальном времени. Тёмная тема, табличные моноширинные цифры, акцентные мини-графики.',
  'chat.example3Title': 'Годовой отчет с длинной прокруткой',
  'chat.example3Tag': 'Редакционный',
  'chat.example3Prompt': 'Интерактивный годовой отчёт для климатической некоммерческой организации — редакционный макет с длинной прокруткой, сочетающий крупные цитатные блоки, визуализации данных (составные столбчатые диаграммы, анимированные счётчики, хороплетную карту проектных площадок), фотографические разделители, стену доноров и финальный призыв к действию. Современный serif для основного текста, sans-serif для подписей графиков и землистая бумажная палитра.',
  'preview.usePlugin': 'Использовать плагин',
  'preview.usePluginOnly': 'Только плагин',
  'preview.usePluginOnlyDesc': 'Использовать структуру плагина и написать содержимое самостоятельно',
  'preview.replicateContent': 'Скопировать это содержимое',
  'preview.replicateContentDesc': 'Использовать пример промпта, чтобы воспроизвести превью',
  'preview.shareMenu': 'Поделиться',
  'preview.exportMenu': 'Экспорт',
  'preview.shareTemplateBadge': 'Шаблон',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Скопировать ссылку на шаблон',
  'preview.copyShareText': 'Скопировать текст для публикации',
  'preview.shareSocialGroup': 'Поделиться в соцсетях',
  'preview.shareCopyGroup': 'Копировать',
  'preview.shareExportGroup': 'Экспортировать файлы',
  'preview.shareCopied': 'Скопировано',
  'preview.shareCopyFailed': 'Не удалось скопировать',
  'preview.shareTextDefault': 'Шаблон Open Design: {title}',
  'preview.openInNewTab': 'Открыть в новой вкладке',
  'preview.exit': '⤓ Выход',
  'preview.fullscreen': '⤢ Полноэкранный',
  'preview.closeTitle': 'Закрыть (Esc)',
  'preview.loading': 'Загрузка {label}…',
  'preview.errorTitle': 'Не удалось загрузить этот пример.',
  'preview.errorBody': 'Не удалось получить HTML примера. Убедитесь, что Open Design запущен, и повторите попытку.',
  'preview.retry': 'Повторить',
  'preview.unavailableTitle': 'Для {noun} нет встроенного предпросмотра.',
  'preview.unavailableBody': 'Запустите запрос в чате, чтобы сгенерировать {kind}-вывод.',
  'preview.nounSkill': 'этого навыка',
  'preview.nounPlugin': 'этого плагина',
  'preview.nounTemplate': 'этого шаблона',
  'preview.showSidebar': 'Показать {label}',
  'preview.hideSidebar': 'Скрыть {label}',
  'misc.savedTemplate': 'Сохраненный шаблон',
  'misc.primary': 'Основной',
  'misc.designSystem': 'Дизайн-система',
  'workspace.designFiles': 'Файлы дизайна',
  'workspace.focusMode': 'Фокус на рабочей области',
  'workspace.showChat': 'Показать чат',
  'workspace.closeTab': 'Закрыть вкладку',
  'workspace.deleteFileConfirm': 'Удалить «{name}» из папки проекта?',
  'workspace.deleteSelectedFilesConfirm': 'Удалить {n} выбранных файла(ов) из папки проекта?',
  'workspace.deleteSelectedFilesPartial': 'Не удалось удалить {n} файл(ов).',
  'workspace.openFromDesignFiles': 'Открыть файл из',
  'workspace.designFilesLink': 'Файлы дизайна',
  'workspace.loadingSketch': 'Загрузка эскиза…',
  'workspace.newTab': 'Новая вкладка',
  'workspace.searchFilesPlaceholder': 'Поиск файлов…',
  'workspace.openTabs': 'Открыть вкладки',
  'workspace.openFile': 'Открыть файл',
  'workspace.noFilesMatch': 'Нет подходящих файлов',
  'workspace.allFiles': 'Все',
  'workspace.createNew': 'Создать',
  'workspace.tabOpen': 'Открыт',
  'workspace.sideChatContextBanner': 'Контекст текущего разговора интегрирован',
  'workspace.sideChatDefaultTitle': 'Боковой чат',
  'workspace.newTerminal': 'Новый терминал',
  'workspace.newTerminalDescription': 'Открыть оболочку в каталоге проекта в новой вкладке',
  'workspace.newBrowser': 'Новый браузер',
  'workspace.newBrowserDescription': 'Открыть встроенную вкладку браузера для справочных сайтов и задач',
  'workspace.terminalStarting': 'Запуск терминала…',
  'workspace.terminalStartingDescription': 'Подготавливаем оболочку проекта. Обычно это занимает несколько секунд.',
  'workspace.terminalSessionEnded': 'Сеанс завершён',
  'workspace.terminalReconnecting': 'Переподключение…',
  'workspace.terminalStartFailed': 'Не удалось запустить сеанс терминала',
  'workspace.terminalRestart': 'Перезапустить',
  'designFiles.title': 'Файлы дизайна',
  'designFiles.upload': 'Загрузить файлы',
  'designFiles.pasteText': 'Вставить как текстовый файл',
  'designFiles.newSketch': 'Новый эскиз',
  'designFiles.empty': 'Здесь появятся ваши работы',
  'designFiles.refresh': 'Обновить',
  'designFiles.delete': 'Удалить',
  'designFiles.searchPlaceholder': 'Поиск файлов…',
  'designFiles.up': 'Вверх',
  'designFiles.back': 'Назад',
  'designFiles.crumbs': 'проект',
  'designFiles.rowMenu': 'Меню строки',
  'designFiles.openInTab': 'Открыть во вкладке',
  'designFiles.download': 'Скачать',
  'designFiles.downloadSelected': 'Скачать {n} как ZIP',
  'designFiles.deleteSelected': 'Удалить {n}',
  'designFiles.clearSelection': 'Очистить выделение',
  'designFiles.selectPage': 'Выбрать всё на странице',
  'designFiles.selectAll': 'Выбрать всё',
  'designFiles.dropTitle': '⤓ Перетащите файлы сюда',
  'designFiles.dropDesc': 'Изображения, документы, референсы или папки — агент будет использовать их как контекст.',
  'designFiles.dropLabel': 'Перетащите файлы сюда',
  'designFiles.upload.title': 'Загрузить файлы',
  'designFiles.paste.title': 'Вставить текст как файл',
  'designFiles.upload.label': 'Загрузить',
  'designFiles.paste.label': 'Вставить',
  'designFiles.previewOpen': 'Открыть',
  'designFiles.previewClose': 'Закрыть предпросмотр',
  'designFiles.modified': 'Изменено {time} · {size}',
  'designFiles.weeksAgo': '{n} нед. назад',
  'designFiles.groupBy': 'Группировать по',
  'designFiles.groupByKind': 'Тип',
  'designFiles.groupByModified': 'Изменено',
  'designFiles.filterBy': 'Фильтр по типу',
  'designFiles.filterClear': 'Очистить',
  'designFiles.filterCount': 'типов: {n}',
  'designFiles.expandGroup': 'Развернуть',
  'designFiles.collapseGroup': 'Свернуть',
  'designFiles.sectionPages': 'Страницы',
  'designFiles.sectionScripts': 'Скрипты',
  'designFiles.sectionImages': 'Изображения',
  'designFiles.sectionSketches': 'Эскизы',
  'designFiles.sectionLiveArtifacts': 'Live-артефакты',
  'designFiles.sectionOther': 'Другое',
  'designFiles.modifiedToday': 'Сегодня',
  'designFiles.modifiedYesterday': 'Вчера',
  'designFiles.modifiedPrevious7Days': 'Последние 7 дней',
  'designFiles.modifiedPrevious30Days': 'Последние 30 дней',
  'designFiles.modifiedOlder': 'Старше',
  'designFiles.showMore': 'Показать ещё +{n}',
  'designFiles.kindHtml': 'HTML страница',
  'designFiles.kindImage': 'Изображение',
  'designFiles.kindSketch': 'Эскиз',
  'designFiles.kindText': 'Текст',
  'designFiles.kindCode': 'Скрипт',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Документ',
  'designFiles.kindPresentation': 'Презентация',
  'designFiles.kindSpreadsheet': 'Таблица',
  'designFiles.kindLiveArtifact': 'Live-артефакт',
  'designFiles.kindBinary': 'Бинарный',
  'designFiles.kindFolder': 'Папка',
  'designFiles.folderCount': '{n} файлов',
  'designFiles.newFolderTitle': 'Новая папка',
  'designFiles.newFolderLabel': 'Имя папки',
  'designFiles.moveTitle': 'Переместить в папку',
  'designFiles.moveLabel': 'Папка назначения',
  'designFiles.moveRoot': 'Корень проекта',
  'designFiles.moveNewFolder': 'Новая папка…',
  'designFiles.move': 'Переместить',
  'designFiles.copyPath': 'Скопировать путь',
  'designFiles.copiedPath': 'Путь скопирован',
  'designFiles.deleteFolderConfirm': 'Удалить папку «{name}» со всем содержимым?',
  'designFiles.folderCreated': 'Папка «{name}» создана',
  'designFiles.folderDeleted': 'Папка «{name}» удалена',
  'designFiles.filesMoved': 'Перемещено {n} в {dest}',
  'designFiles.colName': 'Имя',
  'designFiles.colKind': 'Тип',
  'designFiles.colModified': 'Изменён',
  'designFiles.perPage': 'Показать',
  'designFiles.all': 'Все',
  'designFiles.prev': 'Назад',
  'designFiles.next': 'Вперёд',
  'designFiles.jumpToPage': 'Перейти на страницу',
  'designFiles.pageInfo': '{start}–{end} из {total}',
  'designFiles.sectionFolders': 'Папки',
  'designFiles.sectionStylesheets': 'Таблицы стилей',
  'designFiles.sectionDocuments': 'Документы',
  'designFiles.kindStylesheet': 'Таблица стилей',
  'designFiles.modifiedExt': 'Изменено {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Полезная информация',
  'designFiles.usefulInfoTip': 'Дважды щёлкните по любому файлу, чтобы открыть его в отдельной вкладке.',
  'designFiles.usefulInfoTip2': 'Введите @ в чате, чтобы добавить файл как контекст.',
  'designFiles.usefulInfoTip4': 'Выберите дизайн-систему — результат будет в стиле бренда.',
  'designFiles.usefulInfoTip5': 'Нет идей? Попробуйте шаблон плагина в разделе «Сообщество» на главной.',
  'designFiles.usefulInfoTip6': 'Вопросы или идеи? Присоединяйтесь к нам в Discord.',
  'designFiles.usefulInfoTip7': 'Нравится Open Design? Поставьте звезду на GitHub.',
  'designFiles.usefulInfoTip8': 'Подписывайтесь на @nexudotio в X, чтобы не пропустить новинки.',
  'designFiles.usefulInfoTip9': 'Перетащите изображения, документы или целые папки в эту панель — агент использует их как контекст.',
  'designFiles.usefulInfoTip10': 'Нажмите «Новый эскиз», нарисуйте макет — агент сгенерирует дизайн по нему.',
  'designFiles.usefulInfoTip11': 'Выделите любой элемент в предпросмотре и оставьте комментарий — агент внесёт точечные правки.',
  'designFiles.usefulInfoTip12': 'Не нравится результат? Обвести элемент быстрее, чем описывать заново.',
  'designFiles.usefulInfoTip13': 'Любой дизайн экспортируется в PDF, изображение или автономный HTML в один клик.',
  'designFiles.usefulInfoTip14': 'Довольны проектом? Сохраните его как шаблон через меню «Поделиться».',
  'designFiles.usefulInfoTip15': 'После деплоя можно сразу создать карточки для соцсетей.',
  'quickSwitcher.placeholder': 'Открыть файл…',
  'quickSwitcher.empty': 'В проекте нет файлов',
  'quickSwitcher.noMatches': 'Нет совпадений',
  'quickSwitcher.navigate': 'навигация',
  'quickSwitcher.open': 'открыть',
  'quickSwitcher.close': 'закрыть',
  'pasteDialog.title': 'Вставить текст',
  'pasteDialog.hint': 'Сохраняется в папку проекта. Выберите любое имя.',
  'pasteDialog.fileNameLabel': 'Имя файла',
  'pasteDialog.namePlaceholder': 'заметки.txt',
  'pasteDialog.contentLabel': 'Содержимое',
  'pasteDialog.contentPlaceholder': 'Вставьте что угодно…',
  'pasteDialog.save': 'Сохранить',
  'pasteDialog.cancel': 'Отмена',
  'sketch.save': 'Сохранить эскиз',
  'sketch.cancel': 'Отмена',
  'sketch.saving': 'Сохранение…',
  'sketch.saved': 'Сохранено',
  'sketch.tooltipDirty': 'Несохраненные изменения',
  'sketch.tooltipClean': 'Сохранено',
  'fileViewer.empty': 'Выберите файл для просмотра.',
  'fileViewer.loading': 'Загрузка…',
  'fileViewer.exportPptx': 'Экспорт в PPTX',
  'fileViewer.openInNewTab': 'Открыть в новой вкладке',
  'fileViewer.copyPath': 'Копировать путь',
  'fileViewer.copied': 'Скопировано!',
  'fileViewer.share': 'Поделиться',
  'fileViewer.binaryMeta': 'Бинарный · {size}',
  'fileViewer.binaryNote': 'Бинарный файл ({size} байт). Скачайте или откройте с диска для просмотра.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Документ',
  'fileViewer.presentationMeta': 'Презентация',
  'fileViewer.spreadsheetMeta': 'Таблица',
  'fileViewer.previewUnavailable': 'Предпросмотр недоступен. Скачайте или откройте файл для просмотра.',
  'fileViewer.download': 'Скачать',
  'fileViewer.open': 'Открыть',
  'fileViewer.imageMeta': 'Изображение · {size}',
  'fileViewer.reactMeta': 'React-компонент · {size}',
  'fileViewer.sketchMeta': 'Эскиз · {size}',
  'fileViewer.markdownStreamingMeta': 'Потоковый предпросмотр…',
  'fileViewer.markdownErrorMeta': 'Предпросмотр может быть неполным (ошибка генерации).',
  'fileViewer.markdownStreamingStatus': 'Потоковая передача… показан частичный Markdown.',
  'fileViewer.markdownErrorStatus': 'Ошибка генерации. Показано последнее доступное содержимое.',
  'fileViewer.videoMeta': 'Видео · {size}',
  'fileViewer.audioMeta': 'Аудио · {size}',
  'fileViewer.reload': 'Перезагрузить',
  'fileViewer.reloadDisk': 'Перезагрузить с диска',
  'fileViewer.copy': 'Копировать',
  'fileViewer.copyTitle': 'Копировать содержимое файла',
  'fileViewer.saveDisabled': 'Сохранить (только для чтения)',
  'fileViewer.save': 'Сохранить',
  'fileViewer.preview': 'Предпросмотр',
  'fileViewer.source': 'Исходный код',
  'fileViewer.tweaks': 'Настройки',
  'fileViewer.tweaksUnavailable': 'В этом артефакте нет панели настроек',
  'fileViewer.jsxModuleTitle': 'Нет отдельного предпросмотра',
  'fileViewer.jsxModuleBody': 'Этот файл является модулем компонента, который загружает другая страница.',
  'fileViewer.jsxModuleCta': 'Откройте страницу, которая его отображает:',
  'fileViewer.comment': 'Комментарий',
  'fileViewer.edit': 'Редактировать',
  'fileViewer.draw': 'Рисовать',
  'fileViewer.mark': 'Пометить',
  'fileViewer.markTool': 'Инструмент пометки',
  'fileViewer.boxSelect': 'Выбрать область',
  'fileViewer.screenshot': 'Скриншот',
  'manualEdit.layers': 'Слои',
  'manualEdit.editableCount': 'редактируемых: {count}',
  'manualEdit.hiddenBadge': 'Скрыто',
  'manualEdit.title': 'Ручной редактор',
  'manualEdit.fallbackTitle': 'Редактировать',
  'manualEdit.movePanel': 'Переместить панель редактирования',
  'manualEdit.editParams': 'Изменить параметры',
  'manualEdit.closePanel': 'Закрыть панель редактирования',
  'manualEdit.selectLayer': 'Выберите слой',
  'manualEdit.empty': 'Щёлкните элемент в предпросмотре или выберите слой.',
  'manualEdit.noEditableLayers': 'Редактируемые слои не найдены.',
  'manualEdit.noClass': 'без класса',
  'manualEdit.tabsAria': 'Вкладки ручного редактирования',
  'manualEdit.tabContent': 'Содержимое',
  'manualEdit.tabStyle': 'Стиль',
  'manualEdit.tabAttributes': 'Атрибуты',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Исходный код',
  'manualEdit.attributesJson': 'Атрибуты JSON',
  'manualEdit.selectedHtml': 'HTML выбранного элемента',
  'manualEdit.fullSource': 'Полный исходный код артефакта',
  'manualEdit.applyContent': 'Применить содержимое',
  'manualEdit.applyStyle': 'Применить стиль',
  'manualEdit.applyAttributes': 'Применить атрибуты',
  'manualEdit.applyHtml': 'Применить HTML',
  'manualEdit.applySource': 'Применить исходный код',
  'manualEdit.invalidAttributes': 'Некорректный JSON атрибутов.',
  'manualEdit.changes': 'Изменения',
  'manualEdit.undo': 'Отменить',
  'manualEdit.redo': 'Повторить',
  'manualEdit.noChanges': 'Ручных изменений пока нет.',
  'manualEdit.imageUrl': 'URL изображения',
  'manualEdit.altText': 'Замещающий текст',
  'manualEdit.label': 'Метка',
  'manualEdit.text': 'Текст',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Цвет текста',
  'manualEdit.background': 'Фон',
  'manualEdit.fontSize': 'Размер шрифта',
  'manualEdit.weight': 'Насыщенность',
  'manualEdit.align': 'Выравнивание',
  'manualEdit.padding': 'Внутренние отступы',
  'manualEdit.margin': 'Внешние отступы',
  'manualEdit.radius': 'Скругление',
  'manualEdit.border': 'Граница',
  'manualEdit.width': 'Ширина',
  'manualEdit.minHeight': 'Мин. высота',
  'manualEdit.deleteElement': 'Удалить элемент',
  'manualEdit.deleteElementConfirm': 'Удалить выбранный элемент? Это действие можно отменить через «Отменить».',
  'manualEdit.uploadImage': 'Загрузить изображение',
  'manualEdit.uploadingImage': 'Загрузка изображения…',
  'manualEdit.uploadImageFailed': 'Не удалось загрузить изображение.',
  'manualEdit.focusSlides': 'Фокус на слайдах',
  'manualEdit.showPanels': 'Показать панели',
  'fileViewer.zoomOut': 'Уменьшить',
  'fileViewer.zoomIn': 'Увеличить',
  'fileViewer.resetZoom': 'Сбросить масштаб',
  'fileViewer.viewportAria': 'Область предпросмотра',
  'fileViewer.viewportDesktop': 'Десктоп',
  'fileViewer.viewportDesktopTitle': 'Полноширинный десктопный предпросмотр',
  'fileViewer.viewportTablet': 'Планшет',
  'fileViewer.viewportTabletTitle': 'Предпросмотр на планшете при 820 × 1180 (современный базовый портретный формат)',
  'fileViewer.viewportMobile': 'Мобильный',
  'fileViewer.viewportMobileTitle': 'Предпросмотр на мобильном при 390 × 844',
  'fileViewer.reloadAria': 'Перезагрузить',
  'fileViewer.previousSlide': 'Предыдущий слайд',
  'fileViewer.nextSlide': 'Следующий слайд',
  'fileViewer.slideNavAria': 'Навигация по слайдам',
  'fileViewer.present': 'Презентация',
  'fileViewer.presentInTab': 'В этой вкладке',
  'fileViewer.presentFullscreen': 'Полноэкранный',
  'fileViewer.presentNewTab': 'Новая вкладка',
  'fileViewer.exitPresentation': 'Выйти из презентации',
  'fileViewer.shareLabel': 'Поделиться',
  'fileViewer.shareMenuShareLink': 'ПОДЕЛИТЬСЯ',
  'fileViewer.shareMenuPublishOnline': 'ОПУБЛИКОВАТЬ ОНЛАЙН',
  'fileViewer.shareMenuDownload': 'СКАЧАТЬ',
  'fileViewer.shareMenuPresentation': 'Презентация',
  'fileViewer.shareMenuSourceFiles': 'Исходные файлы',
  'fileViewer.shareMenuSave': 'СОХРАНИТЬ',
  'fileViewer.copyShareLink': 'Скопировать ссылку для доступа',
  'fileViewer.openSharePage': 'Открыть страницу доступа',
  'fileViewer.shareLinkRequiresDeploy': 'Сначала опубликуйте онлайн, чтобы получить ссылку',
  'fileViewer.shareLinkPublishGuide': 'Опубликуйте онлайн выше, чтобы включить доступ ↑',
  'fileViewer.shareAfterGenerationComplete': 'Доступ станет возможен после завершения генерации',
  'fileViewer.copyProviderLink': 'Скопировать ссылку {provider}',
  'fileViewer.copyCloudflareLink': 'Скопировать ссылку Cloudflare',
  'fileViewer.screenshotCopying': 'Копирование снимка экрана...',
  'fileViewer.screenshotCopied': 'Снимок экрана скопирован в буфер обмена',
  'fileViewer.screenshotClipboardDenied': 'Браузер заблокировал доступ к буферу обмена',
  'fileViewer.screenshotPreviewLoading': 'Предпросмотр ещё загружается. Повторите попытку через мгновение.',
  'fileViewer.screenshotCaptureFailed': 'Не удалось сделать снимок предпросмотра. Пожалуйста, попробуйте снова.',
  'fileViewer.exportPdf': 'Экспорт в PDF',
  'fileViewer.exportPdfAllSlides': 'Экспорт в PDF (все слайды)',
  'fileViewer.exportPptxBusy': 'Дождитесь окончания текущего хода.',
  'fileViewer.exportPptxHint': 'Отправьте запрос агенту для конвертации этого дизайна в PPTX.',
  'fileViewer.exportPptxNa': 'Экспорт PPTX здесь недоступен.',
  'fileViewer.exportZip': 'Скачать как .zip',
  'fileViewer.exportHtml': 'Экспорт как HTML',
  'fileViewer.exportMd': 'Экспорт в Markdown',
  'fileViewer.exportImage': 'Экспорт как изображение',
  'fileViewer.exportImageFailed': 'Не удалось сделать снимок. Попробуйте ещё раз или воспользуйтесь инструментом скриншотов вашего браузера.',
  'fileViewer.exportImageModalSubtitle': 'Выберите формат, затем скачайте текущий предпросмотр как изображение.',
  'fileViewer.exportImageFormatLabel': 'Формат',
  'fileViewer.exportImageSaving': 'Сохранение изображения…',
  'fileViewer.exportImageSaved': 'Изображение сохранено',
  'fileViewer.exportImageDownloadStarted': 'Загрузка началась',
  'fileViewer.exportImageDownloadDetails': '{filename} находится в загрузках браузера, если окно «Сохранить как» не появилось.',
  'fileViewer.exportJsx': 'Экспорт как JSX',
  'fileViewer.exportReactHtml': 'Экспорт предпросмотра как HTML',
  'fileViewer.exportStarted': 'Экспорт начат',
  'fileViewer.saveAsTemplate': 'Сохранить как шаблон…',
  'fileViewer.savingTemplate': 'Сохранение шаблона…',
  'fileViewer.savedTemplate': 'Сохранено как «{name}»',
  'fileViewer.savedTemplateFail': 'Не удалось сохранить шаблон — попробуйте снова.',
  'fileViewer.templateNamePrompt': 'Название шаблона',
  'fileViewer.templateNameDefault': 'Шаблон без названия',
  'fileViewer.templateDescPrompt': 'Краткое описание (необязательно — чем полезен этот шаблон?)',
  'liveArtifact.refresh.button': 'Обновить',
  'liveArtifact.refresh.buttonTitle': 'Обновить этот live-артефакт',
  'liveArtifact.refresh.loadingTitle': 'Загрузка live-артефакта…',
  'liveArtifact.refresh.noSourceTitle': 'Пока нет одобренного источника обновления только для чтения.',
  'liveArtifact.refresh.running': 'Обновление…',
  'liveArtifact.refresh.runningMessage': 'Обновляем данные и предпросмотр. Это может занять немного времени.',
  'liveArtifact.refresh.runningAction': 'Предыдущий предпросмотр остается видимым, пока обновление не завершится успешно.',
  'liveArtifact.refresh.successOne': 'Обновление завершено. Данные обновлены.',
  'liveArtifact.refresh.successMany': 'Обновление завершено. Данные обновлены.',
  'liveArtifact.refresh.successAction': 'Предпросмотр перезагружен с последними сохраненными данными.',
  'liveArtifact.refresh.previousFailure': 'Предыдущее обновление завершилось ошибкой: {message}',
  'liveArtifact.refresh.failureAction': 'Проверьте историю обновлений, исправьте проблему с источником или правами и повторите попытку.',
  'liveArtifact.refresh.networkFailure': 'Не удалось отправить запрос на обновление. Проверьте подключение и попробуйте снова.',
  'liveArtifact.refresh.genericFailure': 'Не удалось обновить.',
  'liveArtifact.refresh.statusNever': 'Не обновляется',
  'liveArtifact.refresh.statusReady': 'Готов к обновлению',
  'liveArtifact.refresh.statusSucceeded': 'Актуально',
  'liveArtifact.refresh.statusFailed': 'Обновление не удалось',
  'liveArtifact.refresh.statusRunning': 'Обновление',
  'liveArtifact.refresh.statusRunningDescription': 'Сейчас выполняется обновление.',
  'liveArtifact.refresh.statusSucceededDescription': 'Последнее обновление завершилось успешно.',
  'liveArtifact.refresh.statusFailedDescription': 'Последняя попытка обновления завершилась неудачно.',
  'liveArtifact.refresh.statusReadyDescription': 'Обновляемые источники настроены, но обновление не выполняется.',
  'liveArtifact.refresh.statusNeverDescription': 'У этого живого артефакта пока нет источника обновления.',
  'liveArtifact.refresh.eventStarted': 'Начато',
  'liveArtifact.refresh.eventSucceeded': 'Успешно',
  'liveArtifact.refresh.eventFailed': 'Не удалось',
  'liveArtifact.refresh.eventStartedDetail': 'Обновление запущено…',
  'liveArtifact.refresh.sourcesUpdatedOne': 'Обновлён {n} источник',
  'liveArtifact.refresh.sourcesUpdatedMany': 'Обновлено источников: {n}',
  'liveArtifact.refresh.timelineEmpty': 'В этой сессии ещё не было активности обновления. Запустите обновление, чтобы записать хронологию, или дождитесь автоматических запусков.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Последнее обновление',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Никогда',
  'liveArtifact.refresh.justNow': 'только что',
  'liveArtifact.refresh.factCreated': 'Создано',
  'liveArtifact.refresh.factLastUpdated': 'Последнее обновление',
  'liveArtifact.refresh.factUnknown': 'Неизвестно',
  'liveArtifact.refresh.persistedTitle': 'Сохранённая история обновлений',
  'liveArtifact.refresh.persistedHint': 'Записи, загруженные из refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Сохранённой истории обновлений пока нет.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'успешно',
  'liveArtifact.refresh.persistedStatusRunning': 'выполняется',
  'liveArtifact.refresh.persistedStatusFailed': 'не удалось',
  'liveArtifact.refresh.persistedStatusCancelled': 'отменено',
  'liveArtifact.refresh.persistedStatusSkipped': 'пропущено',
  'liveArtifact.refresh.sessionTitle': 'Активность сессии',
  'liveArtifact.refresh.sessionHint': 'События, зафиксированные пока эта вкладка открыта',
  'liveArtifact.refresh.docSourceTitle': 'Источник документа',
  'liveArtifact.refresh.docSourceHint': 'Источник настроен',
  'liveArtifact.refresh.docSourceType': 'Тип',
  'liveArtifact.refresh.docSourceTool': 'Инструмент',
  'liveArtifact.refresh.docSourceConnector': 'Коннектор',
  'liveArtifact.refresh.debugSummary': 'Расширенные отладочные метаданные',
  'liveArtifact.refresh.debugNote': 'Может включать ID коннекторов, имена файлов, метаданные источников и внутренние пути артефактов.',
  'liveArtifact.viewer.tabPreview': 'Предпросмотр',
  'liveArtifact.viewer.tabCode': 'Код',
  'liveArtifact.viewer.tabData': 'Данные',
  'liveArtifact.viewer.tabRefreshHistory': 'История обновлений',
  'liveArtifact.viewer.dataEmpty': 'Кэш data.json недоступен.',
  'liveArtifact.viewer.code.templateHeading': 'HTML шаблона',
  'liveArtifact.viewer.code.renderedHeading': 'Сгенерированный HTML',
  'liveArtifact.viewer.code.templateHelp': 'Редактируемый шаблон, используемый с data.json для создания предпросмотра.',
  'liveArtifact.viewer.code.renderedHelp': 'Сгенерированный index.html, который сейчас загружен в предпросмотре.',
  'liveArtifact.viewer.code.variantAria': 'Вариант кода',
  'liveArtifact.viewer.code.variantTemplate': 'Шаблон',
  'liveArtifact.viewer.code.variantRendered': 'Сгенерировано',
  'liveArtifact.viewer.code.loading': 'Загрузка кода…',
  'liveArtifact.viewer.code.unavailable': 'Код пока недоступен.',
  'liveArtifact.viewer.code.empty': 'Этот файл кода пуст.',
  'fileViewer.deployToVercel': 'Развернуть на Vercel',
  'fileViewer.redeployToVercel': 'Развернуть повторно',
  'fileViewer.deployingToVercel': 'Развёртывание на Vercel…',
  'fileViewer.deployProviderLabel': 'Провайдер',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'Развернуть на {provider}',
  'fileViewer.redeployToProvider': 'Развернуть повторно на {provider}',
  'fileViewer.deployingToProvider': 'Развёртывание на {provider}…',
  'fileViewer.preparingPublicLink': 'Подготовка публичной ссылки…',
  'fileViewer.copyDeployLink': 'Скопировать ссылку',
  'fileViewer.deployModalTitle': 'Развернуть',
  'fileViewer.deployModalSubtitle': 'Используйте аккаунт выбранного провайдера, чтобы развернуть этот HTML-просмотр.',
  'fileViewer.vercelToken': 'Токен Vercel',
  'fileViewer.vercelTokenGetLink': 'Получить токен Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Вставьте токен Vercel',
  'fileViewer.vercelTokenReuseHint': 'Будет использован сохранённый токен. Введите новый, чтобы заменить его.',
  'fileViewer.vercelTokenRequired': 'Сначала введите и сохраните токен Vercel.',
  'fileViewer.cloudflareApiToken': 'Токен API Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Получить токен API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Вставьте токен API Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'Будет использован сохранённый токен API Cloudflare. Введите новый, чтобы заменить его.',
  'fileViewer.cloudflareApiTokenRequired': 'Сначала введите и сохраните токен API Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'При создании токена API выберите Pages Edit; для пользовательских доменов нужны Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'ID команды',
  'fileViewer.vercelTeamSlug': 'Слаг команды',
  'fileViewer.cloudflareAccountId': 'ID аккаунта',
  'fileViewer.cloudflareAccountIdHint': 'ID аккаунта можно найти в панели Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Сначала введите и сохраните Cloudflare Account ID.',
  'fileViewer.cloudflareZoneLabel': 'Домен',
  'fileViewer.cloudflareZonePlaceholder': 'Сохраните настройки Cloudflare, чтобы загрузить домены',
  'fileViewer.cloudflareZoneRequired': 'Сначала выберите домен Cloudflare.',
  'fileViewer.cloudflareZonesLoading': 'Загрузка доменов Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'Обновить домены',
  'fileViewer.cloudflareZonesLoadFailed': 'Не удалось загрузить домены Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'Для этого аккаунта не найдено активных полных доменов Cloudflare.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Префикс поддомена',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Используйте только одну метку DNS: строчные буквы, цифры и дефисы.',
  'fileViewer.cloudflareHostnamePreview': 'Предпросмотр пользовательского домена: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Необязательно: привяжите пользовательский домен. Если оставить поле пустым, всё равно будет создана ссылка pages.dev.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'URL pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Пользовательский домен',
  'fileViewer.optional': 'Необязательно',
  'fileViewer.vercelPreviewOnly': 'Пока поддерживаются только Preview-развёртывания.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages использует Direct Upload.',
  'fileViewer.savingConfig': 'Сохранение…',
  'fileViewer.deployConfigSaveFailed': 'Не удалось сохранить настройки Vercel.',
  'fileViewer.deployFailed': 'Развёртывание не удалось. Проверьте настройки Vercel и попробуйте снова.',
  'fileViewer.deployProviderConfigSaveFailed': 'Не удалось сохранить настройки {provider}.',
  'fileViewer.deployProviderFailed': 'Развёртывание на {provider} не удалось. Проверьте настройки и попробуйте снова.',
  'fileViewer.deployResultLabel': 'URL развёрнутого сайта',
  'fileViewer.deployLinkReady': 'Готово',
  'fileViewer.deploySuccessToast': 'Развёртывание успешно загружено',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Публичная ссылка готовится',
  'fileViewer.deployLinkDelayed': 'Сайт развёрнут. Провайдер всё ещё готовит публичную ссылку.',
  'fileViewer.deployLinkFailed': 'Пользовательский домен не настроен',
  'fileViewer.deployLinkProtectedLabel': 'Защита развёртывания включена',
  'fileViewer.deployLinkProtected': 'Сайт развёрнут, но эта ссылка предпросмотра требует аутентификации. Отключите Deployment Protection или используйте собственный домен.',
  'fileViewer.retryLink': 'Повторить',
  'questionForm.submit': 'Отправить',
  'questionForm.skip': 'Пропустить',
  'questionForm.locked': 'Отвечено',
  'conv.switch': 'Переключить разговор',
  'conv.label': 'Разговор',
  'conv.heading': 'Разговоры',
  'conv.new': '+ Новый',
  'conv.empty': 'Разговоров пока нет.',
  'conv.untitled': 'Разговор без названия',
  'conv.renameTooltip': 'Дважды кликните для переименования',
  'conv.delete': 'Удалить разговор',
  'conv.deleteConfirm': 'Удалить «{title}»? Это удалит его сообщения.',
  'agentPicker.label': 'Агент',
  'agentPicker.modeChoose': 'Выберите режим выполнения',
  'agentPicker.localCli': 'Локальный CLI',
  'agentPicker.daemonOff': 'демон выключен',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Выберите обнаруженный CLI код-агента',
  'agentPicker.noAgents': 'нет агентов в PATH',
  'agentPicker.notInstalled': 'не установлено',
  'agentPicker.rescan': 'Пересканировать локальный PATH для агентов',
  'tool.openInTab': 'Открыть {name} во вкладке',
  'tool.open': 'открыть',
  'tool.todos': 'Задачи',
  'tool.todosExpand': 'Показать задачи',
  'tool.todosCollapse': 'Скрыть задачи',
  'tool.todosDone': 'Готово',
  'tool.todosDismiss': 'Закрыть список задач',
  'tool.write': 'Записать',
  'tool.edit': 'Редактировать',
  'tool.read': 'Читать',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Fetch',
  'tool.search': 'Поиск',
  'tool.lines': '{n} строк',
  'tool.changeSingular': 'изменение',
  'tool.changePlural': 'изменения',
  'tool.in': 'в {path}',
  'tool.hide': 'скрыть',
  'tool.output': 'вывод',
  'tool.running': 'выполняется…',
  'tool.error': 'ошибка',
  'tool.done': 'готово',
  'assistant.role': 'Ассистент',
  'assistant.workingLabel': 'Работает',
  'assistant.doneLabel': 'Готово',
  'assistant.copyMarkdown': 'Скопировать Markdown ответа',
  'assistant.forkConversation': 'Создать форк отсюда',
  'assistant.forkingConversation': 'Создание форка…',
  'assistant.shareToOpenDesign': 'Поделиться в Open Design',
  'assistant.shareToOpenDesignBusy': 'Готовим пакет…',
  'assistant.feedbackPrompt': 'Отзыв',
  'assistant.feedbackPositive': 'Полезно',
  'assistant.feedbackNegative': 'Не полезно',
  'assistant.feedbackReasonTitle': 'Расскажите почему',
  'assistant.feedbackReasonPositiveMatched': 'Понял мой запрос',
  'assistant.feedbackReasonPositiveVisual': 'Выглядит хорошо',
  'assistant.feedbackReasonPositiveUseful': 'Удобная структура',
  'assistant.feedbackReasonPositiveEasy': 'Легко продолжать редактирование',
  'assistant.feedbackReasonPositiveDesignSystem': 'Следовал дизайн-системе',
  'assistant.feedbackReasonNegativeMissed': 'Не учёл мой запрос',
  'assistant.feedbackReasonNegativeVisual': 'Визуальное качество требует доработки',
  'assistant.feedbackReasonNegativeIncomplete': 'Неполный результат',
  'assistant.feedbackReasonNegativeHard': 'Сложно использовать',
  'assistant.feedbackReasonNegativeDesignSystem': 'Не следовал дизайн-системе',
  'assistant.feedbackReasonOther': 'Другое',
  'assistant.feedbackReasonPlaceholder': 'Добавьте короткую заметку...',
  'assistant.feedbackReasonSubmit': 'Отправить',
  'assistant.emptyResponseLabel': 'Нет результата',
  'assistant.emptyResponseMessage': 'Провайдер завершил запрос, не вернув текст или артефакт. Попробуйте другую модель или провайдера, проверьте квоту или повторите попытку.',
  'assistant.unfinishedLabel': 'Остановлено с незавершенной работой',
  'assistant.unfinishedSummary': 'Осталось задач: {n}',
  'assistant.unfinishedMore': '+{n} еще',
  'assistant.continueRemaining': 'Продолжить оставшиеся задачи',
  'chat.resumeRunCta': 'Продолжить выполнение',
  'assistant.outTokens': '{n} токенов вывода',
  'assistant.producedFiles': 'Файлы из этого хода',
  'assistant.openFile': 'Открыть',
  'assistant.downloadFile': 'Скачать',
  'nextStep.title': 'Следующий шаг',
  'nextStep.more': 'Ещё',
  'nextStep.share': 'Поделиться',
  'nextStep.download': 'Скачать',
  'nextStep.contribute': 'Внести вклад',
  'assistant.thinking': 'Думает',
  'assistant.thought': 'Подумал',
  'assistant.thoughtFor': 'Думал {s}с',
  'assistant.systemReminder': 'Системное напоминание',
  'assistant.possiblePromptInjection': 'Возможная инъекция промпта',
  'assistant.waitingFirstOutput': 'Ожидание первого ответа',
  'assistant.statusBootingAgent': 'Загрузка агента',
  'assistant.statusPreparing': 'Подготовка...',
  'assistant.statusStarting': 'Запуск',
  'assistant.statusRequesting': 'Отправка запроса',
  'assistant.statusThinking': 'Думает',
  'assistant.statusStreaming': 'Потоковая передача',
  'assistant.slowHint': 'Занимает больше времени, чем обычно. Форма обычно появляется через 5–10с — вы можете остановить и перефразировать.',
  'assistant.verbEditing': 'Редактирование',
  'assistant.verbWriting': 'Запись',
  'assistant.verbReading': 'Чтение',
  'assistant.verbSearching': 'Поиск',
  'assistant.verbRunning': 'Выполнение',
  'assistant.verbTodos': 'Задачи',
  'assistant.verbFetching': 'Получение',
  'assistant.verbCalling': 'Вызов',
  'qf.answered': 'отвечено',
  'qf.choose': 'Выберите…',
  'qf.required': 'обязательно',
  'qf.lockedSubmitted': 'Ответы отправлены — агент будет использовать их до конца сессии.',
  'qf.lockedPrev': 'Эта форма из предыдущего хода.',
  'qf.hint': 'Выберите подходящее. Пропустите необязательные поля, которые вам не важны — агент будет использовать разумные значения по умолчанию.',
  'qf.submitDefault': 'Отправить ответы',
  'qf.submitDisabledTitle': 'Сначала заполните обязательные поля',
  'qf.submitTitle': 'Отправить ответы',
  'qf.cardSelected': 'выбрано',
  'qf.cardRefs': 'Ссылки:',
  'qf.cardSampleText': 'Быстрая коричневая лиса · 0123',
  'questions.tabLabel': 'Вопросы',
  'questions.banner': 'Не против, если я задам пару коротких вопросов?',
  'questions.bannerAnswered': 'На вопросы дан ответ',
  'questions.continue': 'Продолжить',
  'questions.generating': 'Генерация вопросов…',
  'questions.skipAll': 'Пропустить всё',
  'questions.autoSkipHint': 'Автоматически продолжается по истечении таймера',
  'sketch.toolSelect': 'Выбор (без действий)',
  'sketch.toolPen': 'Ручка',
  'sketch.toolText': 'Текст',
  'sketch.toolRect': 'Прямоугольник',
  'sketch.toolArrow': 'Стрелка',
  'sketch.toolEraser': 'Ластик',
  'sketch.color': 'Цвет',
  'sketch.strokeSize': 'Размер штриха',
  'sketch.undo': 'Отменить',
  'sketch.clear': 'Очистить',
  'sketch.close': 'Закрыть',
  'sketch.closeConfirm': 'Закрыть набросок и отменить несохранённые изменения?',
  'sketch.textPrompt': 'Текст:',
  'sketch.textModalTitle': 'Добавить текст',
  'critiqueTheater.userFacingName': 'Дизайн-жюри',
  'critiqueTheater.roleDesigner': 'Дизайнер',
  'critiqueTheater.roleCritic': 'Критик',
  'critiqueTheater.roleBrand': 'Бренд',
  'critiqueTheater.roleA11y': 'Доступность',
  'critiqueTheater.roleCopy': 'Текст',
  'critiqueTheater.roundLabel': 'Раунд {n} из {m}',
  'critiqueTheater.mustFix': '{n} обязательных исправлений',
  'critiqueTheater.composite': 'Сводная оценка',
  'critiqueTheater.threshold': 'Порог',
  'critiqueTheater.consensus': 'Консенсус',
  'critiqueTheater.interrupt': 'Прервать',
  'critiqueTheater.interrupting': 'Прерывание…',
  'critiqueTheater.interrupted': 'Прервано',
  'critiqueTheater.degradedHeading': 'Панель недоступна в этом запуске',
  'critiqueTheater.degradedReasonMalformed': 'Некорректный вывод панели (парсер отклонил блок).',
  'critiqueTheater.degradedReasonOversize': 'Вывод панели превысил безопасный лимит в байтах.',
  'critiqueTheater.degradedReasonAdapter': 'Адаптер {adapter} не поддерживает протокол Critique.',
  'critiqueTheater.degradedReasonProtocol': 'Адаптер {adapter} отправил неподдерживаемую версию протокола.',
  'critiqueTheater.degradedReasonMissingArtifact': 'Запуск завершён без финального артефакта.',
  'critiqueTheater.replay': 'Воспроизвести заново',
  'critiqueTheater.replaySpeed': 'Скорость воспроизведения',
  'critiqueTheater.readOnly': 'Только для чтения',
  'critiqueTheater.shippedSummary': 'Отправлено на раунде {round} · итоговая оценка {composite}',
  'critiqueTheater.interruptedSummary': 'Прервано на раунде {round} · лучшая итоговая оценка {composite}',
  'critiqueTheater.shippedBadge': 'Отправлено',
  'critiqueTheater.belowThresholdBadge': 'Ниже порога',
  'critiqueTheater.timedOutBadge': 'Время истекло',
  'critiqueTheater.failedHeading': 'Сбой запуска',
  'critiqueTheater.failedReasonCliExit': 'Agent CLI завершился с ненулевым кодом, прежде чем панель смогла закончить.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Раунд превысил отведённое время.',
  'critiqueTheater.failedReasonTotalTimeout': 'Полный запуск превысил общий лимит времени.',
  'critiqueTheater.failedReasonOrchestrator': 'Внутренняя ошибка оркестратора.',
  'critiqueTheater.transcriptEmpty': 'Пока нет записи для воспроизведения. Запустите критику, чтобы записать её.',
  'critiqueTheater.transcriptLoading': 'Загрузка стенограммы…',
  'critiqueTheater.transcriptError': 'Не удалось загрузить запись: {error}',
  'critiqueTheater.replaySpeedPaused': 'Приостановлено',
  'critiqueTheater.replaySpeedInstant': 'Мгновенно',
  'critiqueTheater.replaySpeedLive': 'В реальном времени',
  'critiqueTheater.replaySpeedFast': 'Быстро',
  'critiqueTheater.settingsNav': 'Жюри дизайна',
  'critiqueTheater.settingsNavHint': 'Обзор дизайна из пяти панелей для ваших запусков',
  'critiqueTheater.settingsEnabledLabel': 'Показывать Жюри дизайна во время запусков Agent',
  'critiqueTheater.settingsEnabledDescription': 'Когда включено, обзор из пяти панелей появляется рядом с генерациями Agent и оценивает результат перед отправкой. Вы можете прервать процесс в любой момент.',
  'critiqueTheater.settingsEnabledProjectHint': 'Сохранено для этого проекта. Новые запуски в этом проекте будут проходить через Жюри дизайна на стороне сервера.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Откройте проект, чтобы сохранить это на стороне сервера. До этого момента изменяется только настройка в браузере.',
  'pet.title': 'Питомцы',
  'pet.subtitle': 'Заведите маленького спутника, который парит над вашей рабочей областью.',
  'pet.navTitle': 'Питомцы',
  'pet.navHint': 'Завести или настроить',
  'pet.tabBuiltIn': 'Встроенные',
  'pet.tabBuiltInHint': 'Подобранные питомцы в комплекте Open Design — выберите и забирайте.',
  'pet.builtInEmpty': 'Встроенные питомцы сейчас недоступны. Обновите вкладку «Сообщество», когда демон снова запустится.',
  'pet.tabCustom': 'Свой',
  'pet.tabCustomHint': 'Своё имя, глиф, цвет или загруженный спрайт.',
  'pet.tabCommunity': 'Сообщество',
  'pet.tabCommunityHint': 'Питомцы из Codex — заведите своего или сгенерируйте нового через ИИ.',
  'pet.tabsAria': 'Источник питомца',
  'pet.adopt': 'Завести',
  'pet.adoptedBadge': 'Заведён',
  'pet.adoptCallout': 'Завести питомца',
  'pet.changePet': 'Сменить питомца',
  'pet.wake': 'Разбудить',
  'pet.tuck': 'Спрятать',
  'pet.wakeTitle': 'Разбудить питомца — показать оверлей.',
  'pet.tuckTitle': 'Спрятать питомца — скрыть оверлей.',
  'pet.settingsTitle': 'Открыть настройки питомца',
  'pet.useCustom': 'Использовать своего',
  'pet.customTitle': 'Создайте своего',
  'pet.customHint': 'Выберите имя, символ и акцентный цвет — оверлей обновляется на лету.',
  'pet.customGreetingPlaceholder': 'Приветствие от вашего питомца…',
  'pet.fieldName': 'Имя',
  'pet.fieldGlyph': 'Символ',
  'pet.fieldGlyphHint': 'Один эмодзи подходит лучше всего (например 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Приветствие',
  'pet.fieldAccent': 'Акцентный цвет',
  'pet.fieldAccentCustom': 'Свой цвет',
  'pet.fieldAccentDefault': 'Цвет акцента по умолчанию',
  'pet.overlayAria': 'Питомец-компаньон',
  'pet.spriteAria': '{name} — тащите, чтобы переместить, кликните, чтобы пообщаться',
  'pet.spriteTitle': 'Привет от {name}! Кликните, чтобы пообщаться.',
  'pet.taskSummarySingle': 'Выполняется {count} задача Agent.',
  'pet.taskSummaryMultiple': 'Выполняется {count} задач Agent в {projects} проектах.',
  'pet.taskSummaryRecentSingle': 'Недавно завершена {count} задача Agent.',
  'pet.taskSummaryRecentMultiple': 'Недавно завершено {count} задач Agent.',
  'pet.taskListAria': 'Активные задачи Agent',
  'pet.taskOpenProject': 'Открыть {project}',
  'pet.taskGroup.running': 'Выполняется',
  'pet.taskGroup.queued': 'Ожидание',
  'pet.taskGroup.recent': 'Недавно завершённые',
  'pet.idleQuote.leonardo.text': 'Учение никогда не истощает ум.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Я увидел ангела в мраморе и высекал, пока не освободил его.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'Есть два средства, которые могут помочь скульптору: свет и тень.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Когда человек пишет картину, он не думает.',
  'pet.idleQuote.raphael.author': 'Raphael',
  'pet.idleQuote.caravaggio.text': 'Все произведения, что бы и кем бы они ни были написаны, — не более чем безделицы и детские пустяки, если они не созданы и не написаны с натуры.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'Главное — быть тронутым, любить, надеяться, трепетать, жить.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Питомцы — разбудить, спрятать или выбрать',
  'pet.composerMenuTitle': 'Питомцы',
  'pet.composerMenuHint': 'совет: введите /pet, чтобы переключить',
  'pet.composerOpenSettings': 'Управление питомцами',
  'pet.welcomeTeaserTitle': 'Заведите питомца',
  'pet.welcomeTeaserBody': 'Маленький спутник, парящий над воркспейсом.',
  'pet.welcomeTeaserCta': 'Выбрать',
  'pet.imageUpload': 'Загрузить спрайт',
  'pet.imageReplace': 'Заменить спрайт',
  'pet.imageRemove': 'Использовать emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF или SVG. Спрайтшит? Загрузите горизонтальную ленту и укажите число кадров.',
  'pet.imageHintActive': 'Показан ваш спрайт. Установите кадры > 1, чтобы анимировать горизонтальный спрайтшит.',
  'pet.fieldFrames': 'Кадры',
  'pet.fieldFramesHint': '1 = статично. > 1 = горизонтальный спрайтшит.',
  'pet.fieldFps': 'Скорость (fps)',
  'pet.fieldFpsHint': 'Скорость смены кадров.',
  'pet.atlasImport': 'Импорт спрайта Codex',
  'pet.atlasImportTitle': 'Импортируйте атлас hatch-pet 8x9 / 192x208 (PNG или WebP).',
  'pet.atlasPickerTitle': 'Выберите ряд анимации',
  'pet.atlasPickerHint': 'У Codex-петов 9 рядов анимаций. По умолчанию мы оставляем весь атлас — питомец меняет ряд при наведении, направлении перетаскивания и долгом простое. Можно зафиксировать и один цикл.',
  'pet.atlasCancel': 'Отменить атлас',
  'pet.atlasAdopt': 'Зафиксировать этот ряд',
  'pet.atlasAdoptFull': 'Использовать весь атлас (анимация)',
  'pet.atlasAdoptFullTitle': 'Сохранить все ряды, чтобы питомец реагировал на наведение, направление перетаскивания и долгое бездействие.',
  'pet.atlasAdoptRowTitle': 'Вырезать только выделенный ряд в отдельную циклическую полоску.',
  'pet.atlasActiveHint': 'Анимированный атлас включён — питомец выбирает ряд по вашему взаимодействию (наведение, перетаскивание, бездействие).',
  'pet.atlasRow.idle': 'Покой',
  'pet.atlasRow.running-right': 'Бег вправо',
  'pet.atlasRow.running-left': 'Бег влево',
  'pet.atlasRow.waving': 'Машет',
  'pet.atlasRow.jumping': 'Прыжок',
  'pet.atlasRow.failed': 'Неудача',
  'pet.atlasRow.waiting': 'Ожидание',
  'pet.atlasRow.running': 'Бежит',
  'pet.atlasRow.review': 'Анализ',
  'pet.hatchTitle': 'Вырастить нового пета с ИИ',
  'pet.hatchHint': 'Запустите встроенный навык hatch-pet в чате, чтобы получить спрайтшит в стиле Codex, а затем импортируйте его здесь.',
  'pet.hatchConcept': 'Концепт пета (по желанию)',
  'pet.hatchConceptPlaceholder': 'напр.: маленький пиксель-арт сиба-ину в уютном свитере',
  'pet.hatchCopy': 'Скопировать промпт',
  'pet.hatchCopied': 'Скопировано!',
  'pet.hatchFoot': 'Когда навык сохранит пета, вернитесь и нажмите «Импорт спрайта Codex».',
  'pet.slashPopoverAria': 'Слэш-команды',
  'pet.slashPopoverTitle': 'Команды',
  'pet.slashPopoverHint': '↑↓ навигация · enter выбрать · esc закрыть',
  'pet.slashPet': 'Переключить, выбрать или открыть настройки пета.',
  'pet.slashPetWake': 'Разбудить плавающего пета.',
  'pet.slashPetTuck': 'Спрятать пета на время.',
  'pet.slashHatch': 'Создать Codex-пета через навык hatch-pet.',
  'pet.slashHatchArg': '<концепт>',
  'pet.slashSearch': 'Искать в вебе через команду OD research.',
  'pet.slashSearchArg': '<запрос>',
  'pet.codexTitle': 'Недавно вылупленные',
  'pet.codexSubtitle': 'Петы, упакованные навыком hatch-pet, появятся здесь для усыновления в один клик.',
  'pet.codexSubtitleWithDir': 'Сканируем {dir} в поисках пакетов hatch-pet.',
  'pet.codexEmpty': 'Пока нет вылупленных петов. Наберите /hatch в чате, чтобы создать.',
  'pet.codexLoading': 'Ищем вылупленных петов…',
  'pet.codexRefresh': 'Обновить',
  'pet.codexAdopt': 'Усыновить',
  'pet.codexAdopting': 'Усыновляем…',
  'pet.communitySync': 'Скачать сообщество питомцев',
  'pet.communitySyncing': 'Загрузка…',
  'pet.communitySyncTitle': 'Синхронизировать свежих питомцев из Codex Pet Share + j20 Hatchery в ~/.codex/pets/.',
  'pet.communitySyncDone': 'Синхронизировано {wrote} новых питомцев (всего {total}).',
  'pet.communitySyncFailed': 'Ошибка синхронизации: {error}',
  'pet.codexBundled': 'Встроен',
  'pet.codexBundledTitle': 'Поставляется с Open Design — загрузка не нужна.',
  'settings.notifications': 'Уведомления',
  'settings.notificationsHint': 'Звук и уведомление при завершении задачи',
  'settings.notifyCompletionSound': 'Звук завершения',
  'settings.notifyCompletionSoundHint': 'Воспроизводится по завершении хода. По умолчанию выключено.',
  'settings.notifySuccessSound': 'Звук успеха',
  'settings.notifyFailureSound': 'Звук ошибки',
  'settings.notifyDesktop': 'Уведомление на рабочем столе',
  'settings.notifyDesktopHint': 'Отправляется, когда окно не активно.',
  'settings.notifyDesktopBlocked': 'Уведомления заблокированы браузером. Разрешите их в настройках сайта.',
  'settings.notifyDesktopUnsupported': 'Уведомления на рабочем столе недоступны в этой среде.',
  'settings.notifyTest': 'Отправить тест',
  'settings.notifyTestSent': 'Тестовое уведомление отправлено. Если баннер не появился, проверьте настройки уведомлений браузера и системы.',
  'settings.notifyTestFailed': 'Вызов уведомления не удался. Проверьте настройки уведомлений браузера и системы.',
  'settings.notifySoundDing': 'Динь',
  'settings.notifySoundChime': 'Колокольчик',
  'settings.notifySoundTwoToneUp': 'Двухтон вверх',
  'settings.notifySoundPluck': 'Щипок',
  'settings.notifySoundBuzz': 'Жужжание',
  'settings.notifySoundTwoToneDown': 'Двухтон вниз',
  'settings.notifySoundThud': 'Глухой удар',
  'settings.skills': 'Навыки',
  'settings.skillsHint': 'Функциональные навыки, которые агент может вызывать во время задачи',
  'settings.skillsNew': 'Новый навык',
  'settings.skillsEmpty': 'Выберите навык слева или создайте новый.',
  'settings.skillsEdit': 'Изменить',
  'settings.skillsDelete': 'Удалить',
  'settings.skillsDeleteConfirm': 'Подтвердить удаление',
  'settings.skillsName': 'Имя',
  'settings.skillsTriggers': 'Триггеры (через запятую или с новой строки)',
  'settings.skillsDescription': 'Описание',
  'settings.skillsBody': 'Содержимое SKILL.md',
  'settings.skillsCreate': 'Создать',
  'settings.skillsSave': 'Сохранить',
  'settings.skillsSaving': 'Сохранение…',
  'settings.skillsFiles': 'Файлы',
  'settings.skillsNoFiles': 'В папке этого навыка нет файлов.',
  'settings.skillsNameRequired': 'Имя навыка обязательно.',
  'settings.skillsBodyRequired': 'Содержимое навыка обязательно.',
  'settings.designSystems': 'Дизайн-системы',
  'settings.designSystemsHint': 'Просматривайте и переключайте доступные дизайн-системы',
  'settings.designSystemsInstalled': 'Установлено',
  'settings.designSystemsAdd': 'Добавить дизайн-систему',
  'settings.designSystemsHiddenCount': '{count} скрыто из домашней галереи',
  'settings.designSystemsShowAll': 'Показать все',
  'settings.designSystemsShowHidden': 'Показать скрытые',
  'settings.designSystemsSource': 'Источник',
  'settings.designSystemsSourceLocal': 'Локально',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Ссылка на реестр shadcn',
  'settings.designSystemsImportShadcn': 'Импортировать из shadcn',
  'settings.designSystemsStructure': 'Структура',
  'settings.designSystemsModeHybrid': 'Гибридно',
  'settings.designSystemsModeNormalized': 'Нормализовано',
  'settings.designSystemsModeVerbatim': 'Без изменений',
  'settings.designSystemsCraft': 'Мастерство',
  'settings.designSystemsCraftColor': 'Цвет',
  'settings.designSystemsCraftAccessibility': 'Доступность',
  'settings.designSystemsGithubUrl': 'URL GitHub',
  'settings.designSystemsProjectPath': 'Путь проекта',
  'settings.designSystemsImportGithub': 'Импортировать из GitHub',
  'settings.designSystemsImportProject': 'Импортировать из проекта',
  'settings.designSystemsImportedStatus': 'Импортировано: {title}',
  'settings.designSystemsViewImported': 'Открыть импортированную дизайн-систему',
  'settings.designSystemsCategory': 'Категория',
  'settings.designSystemsAllCategories': 'Все категории',
  'settings.designSystemsShowInHomeGallery': 'Показывать в домашней галерее',
  'settings.projectLocations': 'Расположения проектов',
  'settings.projectLocationsHint': 'Корни хранения рабочих пространств',
  'settings.projectLocationsDescription': 'Добавьте рабочие базы, которые могут содержать несколько папок проектов Open Design. Новые проекты сохраняются как папка внутри выбранной базы.',
  'settings.projectLocationsSaveError': 'Не удалось сохранить расположения проектов. Проверьте, что каждый путь является доступной папкой.',
  'settings.projectLocationsSaved': 'Расположения проектов сохранены.',
  'settings.projectLocationsScanError': 'Не удалось просканировать расположения проектов.',
  'settings.projectLocationsScanComplete': 'Сканирование завершено: импортировано {imported}, уже зарегистрировано {existing}.',
  'settings.projectLocationsNoFolderSelected': 'Папка не выбрана.',
  'settings.projectLocationsDuplicate': 'Эта рабочая база уже добавлена.',
  'settings.projectLocationsWorkBaseMeta': 'Рабочая база · проекты создаются здесь как подпапки',
  'settings.projectLocationsAddFolder': 'Добавить папку…',
  'settings.projectLocationsDefaultBadge': 'Расположение по умолчанию',
  'settings.projectLocationsMakeDefault': 'Сделать по умолчанию',
  'settings.projectLocationsDefaultSaved': 'Расположение проекта по умолчанию обновлено.',
  'settings.librarySkills': 'Навыки',
  'settings.libraryDesignSystems': 'Системы дизайна',
  'settings.librarySearch': 'Поиск...',
  'settings.libraryAll': 'Все',
  'settings.libraryPreview': 'Предпросмотр',
  'settings.libraryPreviewClose': 'Закрыть',
  'settings.libraryLoading': 'Загрузка...',
  'settings.libraryNoResults': 'Ничего не найдено по вашему запросу.',
  'settings.libraryEnabled': 'Включено',
  'settings.libraryDisabled': 'Отключено',
  'settings.connectorsNavHint': 'Подключения к внешним системам',
  'settings.connectorsHint': 'Управляйте настройками коннекторов и провайдеров инструментов для этого устройства.',
  'settings.connectorsComposioApiKey': 'API-ключ Composio',
  'settings.connectorsSavedTitle': 'Сохранено в локальном daemon',
  'settings.connectorsSavedWithTail': 'Сохранено · ••••{tail}',
  'settings.connectorsSaved': 'Сохранено',
  'settings.connectorsGetApiKey': 'Получить API-ключ',
  'settings.connectorsReplaceKeyPlaceholder': 'Вставьте новый ключ, чтобы заменить сохранённый',
  'settings.connectorsApiKeyPlaceholder': 'Вставьте API-ключ Composio',
  'settings.connectorsClear': 'Очистить',
  'settings.connectorsClearConfirmTitle': 'Очистить сохранённый ключ Composio API?',
  'settings.connectorsClearConfirmBody': 'Удаление ключа отключит все коннекторы Composio, привязанные к этому рабочему пространству. Подключённые аккаунты, разрешения OAuth и доступ к инструментам будут удалены.',
  'settings.connectorsClearConfirmContinue': 'Продолжить',
  'settings.connectorsClearFinalTitle': 'Это отключит все коннекторы',
  'settings.connectorsClearFinalBody': 'Отменить нельзя. После вставки нового ключа каждую интеграцию придётся подключать заново.',
  'settings.connectorsClearFinalConfirm': 'Удалить ключ и отключить',
  'settings.connectorsClearArming': 'Минуточку…',
  'settings.connectorsClearCancel': 'Отмена',
  'settings.connectorsSaveKey': 'Сохранить ключ',
  'settings.connectorsSaveKeyTitle': 'Отправить ключ локальному демону',
  'settings.connectorsKeySaving': 'Сохранение…',
  'settings.connectorsKeySaved': 'Сохранено ✓',
  'settings.connectorsKeyError': 'Не удалось сохранить ключ. Убедитесь, что локальный демон запущен, и попробуйте снова.',
  'settings.connectorsHelpSaved': 'Ваш ключ открывает каталог ниже и остаётся в локальном daemon. Вставьте новый ключ для замены или очистите, чтобы удалить.',
  'settings.connectorsHelpUnsaved': 'Несохранённые изменения — нажмите «Сохранить ключ», чтобы передать его локальному демону и открыть каталог ниже.',
  'settings.connectorsHelpEmpty': 'Добавьте ключ, чтобы открыть каталог ниже. Ключи хранятся локально в daemon и никогда не передаются через переменные окружения.',
  'settings.connectorsLoadingSavedKey': 'Проверка сохранённого ключа в локальном daemon…',
  'settings.autosaveSaving': 'Сохранение…',
  'settings.autosaveSaved': 'Все изменения сохранены',
  'settings.autosaveError': 'Не удалось сохранить изменения. Возможно, локальный демон не в сети.',
  'settings.libraryToggleLabel': 'Переключить',
  'settings.memory': 'Память',
  'settings.memoryHint': 'Личные факты, автоматически извлечённые из чатов',
  'settings.customInstructionsTitle': 'Глобальные правила',
  'settings.customInstructionsHint': 'Постоянные инструкции, которым Open Design должен следовать в каждом чате. Сохраняйте факты, предпочтения и контекст проекта в виде памяти.',
  'settings.customInstructionsPlaceholder': 'например, «Всегда используй TypeScript. Предпочитай функциональные компоненты. Делай ответы краткими.»',
  'settings.memoryDescription': 'Факты о ваших предпочтениях, автоматически извлечённые из чатов, сохранены как Markdown-файлы и подмешиваются в каждый новый чат.',
  'settings.memoryEnabled': 'Включено',
  'settings.memoryDisabled': 'Выключено',
  'settings.memoryEnableLabel': 'Включить вставку памяти',
  'settings.memoryDisabledBanner': 'Память сейчас выключена. Существующие факты сохраняются на диске, но не подмешиваются в новые чаты.',
  'settings.memoryNew': 'Новая запись',
  'settings.memoryEdit': 'Изменить',
  'settings.memoryDelete': 'Удалить',
  'settings.memoryPreview': 'Просмотр',
  'settings.memoryEmpty': 'Пока нет записей.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Я предпочитаю тёмную тему',
  'settings.memoryName': 'Название',
  'settings.memoryDesc': 'Однострочное описание',
  'settings.memoryBody': 'Содержимое (поддерживается Markdown)',
  'settings.memoryBodyHint': 'Сначала правило, затем строки Why и How to apply.',
  'settings.memoryStartersLabel': 'Нужна отправная точка? Нажмите, чтобы заполнить форму:',
  'settings.memoryStarterUserName': 'Моя роль',
  'settings.memoryStarterUserDesc': 'Я фронтенд-инженер, работаю над SaaS-инструментом для дизайна',
  'settings.memoryStarterUserBody': '- Роль: ведущий frontend-инженер\n- Стек: React, TypeScript, Vite\n- Область: инструменты для дизайна / совместной работы\n- Часовой пояс: GMT+8 (Asia/Shanghai)\n\nКогда применять: в любом чате — приводите примеры в контексте веб-фронтенда.',
  'settings.memoryStarterFeedbackName': 'Настройки интерфейса',
  'settings.memoryStarterFeedbackDesc': 'Тёмная тема, крупный основной текст, низкая плотность информации',
  'settings.memoryStarterFeedbackBody': '- Тема: тёмная по умолчанию\n- Основной текст: ≥ 18px\n- Плотность информации: предпочитайте свободное пространство, меньше элементов на экране\n\nПочему: меньше нагрузки на глаза во время долгих сессий.\nКогда применять: всякий раз, когда вы создаёте интерфейс, веб-страницы или слайды.',
  'settings.memoryStarterProjectName': 'Текущий проект',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — редактор дизайна с управлением через чат',
  'settings.memoryStarterProjectBody': '- Цель: выпустить редактор с управлением через чат в этом квартале\n- Приоритеты: потоковый рендеринг, локальная мультимодальность, offline-first\n- Стек: Next.js 16, демон Express, SQLite\n\nКогда применять: в любом разговоре об этом проекте.',
  'settings.memorySaveHint': 'Не сохраняется автоматически — нажмите «Создать» / «Сохранить», чтобы применить.',
  'settings.memoryIndexSaveHint': 'Изменения индекса не сохраняются автоматически — нажмите «Сохранить индекс», чтобы применить.',
  'settings.memoryIndexUnsaved': 'Несохранённые изменения',
  'settings.memoryFlashCreated': '✓ MEMORY.md создан',
  'settings.memoryFlashSaved': '✓ MEMORY.md сохранён',
  'settings.memoryFlashDeleted': '✓ MEMORY.md удалён',
  'settings.memoryFlashIndexSaved': '✓ Индекс сохранён',
  'settings.memoryFlashPathCopied': '✓ Путь скопирован',
  'settings.memoryNameLabel': 'Заголовок',
  'settings.memoryTypeLabel': 'Тип',
  'settings.memoryDescLabel': 'Описание',
  'settings.memoryBodyLabel': 'Содержимое',
  'settings.memoryTypeUser': 'Пользователь',
  'settings.memoryTypeFeedback': 'Отзыв',
  'settings.memoryTypeProject': 'Проект',
  'settings.memoryTypeReference': 'Ссылка',
  'settings.memoryIndex': 'MEMORY.md (индекс)',
  'settings.memoryIndexSave': 'Сохранить индекс',
  'settings.memoryIndexReset': 'Сбросить',
  'settings.memoryToastChanged': 'Память обновлена',
  'settings.memoryToastClickHint': 'Открыть',
  'settings.memoryAll': 'Все',
  'settings.memoryExtractions': 'История извлечений',
  'settings.memoryExtractionsHint': 'Сначала выполняется Regex, LLM работает в фоне.',
  'settings.memoryExtractionsEmpty': 'Извлечений пока нет. Список заполнится при следующем ответе в чате.',
  'settings.memoryExtractionsRefresh': 'Обновить',
  'settings.memoryExtractionsRefreshing': 'Обновление…',
  'settings.memoryExtractionPhaseRunning': 'Выполнение…',
  'settings.memoryExtractionPhaseSuccess': 'Успешно',
  'settings.memoryExtractionPhaseSkipped': 'Пропущено',
  'settings.memoryExtractionPhaseFailed': 'Не удалось',
  'settings.memoryExtractionSkipNoProvider': 'API key для извлечения памяти через LLM не настроен.',
  'settings.memoryExtractionSkipDisabled': 'Память отключена.',
  'settings.memoryExtractionSkipEmpty': 'Пустое сообщение пользователя — извлекать нечего.',
  'settings.memoryExtractionSkipNoMatch': 'В этом ответе не совпал ни один regex-шаблон.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'настройки медиа',
  'settings.memoryExtractionProviderOverride': 'настройки памяти',
  'settings.memoryExtractionProposed': 'предложено',
  'settings.memoryExtractionWritten': 'записано',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Удалить',
  'settings.memoryExtractionsClear': 'Очистить',
  'settings.memoryExtractionsClearTitle': 'Очистить всю историю извлечений',
  'settings.memoryExtractionsClearConfirm': 'Очистить всю историю извлечений? Это действие нельзя отменить.',
  'settings.memoryNoProviderBannerTitle': 'Извлечение памяти через LLM не выполняется',
  'settings.memoryNoProviderBannerBody': 'API key для извлечения памяти не найден. Добавьте ключ OpenAI в разделе «Media providers» или задайте ANTHROPIC_API_KEY / OPENAI_API_KEY в окружении, чтобы включить извлечение на базе LLM. Эвристическое извлечение через regex по-прежнему активно.',
  'settings.libraryInstall': 'Установить',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Локальный путь',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Установить',
  'settings.libraryUninstall': 'Удалить',
  'settings.libraryBuiltIn': 'Встроенный',
  'settings.libraryInstalled': 'Установлен',
  'notify.successTitle': 'Задача выполнена',
  'notify.failureTitle': 'Задача завершилась с ошибкой',
  'notify.successBody': 'Ход завершён.',
  'notify.failureBody': 'Задача завершилась с ошибкой.',
  'updater.available': 'Доступно обновление',
  'updater.availableBody': 'Open Design {version} доступен. Он будет загружен перед открытием установщика.',
  'updater.checking': 'Проверка обновлений',
  'updater.download': 'Скачать обновление',
  'updater.downloading': 'Загрузка обновления',
  'updater.downloadingPercent': 'Загрузка обновления {percent}%',
  'updater.done': 'Готово',
  'updater.failed': 'Обновление не удалось',
  'updater.installerOpenBody': 'Установщик открыт. Open Design закрывается, чтобы вы могли завершить обновление.',
  'updater.installerOpened': 'Установщик открыт',
  'updater.later': 'Позже',
  'updater.openFailedFallback': 'Не удалось открыть установщик.',
  'updater.installRestart': 'Install and restart',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Установить обновление',
  'updater.opening': 'Открытие установщика...',
  'updater.payloadReadyGeneric': 'A new Open Design update is ready. Open Design will close and restart automatically.',
  'updater.payloadReadyVersion': 'Open Design {version} is ready. Open Design will close and restart automatically.',
  'updater.quitButton': 'Закрыть Open Design',
  'updater.quitFailedBody': 'Установщик открыт, но Open Design не удалось закрыть. Закройте Open Design перед заменой приложения.',
  'updater.quitFailedTitle': 'Не удалось закрыть',
  'updater.quitting': 'Закрытие...',
  'updater.ready': 'Обновление готово',
  'updater.readyGeneric': 'Новая версия готова. Open Design закроется и откроет установщик.',
  'updater.readyVersion': 'Open Design {version} готов. Open Design закроется и откроет установщик.',
  'updater.upToDate': 'У вас уже установлена последняя версия.',
  'newsletter.label': 'Рассылка (необязательно)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'Автоматизация',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Ежедневная сводка коннекторов',
  'settings.orbit.lede': 'Собирать активность коннекторов по расписанию и публиковать результат как обновляемый live artifact.',
  'settings.orbit.statusOnTitle': 'Ежедневные запуски по расписанию включены',
  'settings.orbit.statusOffTitle': 'Ежедневные запуски по расписанию выключены',
  'settings.orbit.statusActive': 'Активно',
  'settings.orbit.statusOff': 'Выкл.',
  'settings.orbit.runTitle': 'Запустить Orbit и открыть живой диалог',
  'settings.orbit.running': 'Выполняется…',
  'settings.orbit.runOpen': 'Запустить сейчас',
  'settings.orbit.dailySummaryTitle': 'Ежедневная сводка',
  'settings.orbit.dailySummarySub': 'Выполняется раз в день в назначенное локальное время.',
  'settings.orbit.on': 'Вкл.',
  'settings.orbit.off': 'Выкл.',
  'settings.orbit.runTimeTitle': 'Время запуска',
  'settings.orbit.runTimeSub': 'По умолчанию 08:00. Сохраните, чтобы применить расписание daemon.',
  'settings.orbit.runTimeAria': 'Время ежедневного запуска Orbit',
  'settings.orbit.nextRun': 'Следующий запуск',
  'settings.orbit.nextRunScheduledAfterSave': 'Будет запланировано после сохранения',
  'settings.orbit.schedule': 'Расписание',
  'settings.orbit.pausedManualOnly': 'Пауза — только ручные запуски',
  'settings.orbit.templateTitle': 'Шаблон prompt',
  'settings.orbit.templateMissing': 'Шаблон {id} не установлен.',
  'settings.orbit.templateMissingOption': '{id} (отсутствует)',
  'settings.orbit.templateMissingInstall': 'Установите skill Orbit, чтобы направлять prompt.',
  'settings.orbit.templateMissingPickAnother': 'Выберите другой шаблон в списке.',
  'settings.orbit.templateResetTitle': 'Сбросить на {id}',
  'settings.orbit.templateReset': 'Сбросить',
  'settings.orbit.templateHelp': 'Направляйте Orbit с помощью skill — пример prompt выбранного шаблона добавляется в каждый запуск Orbit, чтобы сводки следовали этой форме.',
  'settings.orbit.templateAria': 'Шаблон prompt Orbit',
  'settings.orbit.templatesLoading': 'Загрузка шаблонов…',
  'settings.orbit.templatesOptgroup': 'Шаблоны skills Orbit',
  'settings.orbit.lastRun': 'Последний запуск',
  'settings.orbit.triggerManual': 'Вручную',
  'settings.orbit.triggerScheduled': 'По расписанию',
  'settings.orbit.meterAria': '{succeeded} успешно, {skipped} пропущено, {failed} с ошибкой из {checked} проверено',
  'settings.orbit.countChecked': 'Проверено',
  'settings.orbit.countSucceeded': 'Успешно',
  'settings.orbit.countSkipped': 'Пропущено',
  'settings.orbit.countFailed': 'С ошибкой',
  'settings.orbit.runError': 'Не удалось запустить Orbit. Убедитесь, что локальный daemon запущен, а коннекторы настроены.',
  'settings.orbit.gateAriaLabel': 'Для работы Orbit нужны коннекторы',
  'settings.orbit.gateEyebrow': 'Требуется настройка',
  'settings.orbit.gateTitle': 'Подключите инструмент для работы Orbit',
  'settings.orbit.gateBody': 'Orbit обобщает активность ваших коннекторов. Вы ещё ничего не подключили — добавьте хотя бы одну интеграцию, чтобы Orbit мог о чём-то сообщить.',
  'settings.orbit.gateBodyNoKey': 'Orbit обобщает активность коннекторов, а коннекторы работают через Composio. Добавьте ключ API Composio в разделе «Коннекторы», чтобы открыть каталог и выбрать первую интеграцию.',
  'settings.orbit.gateAction': 'Открыть коннекторы',
  'settings.orbit.gateActionNoKey': 'Настроить Composio',
  'settings.orbit.gateLoading': 'Проверка коннекторов…',
  'settings.orbit.controlsLockedBadge': 'Заблокировано',
  'settings.orbit.controlsLockedHint': 'Подключите инструмент, чтобы разблокировать расписание и шаблон Orbit.',
  'settings.orbit.artifactKickerLive': 'живой артефакт',
  'settings.orbit.artifactKickerLegacy': 'Устаревшая сводка',
  'settings.orbit.artifactTitle': 'Ежедневная сводка активности Orbit',
  'settings.orbit.artifactMetaLive': 'Обновляемый HTML-артефакт, созданный из активности коннекторов.',
  'settings.orbit.artifactMetaLegacy': 'Создано до включения поддержки live artifact — запустите Orbit снова, чтобы опубликовать один.',
  'settings.orbit.copyMarkdownTitle': 'Скопировать сводку Markdown в буфер обмена',
  'settings.orbit.copied': 'Скопировано',
  'settings.orbit.copy': 'Копировать',
  'settings.orbit.openArtifact': 'Открыть артефакт',
  'settings.orbit.sourceMarkdown': 'Исходный Markdown',
  'settings.memoryModelInlineHintByokNeutral': 'Память использует отдельную от чата модель. По умолчанию — ваша модель чата.',
  'diagnostics.exportTitle': 'Экспорт диагностики',
  'diagnostics.exportButton': 'Экспорт диагностики',
  'diagnostics.exportHint': 'Упаковывает недавние журналы приложения и сведения о машине в zip для отправки команде.',
  'diagnostics.exporting': 'Экспортирование…',
  'diagnostics.exportSuccess': 'Диагностика сохранена: {path}',
  'diagnostics.exportFailed': 'Не удалось экспортировать диагностику: {message}',
  'automations.eyebrow': 'Запланированные сессии Agent',
  'automations.title': 'Автоматизации',
  'automations.lede': 'Планируйте повторяющиеся беседы для работы над проектами, дайджестов Orbit и живых артефактов.',
  'automations.summaryAria': 'Сводка по автоматизациям',
  'automations.metricActive': 'Активные',
  'automations.metricPaused': 'Приостановленные',
  'automations.metricTemplates': 'Шаблоны',
  'automations.newAutomation': 'Новая автоматизация',
  'automations.yourAutomations': 'Ваши автоматизации',
  'automations.loading': 'Загрузка',
  'automations.emptyTitle': 'Автоматизаций пока нет',
  'automations.emptyBody': 'Создайте автоматизацию из шаблона или начните с пустого расписания.',
  'automations.targetNewEachRun': 'Новый проект при каждом запуске',
  'automations.lastRun': 'Последний запуск {time}',
  'automations.openResult': 'Открыть результат',
  'automations.run': 'Запустить',
  'automations.runNowTitle': 'Запустить сейчас и открыть беседу',
  'automations.history': 'История',
  'automations.hideHistory': 'Скрыть историю',
  'automations.edit': 'Изменить',
  'automations.pause': 'Приостановить',
  'automations.resume': 'Возобновить',
  'automations.deleteAria': 'Удалить автоматизацию',
  'automations.deleteTitle': 'Удалить эту автоматизацию',
  'automations.deleteConfirm': 'Удалить эту автоматизацию? Прошлые запуски и их проекты сохранятся.',
  'automations.proposalsTitle': 'Предложения по развитию',
  'automations.proposalsSub': 'Просмотрите результаты автоматизации, прежде чем они изменят память, навыки или дизайн-системы.',
  'automations.proposalsPending': '{n} в ожидании',
  'automations.apply': 'Применить',
  'automations.reject': 'Отклонить',
  'automations.proposalsDismissReason': 'Отклонено в Автоматизациях',
  'automations.templatesTitle': 'Шаблоны',
  'automations.templatesSub': 'Orbit и живые артефакты — это шаблоны в рамках того же процесса автоматизации.',
  'automations.templatesCount': '{filtered} из {total}',
  'automations.templateFiltersAria': 'Фильтры шаблонов',
  'automations.templatesEmptyTitle': 'В этой категории пока нет шаблонов.',
  'automations.templatesEmptyBody': 'Попробуйте другой фильтр или начните с пустой автоматизации.',
  'automations.useTemplate': 'Использовать шаблон',
  'automations.runHistoryLoading': 'Загрузка истории запусков...',
  'automations.runHistoryEmpty': 'Запусков пока нет.',
  'automations.runHistoryTitle': 'История запусков',
  'automations.runHistoryLatest': 'Последние 10',
  'automations.crystallize': 'Кристаллизовать',
  'automations.crystallizing': 'Кристаллизация',
  'automations.crystallizeTitle': 'Создать черновики предложений по навыкам и памяти из этого запуска',
  'automations.openConversation': 'Открыть беседу',
  'automations.runHistoryAria': 'История запусков автоматизации',
  'automations.proposalsAria': 'Предложения по развитию автоматизации',
  'automations.templatesAria': 'Шаблоны автоматизаций',
  'automations.runInProgress': 'Выполняется',
  'automations.scheduleStatusPaused': 'Приостановлено',
  'automations.nextRunManualOnly': 'Только вручную',
  'automations.nextRunScheduled': 'По расписанию',
  'automations.nextRunAt': 'Следующий {time}',
  'automations.statusSucceeded': 'Успешно',
  'automations.statusFailed': 'Ошибка',
  'automations.statusRunning': 'Выполняется',
  'automations.statusQueued': 'В очереди',
  'automations.statusCanceled': 'Отменено',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Живой артефакт',
  'automations.kindAutomation': 'Автоматизация',
  'automations.proposalTargetMemory': 'Память',
  'automations.proposalTargetDesignSystem': 'Дизайн-система',
  'automations.proposalTargetSkill': 'Навык',
  'automations.proposalTargetTemplate': 'Шаблон автоматизации',
  'automations.proposalActionCreate': 'Создать',
  'automations.proposalActionUpdate': 'Обновить',
  'automations.proposalActionMerge': 'Объединить',
  'automations.proposalActionMove': 'Переместить',
  'automations.proposalActionDelete': 'Удалить',
  'automations.proposalActionPromote': 'Повысить',
  'automations.filterAll': 'Все',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Живые артефакты',
  'automations.filterMemory': 'Память',
  'automations.filterDesignSystems': 'Дизайн-системы',
  'automations.filterSkills': 'Навыки',
  'automations.filterConnectors': 'Коннекторы',
  'automations.filterCompression': 'Сжатие',
  'automations.filterRelease': 'Релиз',
  'automations.filterQuality': 'Качество',
  'automations.tpl.memoryRefresh.title': 'Обновить память проекта на основе недавней работы.',
  'automations.tpl.memoryRefresh.desc': 'Превращает повторяющиеся решения, предпочтения и отзывы в многократно используемые обновления памяти.',
  'automations.tpl.designSystemRefresh.title': 'Обновить дизайн-системы на основе выпущенных артефактов.',
  'automations.tpl.designSystemRefresh.desc': 'Находит переиспользуемые токены, компоненты и правила в недавней дизайн-работе.',
  'automations.tpl.liveArtifactRegistry.title': 'Проверить живые артефакты и обновить устаревшие версии.',
  'automations.tpl.liveArtifactRegistry.desc': 'Поддерживает актуальность постоянных дашбордов, отчётов и превью вместо их дублирования.',
  'automations.tpl.orbitDashboard.title': 'Создать дашборд активности коннекторов.',
  'automations.tpl.orbitDashboard.desc': 'Объединяет выбранные коннекторы в живой дашборд в стиле Orbit.',
  'automations.tpl.releaseNotes.title': 'Составить заметки о релизе на основе выпущенной дизайн-работы.',
  'automations.tpl.releaseNotes.desc': 'Связывает объединённые PR, артефакты и видимые пользователю изменения в заметки о релизе.',
  'automations.tpl.qualityRegressionWatch.title': 'Отслеживать регрессии в дизайне и реализации.',
  'automations.tpl.qualityRegressionWatch.desc': 'Сравнивает недавние изменения с эталонами, трассировками и принятыми образцами.',
  'automations.tpl.orbitDaily.title': 'Ежедневный дайджест коннекторов.',
  'automations.tpl.orbitDaily.desc': 'Обновляет дайджест активности коннекторов по расписанию.',
  'automations.tpl.liveStatusBoard.title': 'Поддерживать актуальность живого артефакта статуса.',
  'automations.tpl.liveStatusBoard.desc': 'Обновляет один постоянный артефакт вместо создания нового отчёта при каждом запуске.',
  'dsManager.areaAria': 'Раздел дизайн-систем',
  'dsManager.tabDesignSystem': 'Дизайн-система',
  'dsManager.tabTemplate': 'Шаблон',
  'dsManager.sourceAria': 'Источник дизайн-системы',
  'dsManager.templateSourceAria': 'Источник шаблона',
  'dsManager.yourSystems': 'Ваши системы',
  'dsManager.officialPresets': 'Официальные пресеты',
  'dsManager.enterprise': 'Корпоративные',
  'dsManager.yourTemplates': 'Ваши шаблоны',
  'dsManager.yourSystemsAria': 'Ваши дизайн-системы',
  'dsManager.eyebrowDesignSystems': 'Дизайн-системы',
  'dsManager.yourSystemsHeading': 'Ваши системы',
  'dsManager.filterAria': 'Фильтровать дизайн-системы',
  'dsManager.filterAll': 'Все',
  'dsManager.filterPublished': 'Опубликованные',
  'dsManager.filterDraft': 'Черновик',
  'dsManager.createTitle': 'Создать новую дизайн-систему',
  'dsManager.createBody': 'Обучите Open Design вашему бренду, продукту, коду, ресурсам и дизайн-референсам.',
  'dsManager.createAction': 'Создать',
  'dsManager.emptyMine': 'Дизайн-систем пока нет. Создайте систему из реального контекста продукта, проверьте черновик и опубликуйте её для будущих проектов.',
  'dsManager.badgeDefault': 'По умолчанию',
  'dsManager.rowMetaUpdated': 'Вы · обновлено {date}',
  'dsManager.edit': 'Изменить',
  'dsManager.makeDefault': 'Сделать по умолчанию',
  'dsManager.statusPublished': 'Опубликовано',
  'dsManager.statusDraft': 'Черновик',
  'dsManager.openSystemAria': 'Открыть {title}',
  'dsManager.deleteSystemAria': 'Удалить {title}',
  'dsManager.presetsAria': 'Официальные пресеты дизайн-систем',
  'dsManager.eyebrowLibrary': 'Библиотека',
  'dsManager.eyebrowTemplates': 'Шаблоны',
  'dsManager.yourTemplatesAria': 'Ваши шаблоны',
  'dsManager.emptyTemplates': 'Шаблонов пока нет. Создайте шаблон из любого сгенерированного проекта через «Поделиться», когда публикация шаблонов будет включена.',
  'dsManager.templateDescFallback': 'Создано из проекта',
  'dsManager.comingSoonBadge': 'Скоро',
  'dsManager.enterpriseDsTitle': 'Корпоративные дизайн-системы',
  'dsManager.enterpriseDsBody': 'Общие командные дизайн-системы и управляемые библиотеки бренда появятся скоро.',
  'dsManager.enterpriseTplTitle': 'Корпоративные шаблоны',
  'dsManager.enterpriseTplBody': 'Утверждённые командой шаблоны и публикация в масштабах организации появятся скоро.',
  'settings.instructionsTitle': 'Инструкции / Правила',
  'settings.instructionsSubtitle': 'Фиксированное поведение, которому должен следовать ассистент',
  'settings.instructionsNavSub': 'Фиксированное поведение ассистента',
  'settings.customInstructionsDesc': 'Фиксированные инструкции, которым Open Design следует в каждом чате. Это не сохранённые воспоминания; используйте Память для фактов, предпочтений и контекста проекта.',
  'mcpClient.forwardedToLabel': 'Перенаправляется в:',
  'mcpClient.notForwardedToLabel': 'Не перенаправляется в:',
  'mcpClient.forwardedAcpNote': 'Адаптеры ACP, помеченные как stdio, получают из этого списка только серверы stdio MCP; записи HTTP и SSE отбрасываются при запуске.',
  'mcpClient.notForwardedNote': 'Для этих Agent настройте серверы MCP в собственном файле конфигурации агента (например, ~/.codex/config.toml, ~/.gemini/settings.json); указанные ниже серверы там молча не используются.',
};
